/**
 * Public Domain Drawing Compendium
 * Auto-generated by scrape-public-domain-drawings.ts
 * Generated: 2026-01-28T00:06:19.364Z
 *
 * All works are in the public domain (artists died before 1954).
 * Sources: Wikimedia Commons
 */

export interface DrawingSource {
  title: string;
  artist: string;
  url: string;
  thumbUrl: string;
  width: number;
  height: number;
}

export interface ArtistCollection {
  artist: string;
  deathYear: number;
  publicDomainStatus: string;
  works: DrawingSource[];
}

export const MICHELANGELO_DRAWINGS: ArtistCollection = {
  artist: "Michelangelo",
  deathYear: 1564,
  publicDomainStatus: "Public domain - artist died 1564 (>462 years ago)",
  works: [
  ],
};

export const LEONARDO_DA_VINCI_DRAWINGS: ArtistCollection = {
  artist: "Leonardo da Vinci",
  deathYear: 1519,
  publicDomainStatus: "Public domain - artist died 1519 (>507 years ago)",
  works: [
    {
      title: "L'Adoration des mages RIR 1.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7d/L%27Adoration_des_mages_RIR_1.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/7d/L%27Adoration_des_mages_RIR_1.jpg",
      width: 663,
      height: 419,
    },
    {
      title: "Fig. 40 Leonardo da Vinci the anatomist from McMurrich Wellcome M0010882.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e9/Fig._40_Leonardo_da_Vinci_the_anatomist_from_McMurrich_Wellcome_M0010882.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Fig._40_Leonardo_da_Vinci_the_anatomist_from_McMurrich_Wellcome_M0010882.jpg/1280px-Fig._40_Leonardo_da_Vinci_the_anatomist_from_McMurrich_Wellcome_M0010882.jpg",
      width: 3186,
      height: 3396,
    },
    {
      title: "Figure 41\"Leonardo da Vinci the anatomist\" from McMurrich Wellcome M0010883.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1a/Figure_41%22Leonardo_da_Vinci_the_anatomist%22_from_McMurrich_Wellcome_M0010883.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Figure_41%22Leonardo_da_Vinci_the_anatomist%22_from_McMurrich_Wellcome_M0010883.jpg/1280px-Figure_41%22Leonardo_da_Vinci_the_anatomist%22_from_McMurrich_Wellcome_M0010883.jpg",
      width: 2757,
      height: 3918,
    },
    {
      title: "Fig. 55 \"Leonardo da Vinci the anatomist\" from McMurrich Wellcome M0010885.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Fig._55_%22Leonardo_da_Vinci_the_anatomist%22_from_McMurrich_Wellcome_M0010885.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Fig._55_%22Leonardo_da_Vinci_the_anatomist%22_from_McMurrich_Wellcome_M0010885.jpg/1280px-Fig._55_%22Leonardo_da_Vinci_the_anatomist%22_from_McMurrich_Wellcome_M0010885.jpg",
      width: 2479,
      height: 4429,
    },
    {
      title: "Le Grand Oeuvre de Leonardo - La Tentation + Scène infernale.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Le_Grand_Oeuvre_de_Leonardo_-_La_Tentation_%2B_Sc%C3%A8ne_infernale.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Le_Grand_Oeuvre_de_Leonardo_-_La_Tentation_%2B_Sc%C3%A8ne_infernale.jpg/1280px-Le_Grand_Oeuvre_de_Leonardo_-_La_Tentation_%2B_Sc%C3%A8ne_infernale.jpg",
      width: 1709,
      height: 1187,
    },
    {
      title: "Davinci afbeelding.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Davinci_afbeelding.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Davinci_afbeelding.jpg",
      width: 591,
      height: 472,
    },
    {
      title: "Copy of DaVinci drawing.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/03/Copy_of_DaVinci_drawing.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Copy_of_DaVinci_drawing.jpg/1280px-Copy_of_DaVinci_drawing.jpg",
      width: 1970,
      height: 500,
    },
    {
      title: "Andrea del verrocchio e leonardo da vinci, venere e cupido, 1474 ca. (gdsu).jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b7/Andrea_del_verrocchio_e_leonardo_da_vinci%2C_venere_e_cupido%2C_1474_ca._%28gdsu%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Andrea_del_verrocchio_e_leonardo_da_vinci%2C_venere_e_cupido%2C_1474_ca._%28gdsu%29.jpg/1280px-Andrea_del_verrocchio_e_leonardo_da_vinci%2C_venere_e_cupido%2C_1474_ca._%28gdsu%29.jpg",
      width: 4680,
      height: 2892,
    },
    {
      title: "Unknown, 16th century - Study for the head of a woman, ca. 1510, 6954.png",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7a/Unknown%2C_16th_century_-_Study_for_the_head_of_a_woman%2C_ca._1510%2C_6954.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Unknown%2C_16th_century_-_Study_for_the_head_of_a_woman%2C_ca._1510%2C_6954.png/1280px-Unknown%2C_16th_century_-_Study_for_the_head_of_a_woman%2C_ca._1510%2C_6954.png",
      width: 5735,
      height: 4204,
    },
    {
      title: "Leonardo da Vinci - Studies for Saint Mary Magdalene, Circa 1480-82, D.1978.PG.80.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/39/Leonardo_da_Vinci_-_Studies_for_Saint_Mary_Magdalene%2C_Circa_1480-82%2C_D.1978.PG.80.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/39/Leonardo_da_Vinci_-_Studies_for_Saint_Mary_Magdalene%2C_Circa_1480-82%2C_D.1978.PG.80.jpg",
      width: 413,
      height: 700,
    },
    {
      title: "Leonardo Da Vinci Studi di Anamorfosi Occhio Bambino dal CodiceAtlantico RIO.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1c/Leonardo_Da_Vinci_Studi_di_Anamorfosi_Occhio_Bambino_dal_CodiceAtlantico_RIO.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Leonardo_Da_Vinci_Studi_di_Anamorfosi_Occhio_Bambino_dal_CodiceAtlantico_RIO.jpg/1280px-Leonardo_Da_Vinci_Studi_di_Anamorfosi_Occhio_Bambino_dal_CodiceAtlantico_RIO.jpg",
      width: 2044,
      height: 924,
    },
    {
      title: "Leonardo da vinci chiesa.png",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/37/Leonardo_da_vinci_chiesa.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/37/Leonardo_da_vinci_chiesa.png",
      width: 568,
      height: 797,
    },
    {
      title: "Disegni per la Leda di Leonardo da Vinci.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/05/Disegni_per_la_Leda_di_Leonardo_da_Vinci.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Disegni_per_la_Leda_di_Leonardo_da_Vinci.jpg/1280px-Disegni_per_la_Leda_di_Leonardo_da_Vinci.jpg",
      width: 6100,
      height: 7000,
    },
    {
      title: "Codice Atlantico folio 21 recto.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/53/Codice_Atlantico_folio_21_recto.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/5/53/Codice_Atlantico_folio_21_recto.jpg",
      width: 460,
      height: 600,
    },
    {
      title: "Provinciale Noordbrabantsche en 's-Hertogenbossche Courant 1927 no 089 Leonardo da Vinci Caricaturen.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/06/Provinciale_Noordbrabantsche_en_%27s-Hertogenbossche_Courant_1927_no_089_Leonardo_da_Vinci_Caricaturen.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Provinciale_Noordbrabantsche_en_%27s-Hertogenbossche_Courant_1927_no_089_Leonardo_da_Vinci_Caricaturen.jpg/1280px-Provinciale_Noordbrabantsche_en_%27s-Hertogenbossche_Courant_1927_no_089_Leonardo_da_Vinci_Caricaturen.jpg",
      width: 1397,
      height: 1751,
    },
    {
      title: "Leonardo insects drawings.jpg",
      artist: "Leonardo da Vinci",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/30/Leonardo_insects_drawings.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/30/Leonardo_insects_drawings.jpg",
      width: 650,
      height: 716,
    },
  ],
};

export const ALBRECHT_D_RER_DRAWINGS: ArtistCollection = {
  artist: "Albrecht Dürer",
  deathYear: 1528,
  publicDomainStatus: "Public domain - artist died 1528 (>498 years ago)",
  works: [
    {
      title: "Dürer skizze karl der grosse.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/09/D%C3%BCrer_skizze_karl_der_grosse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/0/09/D%C3%BCrer_skizze_karl_der_grosse.jpg",
      width: 791,
      height: 1160,
    },
    {
      title: "S381 Albrecht Dürer 1496 Spazierritt.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cd/S381_Albrecht_D%C3%BCrer_1496_Spazierritt.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/S381_Albrecht_D%C3%BCrer_1496_Spazierritt.jpg/1280px-S381_Albrecht_D%C3%BCrer_1496_Spazierritt.jpg",
      width: 1431,
      height: 1854,
    },
    {
      title: "ADurerAugerBayonne.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d8/ADurerAugerBayonne.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d8/ADurerAugerBayonne.jpg",
      width: 650,
      height: 1074,
    },
    {
      title: "Triumphwagen1.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d3/Triumphwagen1.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d3/Triumphwagen1.jpg",
      width: 1000,
      height: 495,
    },
    {
      title: "AlbrechtDürer-TheErlingenSiameseTwins(1512).jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ee/AlbrechtD%C3%BCrer-TheErlingenSiameseTwins%281512%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/ee/AlbrechtD%C3%BCrer-TheErlingenSiameseTwins%281512%29.jpg",
      width: 821,
      height: 617,
    },
    {
      title: "Albrecht Dürer Lüsterweibchen 1.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/87/Albrecht_D%C3%BCrer_L%C3%BCsterweibchen_1.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/87/Albrecht_D%C3%BCrer_L%C3%BCsterweibchen_1.jpg",
      width: 561,
      height: 506,
    },
    {
      title: "Albrecht Dürer Lüsterweibchen 2.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b7/Albrecht_D%C3%BCrer_L%C3%BCsterweibchen_2.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/b/b7/Albrecht_D%C3%BCrer_L%C3%BCsterweibchen_2.jpg",
      width: 1027,
      height: 802,
    },
    {
      title: "Dürer - Das Liebspaar.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4b/D%C3%BCrer_-_Das_Liebspaar.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4b/D%C3%BCrer_-_Das_Liebspaar.jpg",
      width: 576,
      height: 786,
    },
    {
      title: "Dürer - Reiter vom Tod überfallen.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ee/D%C3%BCrer_-_Reiter_vom_Tod_%C3%BCberfallen.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/ee/D%C3%BCrer_-_Reiter_vom_Tod_%C3%BCberfallen.jpg",
      width: 626,
      height: 914,
    },
    {
      title: "Dürer - Junges Paar zu Pferde.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/44/D%C3%BCrer_-_Junges_Paar_zu_Pferde.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/D%C3%BCrer_-_Junges_Paar_zu_Pferde.jpg/1248px-D%C3%BCrer_-_Junges_Paar_zu_Pferde.jpg",
      width: 1248,
      height: 1627,
    },
    {
      title: "Sammlung Ludwig - Artefakt und Naturwunder-Veit Stoß-Drachenleuchter- Entwurf Dürer80327.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/89/Sammlung_Ludwig_-_Artefakt_und_Naturwunder-Veit_Sto%C3%9F-Drachenleuchter-_Entwurf_D%C3%BCrer80327.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/Sammlung_Ludwig_-_Artefakt_und_Naturwunder-Veit_Sto%C3%9F-Drachenleuchter-_Entwurf_D%C3%BCrer80327.jpg/1280px-Sammlung_Ludwig_-_Artefakt_und_Naturwunder-Veit_Sto%C3%9F-Drachenleuchter-_Entwurf_D%C3%BCrer80327.jpg",
      width: 2613,
      height: 2580,
    },
    {
      title: "Durer Bookplate of Willibald Pirckheimer.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c5/Durer_Bookplate_of_Willibald_Pirckheimer.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c5/Durer_Bookplate_of_Willibald_Pirckheimer.jpg",
      width: 600,
      height: 886,
    },
    {
      title: "Albrecht Dürer - Six Goblets - WGA07081.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/fc/Albrecht_D%C3%BCrer_-_Six_Goblets_-_WGA07081.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/f/fc/Albrecht_D%C3%BCrer_-_Six_Goblets_-_WGA07081.jpg",
      width: 801,
      height: 613,
    },
    {
      title: "Albrecht Dürer - Study of Drapery - WGA07064.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c5/Albrecht_D%C3%BCrer_-_Study_of_Drapery_-_WGA07064.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c5/Albrecht_D%C3%BCrer_-_Study_of_Drapery_-_WGA07064.jpg",
      width: 605,
      height: 1036,
    },
    {
      title: "Albrecht Dürer - Cupid the Honey Thief - WGA07372.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ad/Albrecht_D%C3%BCrer_-_Cupid_the_Honey_Thief_-_WGA07372.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/ad/Albrecht_D%C3%BCrer_-_Cupid_the_Honey_Thief_-_WGA07372.jpg",
      width: 1030,
      height: 704,
    },
    {
      title: "Dragon Duerer.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Dragon_Duerer.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Dragon_Duerer.jpg",
      width: 1003,
      height: 552,
    },
    {
      title: "Pupila-augusta-master-sb-1490s.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/88/Pupila-augusta-master-sb-1490s.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/88/Pupila-augusta-master-sb-1490s.jpg",
      width: 1200,
      height: 710,
    },
    {
      title: "Dürer-pleasures-of-the-world-1490s.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/ce/D%C3%BCrer-pleasures-of-the-world-1490s.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/D%C3%BCrer-pleasures-of-the-world-1490s.jpg/1280px-D%C3%BCrer-pleasures-of-the-world-1490s.jpg",
      width: 2709,
      height: 1715,
    },
    {
      title: "Dürer-death-at-society's-table-1490s.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/8c/D%C3%BCrer-death-at-society%27s-table-1490s.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8c/D%C3%BCrer-death-at-society%27s-table-1490s.jpg/1280px-D%C3%BCrer-death-at-society%27s-table-1490s.jpg",
      width: 2502,
      height: 2507,
    },
    {
      title: "Dürer, Albrecht Der große Triumphwagen, Detail Die ungarische Trophäe.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/af/D%C3%BCrer%2C_Albrecht_Der_gro%C3%9Fe_Triumphwagen%2C_Detail_Die_ungarische_Troph%C3%A4e.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/D%C3%BCrer%2C_Albrecht_Der_gro%C3%9Fe_Triumphwagen%2C_Detail_Die_ungarische_Troph%C3%A4e.jpg/1280px-D%C3%BCrer%2C_Albrecht_Der_gro%C3%9Fe_Triumphwagen%2C_Detail_Die_ungarische_Troph%C3%A4e.jpg",
      width: 1956,
      height: 3000,
    },
    {
      title: "Durer letter emoticon 1506.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3e/Durer_letter_emoticon_1506.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/3e/Durer_letter_emoticon_1506.jpg",
      width: 948,
      height: 474,
    },
    {
      title: "Albrecht Dürer - Design for Decoration of the Town Hall of Nuremberg.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/73/Albrecht_D%C3%BCrer_-_Design_for_Decoration_of_the_Town_Hall_of_Nuremberg.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Albrecht_D%C3%BCrer_-_Design_for_Decoration_of_the_Town_Hall_of_Nuremberg.jpg/1280px-Albrecht_D%C3%BCrer_-_Design_for_Decoration_of_the_Town_Hall_of_Nuremberg.jpg",
      width: 2170,
      height: 1585,
    },
    {
      title: "Dürer's dream.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/13/D%C3%BCrer%27s_dream.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/D%C3%BCrer%27s_dream.jpg/1280px-D%C3%BCrer%27s_dream.jpg",
      width: 1780,
      height: 1334,
    },
    {
      title: "Gravure de Dürer montrant un démon emportant une femme nue - Archives nationales (France).jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Gravure_de_D%C3%BCrer_montrant_un_d%C3%A9mon_emportant_une_femme_nue_-_Archives_nationales_%28France%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Gravure_de_D%C3%BCrer_montrant_un_d%C3%A9mon_emportant_une_femme_nue_-_Archives_nationales_%28France%29.jpg",
      width: 860,
      height: 1238,
    },
    {
      title: "Albrecht Dürer - Phyllis and Aristotle, detail of Nuremberg Town Hall design.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Albrecht_D%C3%BCrer_-_Phyllis_and_Aristotle%2C_detail_of_Nuremberg_Town_Hall_design.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Albrecht_D%C3%BCrer_-_Phyllis_and_Aristotle%2C_detail_of_Nuremberg_Town_Hall_design.jpg",
      width: 523,
      height: 551,
    },
    {
      title: "Galeriewerk Woermann Mappe 02 02.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6c/Galeriewerk_Woermann_Mappe_02_02.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Galeriewerk_Woermann_Mappe_02_02.jpg/1280px-Galeriewerk_Woermann_Mappe_02_02.jpg",
      width: 5020,
      height: 6199,
    },
    {
      title: "Galeriewerk Woermann Mappe 02 03.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/11/Galeriewerk_Woermann_Mappe_02_03.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Galeriewerk_Woermann_Mappe_02_03.jpg/1280px-Galeriewerk_Woermann_Mappe_02_03.jpg",
      width: 7459,
      height: 9000,
    },
    {
      title: "Galeriewerk Woermann Mappe 02 04.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/17/Galeriewerk_Woermann_Mappe_02_04.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Galeriewerk_Woermann_Mappe_02_04.jpg/1280px-Galeriewerk_Woermann_Mappe_02_04.jpg",
      width: 4800,
      height: 6459,
    },
    {
      title: "Galeriewerk Woermann Mappe 02 05.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/bb/Galeriewerk_Woermann_Mappe_02_05.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Galeriewerk_Woermann_Mappe_02_05.jpg/1280px-Galeriewerk_Woermann_Mappe_02_05.jpg",
      width: 4500,
      height: 6280,
    },
    {
      title: "Galeriewerk Woermann Mappe 02 06.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/49/Galeriewerk_Woermann_Mappe_02_06.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/Galeriewerk_Woermann_Mappe_02_06.jpg/1280px-Galeriewerk_Woermann_Mappe_02_06.jpg",
      width: 5900,
      height: 7799,
    },
    {
      title: "Albrecht Dürer, An Oriental Ruler Seated on His Throne, c. 1495, NGA 152824.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/39/Albrecht_D%C3%BCrer%2C_An_Oriental_Ruler_Seated_on_His_Throne%2C_c._1495%2C_NGA_152824.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Albrecht_D%C3%BCrer%2C_An_Oriental_Ruler_Seated_on_His_Throne%2C_c._1495%2C_NGA_152824.jpg/1280px-Albrecht_D%C3%BCrer%2C_An_Oriental_Ruler_Seated_on_His_Throne%2C_c._1495%2C_NGA_152824.jpg",
      width: 2584,
      height: 4000,
    },
    {
      title: "Albrecht Dürer, An Oriental Ruler Seated on His Throne, c. 1495, NGA 53157.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/84/Albrecht_D%C3%BCrer%2C_An_Oriental_Ruler_Seated_on_His_Throne%2C_c._1495%2C_NGA_53157.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Albrecht_D%C3%BCrer%2C_An_Oriental_Ruler_Seated_on_His_Throne%2C_c._1495%2C_NGA_53157.jpg/1280px-Albrecht_D%C3%BCrer%2C_An_Oriental_Ruler_Seated_on_His_Throne%2C_c._1495%2C_NGA_53157.jpg",
      width: 2595,
      height: 4000,
    },
    {
      title: "Handen en een profielkop, RP-T-1954-73.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/ce/Handen_en_een_profielkop%2C_RP-T-1954-73.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Handen_en_een_profielkop%2C_RP-T-1954-73.jpg/1280px-Handen_en_een_profielkop%2C_RP-T-1954-73.jpg",
      width: 4318,
      height: 6086,
    },
    {
      title: "Logarithmische Spirale bei Albrecht Dürer.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/31/Logarithmische_Spirale_bei_Albrecht_D%C3%BCrer.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/31/Logarithmische_Spirale_bei_Albrecht_D%C3%BCrer.jpg/1280px-Logarithmische_Spirale_bei_Albrecht_D%C3%BCrer.jpg",
      width: 1994,
      height: 1297,
    },
    {
      title: "Virgin Mary death Durer 1518.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/0f/Virgin_Mary_death_Durer_1518.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0f/Virgin_Mary_death_Durer_1518.jpg/1280px-Virgin_Mary_death_Durer_1518.jpg",
      width: 1459,
      height: 2028,
    },
    {
      title: "Albrecht Dürer, Kopf eines Hirschen mit Pfeil (1504).jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d5/Albrecht_D%C3%BCrer%2C_Kopf_eines_Hirschen_mit_Pfeil_%281504%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/Albrecht_D%C3%BCrer%2C_Kopf_eines_Hirschen_mit_Pfeil_%281504%29.jpg/1280px-Albrecht_D%C3%BCrer%2C_Kopf_eines_Hirschen_mit_Pfeil_%281504%29.jpg",
      width: 3808,
      height: 3159,
    },
    {
      title: "The Scourging of Christ by Albrecht Dürer.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/18/The_Scourging_of_Christ_by_Albrecht_D%C3%BCrer.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/1/18/The_Scourging_of_Christ_by_Albrecht_D%C3%BCrer.jpg",
      width: 1065,
      height: 1500,
    },
    {
      title: "Dürer, Albrecht - Zeichnung für einen Tischbrunnen.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/72/D%C3%BCrer%2C_Albrecht_-_Zeichnung_f%C3%BCr_einen_Tischbrunnen.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/72/D%C3%BCrer%2C_Albrecht_-_Zeichnung_f%C3%BCr_einen_Tischbrunnen.jpg",
      width: 468,
      height: 733,
    },
    {
      title: "Albrecht Dürer, Drawings p42 Rhinoceron.png",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f1/Albrecht_D%C3%BCrer%2C_Drawings_p42_Rhinoceron.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Albrecht_D%C3%BCrer%2C_Drawings_p42_Rhinoceron.png/1280px-Albrecht_D%C3%BCrer%2C_Drawings_p42_Rhinoceron.png",
      width: 1574,
      height: 1170,
    },
    {
      title: "Albrecht Dürer. Illustration für die Hieroglyphica des Horapollo.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/82/Albrecht_D%C3%BCrer._Illustration_f%C3%BCr_die_Hieroglyphica_des_Horapollo.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/82/Albrecht_D%C3%BCrer._Illustration_f%C3%BCr_die_Hieroglyphica_des_Horapollo.jpg/1280px-Albrecht_D%C3%BCrer._Illustration_f%C3%BCr_die_Hieroglyphica_des_Horapollo.jpg",
      width: 1864,
      height: 4000,
    },
    {
      title: "Albrecht dürer, filippo melatone, 1526 ca., disegno a penna e inchiostro (museo horne).jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/90/Albrecht_d%C3%BCrer%2C_filippo_melatone%2C_1526_ca.%2C_disegno_a_penna_e_inchiostro_%28museo_horne%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Albrecht_d%C3%BCrer%2C_filippo_melatone%2C_1526_ca.%2C_disegno_a_penna_e_inchiostro_%28museo_horne%29.jpg/1280px-Albrecht_d%C3%BCrer%2C_filippo_melatone%2C_1526_ca.%2C_disegno_a_penna_e_inchiostro_%28museo_horne%29.jpg",
      width: 2586,
      height: 2874,
    },
    {
      title: "Albrecht Dürer Arm mit Dolch 1508.jpeg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/73/Albrecht_D%C3%BCrer_Arm_mit_Dolch_1508.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Albrecht_D%C3%BCrer_Arm_mit_Dolch_1508.jpeg/1280px-Albrecht_D%C3%BCrer_Arm_mit_Dolch_1508.jpeg",
      width: 1563,
      height: 1792,
    },
    {
      title: "Albrecht dürer - A man with an oar - Barber institute of Fine Arts.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/da/Albrecht_d%C3%BCrer_-_A_man_with_an_oar_-_Barber_institute_of_Fine_Arts.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/da/Albrecht_d%C3%BCrer_-_A_man_with_an_oar_-_Barber_institute_of_Fine_Arts.jpg",
      width: 500,
      height: 754,
    },
    {
      title: "Rysunek i malarstwo 1901 (76295279).jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Rysunek_i_malarstwo_1901_%2876295279%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Rysunek_i_malarstwo_1901_%2876295279%29.jpg/1280px-Rysunek_i_malarstwo_1901_%2876295279%29.jpg",
      width: 4231,
      height: 6471,
    },
    {
      title: "Zeichnung - Skizzenbuchblatt - Marx Ulstat und Die schöne Jungfrau zu Antwerpen - Albrecht Dürer - um 1520.jpg",
      artist: "Albrecht Dürer",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b1/Zeichnung_-_Skizzenbuchblatt_-_Marx_Ulstat_und_Die_sch%C3%B6ne_Jungfrau_zu_Antwerpen_-_Albrecht_D%C3%BCrer_-_um_1520.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b1/Zeichnung_-_Skizzenbuchblatt_-_Marx_Ulstat_und_Die_sch%C3%B6ne_Jungfrau_zu_Antwerpen_-_Albrecht_D%C3%BCrer_-_um_1520.jpg/1280px-Zeichnung_-_Skizzenbuchblatt_-_Marx_Ulstat_und_Die_sch%C3%B6ne_Jungfrau_zu_Antwerpen_-_Albrecht_D%C3%BCrer_-_um_1520.jpg",
      width: 2964,
      height: 2000,
    },
  ],
};

export const REMBRANDT_DRAWINGS: ArtistCollection = {
  artist: "Rembrandt",
  deathYear: 1669,
  publicDomainStatus: "Public domain - artist died 1669 (>357 years ago)",
  works: [
    {
      title: "Nude Study for the Figure... - Rembrandt Harmenszoon van Rijn.png",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7d/Nude_Study_for_the_Figure..._-_Rembrandt_Harmenszoon_van_Rijn.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/7d/Nude_Study_for_the_Figure..._-_Rembrandt_Harmenszoon_van_Rijn.png",
      width: 1024,
      height: 1536,
    },
    {
      title: "Rembrandt 210.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Rembrandt_210.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Rembrandt_210.jpg/1280px-Rembrandt_210.jpg",
      width: 1588,
      height: 962,
    },
    {
      title: "Rembrandt drawing known as 'The Judgment'.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/81/Rembrandt_drawing_known_as_%27The_Judgment%27.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/81/Rembrandt_drawing_known_as_%27The_Judgment%27.jpg",
      width: 871,
      height: 525,
    },
    {
      title: "Rembrandt Harmensz van Rijn, 'A blind beggar with a boy and a dog'.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/80/Rembrandt_Harmensz_van_Rijn%2C_%27A_blind_beggar_with_a_boy_and_a_dog%27.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Rembrandt_Harmensz_van_Rijn%2C_%27A_blind_beggar_with_a_boy_and_a_dog%27.jpg/1280px-Rembrandt_Harmensz_van_Rijn%2C_%27A_blind_beggar_with_a_boy_and_a_dog%27.jpg",
      width: 2180,
      height: 3200,
    },
    {
      title: "Lithostein IB 108-2 Rembrandt.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/39/Lithostein_IB_108-2_Rembrandt.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/Lithostein_IB_108-2_Rembrandt.jpg/1280px-Lithostein_IB_108-2_Rembrandt.jpg",
      width: 2358,
      height: 2977,
    },
    {
      title: "Rembrandt Bearded old man seated in an armchair.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6e/Rembrandt_Bearded_old_man_seated_in_an_armchair.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/6e/Rembrandt_Bearded_old_man_seated_in_an_armchair.jpg",
      width: 956,
      height: 1385,
    },
    {
      title: "Rembrandt Minerva in her Study.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/80/Rembrandt_Minerva_in_her_Study.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/80/Rembrandt_Minerva_in_her_Study.jpg",
      width: 417,
      height: 600,
    },
    {
      title: "Rembrandt Study of Russian Costume.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/8f/Rembrandt_Study_of_Russian_Costume.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8f/Rembrandt_Study_of_Russian_Costume.jpg/1280px-Rembrandt_Study_of_Russian_Costume.jpg",
      width: 1452,
      height: 1037,
    },
    {
      title: "Rembrandt The Prodigal Son in the Tavern.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ea/Rembrandt_The_Prodigal_Son_in_the_Tavern.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ea/Rembrandt_The_Prodigal_Son_in_the_Tavern.jpg/1243px-Rembrandt_The_Prodigal_Son_in_the_Tavern.jpg",
      width: 1243,
      height: 1048,
    },
    {
      title: "Rembrandt Two Studies of a Woman Seated on the Ground.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3d/Rembrandt_Two_Studies_of_a_Woman_Seated_on_the_Ground.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/3d/Rembrandt_Two_Studies_of_a_Woman_Seated_on_the_Ground.jpg",
      width: 834,
      height: 1060,
    },
    {
      title: "Rembrandt Studies of an Officer, an Oriental and a Man in High Cap.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3d/Rembrandt_Studies_of_an_Officer%2C_an_Oriental_and_a_Man_in_High_Cap.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/3d/Rembrandt_Studies_of_an_Officer%2C_an_Oriental_and_a_Man_in_High_Cap.jpg",
      width: 510,
      height: 800,
    },
    {
      title: "Rembrandt The Pancake Woman.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1e/Rembrandt_The_Pancake_Woman.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/1/1e/Rembrandt_The_Pancake_Woman.jpg",
      width: 1200,
      height: 908,
    },
    {
      title: "Rembrandt Woman in a Rich Dress and a Fur Hat, Seen from Behind.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/86/Rembrandt_Woman_in_a_Rich_Dress_and_a_Fur_Hat%2C_Seen_from_Behind.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/86/Rembrandt_Woman_in_a_Rich_Dress_and_a_Fur_Hat%2C_Seen_from_Behind.jpg",
      width: 763,
      height: 1078,
    },
    {
      title: "Rembrandt Study for a Presentation in the Temple.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/86/Rembrandt_Study_for_a_Presentation_in_the_Temple.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Rembrandt_Study_for_a_Presentation_in_the_Temple.jpg/1280px-Rembrandt_Study_for_a_Presentation_in_the_Temple.jpg",
      width: 1508,
      height: 1430,
    },
    {
      title: "Rembrandt Study of a Seated Beggar Woman, Supplicating.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/84/Rembrandt_Study_of_a_Seated_Beggar_Woman%2C_Supplicating.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/84/Rembrandt_Study_of_a_Seated_Beggar_Woman%2C_Supplicating.jpg",
      width: 812,
      height: 625,
    },
    {
      title: "Rembrandt Study for the Hundred-guilder Print.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c4/Rembrandt_Study_for_the_Hundred-guilder_Print.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Rembrandt_Study_for_the_Hundred-guilder_Print.jpg/1263px-Rembrandt_Study_for_the_Hundred-guilder_Print.jpg",
      width: 1263,
      height: 1087,
    },
    {
      title: "Rembrandt The Agony in the Garden.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e1/Rembrandt_The_Agony_in_the_Garden.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/e1/Rembrandt_The_Agony_in_the_Garden.jpg",
      width: 739,
      height: 760,
    },
    {
      title: "Rembrandt Old Man Leaning on a Stick.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/75/Rembrandt_Old_Man_Leaning_on_a_Stick.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Rembrandt_Old_Man_Leaning_on_a_Stick.jpg/1280px-Rembrandt_Old_Man_Leaning_on_a_Stick.jpg",
      width: 2366,
      height: 3996,
    },
    {
      title: "Rembrandt Farmhouse beneath Trees, with a Footbridge.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4f/Rembrandt_Farmhouse_beneath_Trees%2C_with_a_Footbridge.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4f/Rembrandt_Farmhouse_beneath_Trees%2C_with_a_Footbridge.jpg",
      width: 760,
      height: 663,
    },
    {
      title: "Rembrandt, his life, his work and his time (1894) (14774429551).jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4f/Rembrandt%2C_his_life%2C_his_work_and_his_time_%281894%29_%2814774429551%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Rembrandt%2C_his_life%2C_his_work_and_his_time_%281894%29_%2814774429551%29.jpg/1280px-Rembrandt%2C_his_life%2C_his_work_and_his_time_%281894%29_%2814774429551%29.jpg",
      width: 2512,
      height: 1900,
    },
    {
      title: "Martha and Mary at Jesus' Feet.png",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ea/Martha_and_Mary_at_Jesus%27_Feet.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/ea/Martha_and_Mary_at_Jesus%27_Feet.png",
      width: 806,
      height: 521,
    },
    {
      title: "Rembrandt 1669-1969 tentoonstelling te Amsterdam 13 september tot 30 november sc, Bestanddeelnr 922-3232.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/9a/Rembrandt_1669-1969_tentoonstelling_te_Amsterdam_13_september_tot_30_november_sc%2C_Bestanddeelnr_922-3232.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Rembrandt_1669-1969_tentoonstelling_te_Amsterdam_13_september_tot_30_november_sc%2C_Bestanddeelnr_922-3232.jpg/1280px-Rembrandt_1669-1969_tentoonstelling_te_Amsterdam_13_september_tot_30_november_sc%2C_Bestanddeelnr_922-3232.jpg",
      width: 3484,
      height: 2608,
    },
    {
      title: "Rembrandt 1669-1969 tentoonstelling te Amsterdam 13 september tot 30 november sc, Bestanddeelnr 922-3233.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b3/Rembrandt_1669-1969_tentoonstelling_te_Amsterdam_13_september_tot_30_november_sc%2C_Bestanddeelnr_922-3233.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Rembrandt_1669-1969_tentoonstelling_te_Amsterdam_13_september_tot_30_november_sc%2C_Bestanddeelnr_922-3233.jpg/1280px-Rembrandt_1669-1969_tentoonstelling_te_Amsterdam_13_september_tot_30_november_sc%2C_Bestanddeelnr_922-3233.jpg",
      width: 2657,
      height: 3299,
    },
    {
      title: "Diana and Callisto, Rembrandt van Rijn, 1642-1643, drawing, 208 by 300 mm, private collection (ex W. R. Valentiner).jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/98/Diana_and_Callisto%2C_Rembrandt_van_Rijn%2C_1642-1643%2C_drawing%2C_208_by_300_mm%2C_private_collection_%28ex_W._R._Valentiner%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/9/98/Diana_and_Callisto%2C_Rembrandt_van_Rijn%2C_1642-1643%2C_drawing%2C_208_by_300_mm%2C_private_collection_%28ex_W._R._Valentiner%29.jpg",
      width: 1200,
      height: 850,
    },
    {
      title: "Gegevens cataloguskaartje Gezicht op de Amsterdamse Poort en de aangrenzende wal vanaf de Oude Weg, Inventarisnummer NL-HlmNHA 1100 KNA006000213.JPG",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/db/Gegevens_cataloguskaartje_Gezicht_op_de_Amsterdamse_Poort_en_de_aangrenzende_wal_vanaf_de_Oude_Weg%2C_Inventarisnummer_NL-HlmNHA_1100_KNA006000213.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/db/Gegevens_cataloguskaartje_Gezicht_op_de_Amsterdamse_Poort_en_de_aangrenzende_wal_vanaf_de_Oude_Weg%2C_Inventarisnummer_NL-HlmNHA_1100_KNA006000213.JPG/1280px-Gegevens_cataloguskaartje_Gezicht_op_de_Amsterdamse_Poort_en_de_aangrenzende_wal_vanaf_de_Oude_Weg%2C_Inventarisnummer_NL-HlmNHA_1100_KNA006000213.JPG",
      width: 2234,
      height: 1369,
    },
    {
      title: "Amsterdam - Rijksmuseum - Late Rembrandt Exposition 2015 - Drawing of Christ Preaching.png",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/73/Amsterdam_-_Rijksmuseum_-_Late_Rembrandt_Exposition_2015_-_Drawing_of_Christ_Preaching.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/73/Amsterdam_-_Rijksmuseum_-_Late_Rembrandt_Exposition_2015_-_Drawing_of_Christ_Preaching.png/1280px-Amsterdam_-_Rijksmuseum_-_Late_Rembrandt_Exposition_2015_-_Drawing_of_Christ_Preaching.png",
      width: 3974,
      height: 3175,
    },
    {
      title: "Amsterdam - Rijksmuseum - Late Rembrandt Exposition 2015 - The Agony in the Garden 1657.png",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/75/Amsterdam_-_Rijksmuseum_-_Late_Rembrandt_Exposition_2015_-_The_Agony_in_the_Garden_1657.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Amsterdam_-_Rijksmuseum_-_Late_Rembrandt_Exposition_2015_-_The_Agony_in_the_Garden_1657.png/1280px-Amsterdam_-_Rijksmuseum_-_Late_Rembrandt_Exposition_2015_-_The_Agony_in_the_Garden_1657.png",
      width: 3148,
      height: 4215,
    },
    {
      title: "Rembrandt Temptation of Christ Sketch 3.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/31/Rembrandt_Temptation_of_Christ_Sketch_3.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/31/Rembrandt_Temptation_of_Christ_Sketch_3.jpg",
      width: 1000,
      height: 832,
    },
    {
      title: "Rembrandt Temptation of Christ Sketch 2.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Rembrandt_Temptation_of_Christ_Sketch_2.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Rembrandt_Temptation_of_Christ_Sketch_2.jpg",
      width: 1000,
      height: 841,
    },
    {
      title: "Attributed to Jan Lievens - Moor with turban, ca. 1627-1629, 215990.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6d/Attributed_to_Jan_Lievens_-_Moor_with_turban%2C_ca._1627-1629%2C_215990.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/6d/Attributed_to_Jan_Lievens_-_Moor_with_turban%2C_ca._1627-1629%2C_215990.jpg",
      width: 500,
      height: 650,
    },
    {
      title: "Rembrandt - Christ on Mount of Olives, 62.24.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/70/Rembrandt_-_Christ_on_Mount_of_Olives%2C_62.24.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/70/Rembrandt_-_Christ_on_Mount_of_Olives%2C_62.24.jpg",
      width: 640,
      height: 540,
    },
    {
      title: "Le Moulin (Bartsch 233), GDUT7915.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/07/Le_Moulin_%28Bartsch_233%29%2C_GDUT7915.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Le_Moulin_%28Bartsch_233%29%2C_GDUT7915.jpg/1280px-Le_Moulin_%28Bartsch_233%29%2C_GDUT7915.jpg",
      width: 3249,
      height: 2346,
    },
    {
      title: "Rembrandt after Hans Holbein (II) - An English Woman - NG.K&H.B.15589 - National Museum of Art, Architecture and Design.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/58/Rembrandt_after_Hans_Holbein_%28II%29_-_An_English_Woman_-_NG.K%26H.B.15589_-_National_Museum_of_Art%2C_Architecture_and_Design.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/Rembrandt_after_Hans_Holbein_%28II%29_-_An_English_Woman_-_NG.K%26H.B.15589_-_National_Museum_of_Art%2C_Architecture_and_Design.jpg/1280px-Rembrandt_after_Hans_Holbein_%28II%29_-_An_English_Woman_-_NG.K%26H.B.15589_-_National_Museum_of_Art%2C_Architecture_and_Design.jpg",
      width: 2911,
      height: 4000,
    },
    {
      title: "Jesus und Ehebrecherin.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/32/Jesus_und_Ehebrecherin.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Jesus_und_Ehebrecherin.jpg/1280px-Jesus_und_Ehebrecherin.jpg",
      width: 1292,
      height: 978,
    },
    {
      title: "The Return of the... - Rembrandt Harmenszoon van Rijn.png",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1c/The_Return_of_the..._-_Rembrandt_Harmenszoon_van_Rijn.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/The_Return_of_the..._-_Rembrandt_Harmenszoon_van_Rijn.png/1280px-The_Return_of_the..._-_Rembrandt_Harmenszoon_van_Rijn.png",
      width: 1536,
      height: 1024,
    },
    {
      title: "Rembrandt Men in oriental dress.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/13/Rembrandt_Men_in_oriental_dress.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/13/Rembrandt_Men_in_oriental_dress.jpg/1280px-Rembrandt_Men_in_oriental_dress.jpg",
      width: 2406,
      height: 1882,
    },
    {
      title: "Verhaeren - Rembrandt, Laurens p025R.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/79/Verhaeren_-_Rembrandt%2C_Laurens_p025R.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Verhaeren_-_Rembrandt%2C_Laurens_p025R.jpg/1280px-Verhaeren_-_Rembrandt%2C_Laurens_p025R.jpg",
      width: 3991,
      height: 2789,
    },
    {
      title: "Tobias healing Tobit by Rembrandt Wellcome M0006884.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/46/Tobias_healing_Tobit_by_Rembrandt_Wellcome_M0006884.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Tobias_healing_Tobit_by_Rembrandt_Wellcome_M0006884.jpg/1280px-Tobias_healing_Tobit_by_Rembrandt_Wellcome_M0006884.jpg",
      width: 3240,
      height: 3349,
    },
    {
      title: "Solomon's Idolatry.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/37/Solomon%27s_Idolatry.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/37/Solomon%27s_Idolatry.jpg",
      width: 626,
      height: 800,
    },
    {
      title: "The Preaching of St. John the Baptist.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/47/The_Preaching_of_St._John_the_Baptist.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/The_Preaching_of_St._John_the_Baptist.jpg/1280px-The_Preaching_of_St._John_the_Baptist.jpg",
      width: 1737,
      height: 1227,
    },
    {
      title: "The Roman Consul Popilius Lenas Drawing a Line Around King Antiochus Epiphanes 1656.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/ca/The_Roman_Consul_Popilius_Lenas_Drawing_a_Line_Around_King_Antiochus_Epiphanes_1656.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/ca/The_Roman_Consul_Popilius_Lenas_Drawing_a_Line_Around_King_Antiochus_Epiphanes_1656.jpg",
      width: 800,
      height: 520,
    },
    {
      title: "Study of a seated mother and a child in a high chair, attributed to Rembrandt van Rijn, 1640s, black chalk, 88 by 92 mm.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/03/Study_of_a_seated_mother_and_a_child_in_a_high_chair%2C_attributed_to_Rembrandt_van_Rijn%2C_1640s%2C_black_chalk%2C_88_by_92_mm.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Study_of_a_seated_mother_and_a_child_in_a_high_chair%2C_attributed_to_Rembrandt_van_Rijn%2C_1640s%2C_black_chalk%2C_88_by_92_mm.jpg/1280px-Study_of_a_seated_mother_and_a_child_in_a_high_chair%2C_attributed_to_Rembrandt_van_Rijn%2C_1640s%2C_black_chalk%2C_88_by_92_mm.jpg",
      width: 2880,
      height: 2738,
    },
    {
      title: "Rembrandt - The Derelict Church of Sloten - NG.K&H.B.15804 - National Museum of Art, Architecture and Design.jpg",
      artist: "Rembrandt",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/08/Rembrandt_-_The_Derelict_Church_of_Sloten_-_NG.K%26H.B.15804_-_National_Museum_of_Art%2C_Architecture_and_Design.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/08/Rembrandt_-_The_Derelict_Church_of_Sloten_-_NG.K%26H.B.15804_-_National_Museum_of_Art%2C_Architecture_and_Design.jpg/1280px-Rembrandt_-_The_Derelict_Church_of_Sloten_-_NG.K%26H.B.15804_-_National_Museum_of_Art%2C_Architecture_and_Design.jpg",
      width: 4000,
      height: 2834,
    },
  ],
};

export const RAPHAEL_DRAWINGS: ArtistCollection = {
  artist: "Raphael",
  deathYear: 1520,
  publicDomainStatus: "Public domain - artist died 1520 (>506 years ago)",
  works: [
  ],
};

export const PETER_PAUL_RUBENS_DRAWINGS: ArtistCollection = {
  artist: "Peter Paul Rubens",
  deathYear: 1640,
  publicDomainStatus: "Public domain - artist died 1640 (>386 years ago)",
  works: [
    {
      title: "Rubens-landscape1635-1640.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/0a/Rubens-landscape1635-1640.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/Rubens-landscape1635-1640.jpg/1280px-Rubens-landscape1635-1640.jpg",
      width: 1998,
      height: 1479,
    },
    {
      title: "Peter Paul Rubens, Bildnis seines Sohnes Nikolas.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/65/Peter_Paul_Rubens%2C_Bildnis_seines_Sohnes_Nikolas.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/65/Peter_Paul_Rubens%2C_Bildnis_seines_Sohnes_Nikolas.jpg",
      width: 768,
      height: 994,
    },
    {
      title: "Rubens i nicolas.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/db/Rubens_i_nicolas.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/db/Rubens_i_nicolas.jpg",
      width: 578,
      height: 736,
    },
    {
      title: "Albert-rubens.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4d/Albert-rubens.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4d/Albert-rubens.jpg",
      width: 1118,
      height: 1300,
    },
    {
      title: "Rubens+son+Nicholas.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/40/Rubens%2Bson%2BNicholas.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/40/Rubens%2Bson%2BNicholas.jpg",
      width: 605,
      height: 768,
    },
    {
      title: "Head of a Boy - Sir Peter Paul Rubens.png",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/de/Head_of_a_Boy_-_Sir_Peter_Paul_Rubens.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/de/Head_of_a_Boy_-_Sir_Peter_Paul_Rubens.png",
      width: 1024,
      height: 1536,
    },
    {
      title: "Son of the Artist - Sir Peter Paul Rubens.png",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/17/Son_of_the_Artist_-_Sir_Peter_Paul_Rubens.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/1/17/Son_of_the_Artist_-_Sir_Peter_Paul_Rubens.png",
      width: 1024,
      height: 1536,
    },
    {
      title: "Study of a River God - Sir Peter Paul Rubens.png",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Study_of_a_River_God_-_Sir_Peter_Paul_Rubens.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Study_of_a_River_God_-_Sir_Peter_Paul_Rubens.png/1280px-Study_of_a_River_God_-_Sir_Peter_Paul_Rubens.png",
      width: 1536,
      height: 1024,
    },
    {
      title: "Sketch of Peterpaulrubens with Helene Fourment and child.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/03/Sketch_of_Peterpaulrubens_with_Helene_Fourment_and_child.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/0/03/Sketch_of_Peterpaulrubens_with_Helene_Fourment_and_child.jpg",
      width: 863,
      height: 1120,
    },
    {
      title: "Rubens Lorenzo de' Medici.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6e/Rubens_Lorenzo_de%27_Medici.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/6e/Rubens_Lorenzo_de%27_Medici.jpg",
      width: 440,
      height: 490,
    },
    {
      title: "Pieter Claesz. Soutman and Peter Paul Rubens 001.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/ce/Pieter_Claesz._Soutman_and_Peter_Paul_Rubens_001.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Pieter_Claesz._Soutman_and_Peter_Paul_Rubens_001.jpg/1270px-Pieter_Claesz._Soutman_and_Peter_Paul_Rubens_001.jpg",
      width: 1270,
      height: 853,
    },
    {
      title: "Rubens' daughter Clara Serena (or Infanta Isabella's lady-in-waiting) by Peter Paul Rubens.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/94/Rubens%27_daughter_Clara_Serena_%28or_Infanta_Isabella%27s_lady-in-waiting%29_by_Peter_Paul_Rubens.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Rubens%27_daughter_Clara_Serena_%28or_Infanta_Isabella%27s_lady-in-waiting%29_by_Peter_Paul_Rubens.jpg/1280px-Rubens%27_daughter_Clara_Serena_%28or_Infanta_Isabella%27s_lady-in-waiting%29_by_Peter_Paul_Rubens.jpg",
      width: 1600,
      height: 1990,
    },
    {
      title: "Peter Paul Rubens - Nicolaas Rubens - WGA20453.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/36/Peter_Paul_Rubens_-_Nicolaas_Rubens_-_WGA20453.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/36/Peter_Paul_Rubens_-_Nicolaas_Rubens_-_WGA20453.jpg",
      width: 850,
      height: 1050,
    },
    {
      title: "Peter Paul Rubens - Portrait of a Chambermaid - WGA20450.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b7/Peter_Paul_Rubens_-_Portrait_of_a_Chambermaid_-_WGA20450.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/b/b7/Peter_Paul_Rubens_-_Portrait_of_a_Chambermaid_-_WGA20450.jpg",
      width: 666,
      height: 820,
    },
    {
      title: "Peter Paul Rubens - Vision of Ezekiel - WGA20455.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ae/Peter_Paul_Rubens_-_Vision_of_Ezekiel_-_WGA20455.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/ae/Peter_Paul_Rubens_-_Vision_of_Ezekiel_-_WGA20455.jpg",
      width: 822,
      height: 1010,
    },
    {
      title: "Peter Paul Rubens 197.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6f/Peter_Paul_Rubens_197.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/6f/Peter_Paul_Rubens_197.jpg",
      width: 640,
      height: 458,
    },
    {
      title: "Rubens Rest on the flight into Egypt.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Rubens_Rest_on_the_flight_into_Egypt.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Rubens_Rest_on_the_flight_into_Egypt.jpg",
      width: 998,
      height: 768,
    },
    {
      title: "Peter Paul Rubens - Rubens's Son Nicolaas Wearing a Red Felt Cap, 1625-1627 - Google Art Project.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/02/Peter_Paul_Rubens_-_Rubens%27s_Son_Nicolaas_Wearing_a_Red_Felt_Cap%2C_1625-1627_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/Peter_Paul_Rubens_-_Rubens%27s_Son_Nicolaas_Wearing_a_Red_Felt_Cap%2C_1625-1627_-_Google_Art_Project.jpg/1280px-Peter_Paul_Rubens_-_Rubens%27s_Son_Nicolaas_Wearing_a_Red_Felt_Cap%2C_1625-1627_-_Google_Art_Project.jpg",
      width: 2609,
      height: 3226,
    },
    {
      title: "Peter Paul Rubens - Rubens Sohn mit roter Filzkappe.JPG",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/05/Peter_Paul_Rubens_-_Rubens_Sohn_mit_roter_Filzkappe.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Peter_Paul_Rubens_-_Rubens_Sohn_mit_roter_Filzkappe.JPG/1280px-Peter_Paul_Rubens_-_Rubens_Sohn_mit_roter_Filzkappe.JPG",
      width: 2953,
      height: 3508,
    },
    {
      title: "0 Le Prophète Joël - P.P. Rubens - Louvre (INV 20230).JPG",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/0a/0_Le_Proph%C3%A8te_Jo%C3%ABl_-_P.P._Rubens_-_Louvre_%28INV_20230%29.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0a/0_Le_Proph%C3%A8te_Jo%C3%ABl_-_P.P._Rubens_-_Louvre_%28INV_20230%29.JPG/1280px-0_Le_Proph%C3%A8te_Jo%C3%ABl_-_P.P._Rubens_-_Louvre_%28INV_20230%29.JPG",
      width: 2039,
      height: 2909,
    },
    {
      title: "0 Le Prophète Ézéchiel - P.P. Rubens - Louvre (IN V 20231).JPG",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/bd/0_Le_Proph%C3%A8te_%C3%89z%C3%A9chiel_-_P.P._Rubens_-_Louvre_%28IN_V_20231%29.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bd/0_Le_Proph%C3%A8te_%C3%89z%C3%A9chiel_-_P.P._Rubens_-_Louvre_%28IN_V_20231%29.JPG/1280px-0_Le_Proph%C3%A8te_%C3%89z%C3%A9chiel_-_P.P._Rubens_-_Louvre_%28IN_V_20231%29.JPG",
      width: 1545,
      height: 2200,
    },
    {
      title: "0 Le Torse du Belvédère - P.P. Rubens - Rubenshuis - RH.S.109.JPG",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3e/0_Le_Torse_du_Belv%C3%A9d%C3%A8re_-_P.P._Rubens_-_Rubenshuis_-_RH.S.109.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/0_Le_Torse_du_Belv%C3%A9d%C3%A8re_-_P.P._Rubens_-_Rubenshuis_-_RH.S.109.JPG/1280px-0_Le_Torse_du_Belv%C3%A9d%C3%A8re_-_P.P._Rubens_-_Rubenshuis_-_RH.S.109.JPG",
      width: 2290,
      height: 3240,
    },
    {
      title: "Peter Paul Rubens - St. Lambert.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Peter_Paul_Rubens_-_St._Lambert.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/cb/Peter_Paul_Rubens_-_St._Lambert.jpg",
      width: 546,
      height: 1000,
    },
    {
      title: "Godfried Maes or Peter Paul Rubens (Attr.) - Saint Margaret.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c0/Godfried_Maes_or_Peter_Paul_Rubens_%28Attr.%29_-_Saint_Margaret.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Godfried_Maes_or_Peter_Paul_Rubens_%28Attr.%29_-_Saint_Margaret.jpg/1280px-Godfried_Maes_or_Peter_Paul_Rubens_%28Attr.%29_-_Saint_Margaret.jpg",
      width: 2190,
      height: 3000,
    },
    {
      title: "Peter Paul Rubens - Anatomical study.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cd/Peter_Paul_Rubens_-_Anatomical_study.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Peter_Paul_Rubens_-_Anatomical_study.jpg/1280px-Peter_Paul_Rubens_-_Anatomical_study.jpg",
      width: 1399,
      height: 1998,
    },
    {
      title: "Peter Paul Rubens - Child portrait of Frans Rubens, son of the artist.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6c/Peter_Paul_Rubens_-_Child_portrait_of_Frans_Rubens%2C_son_of_the_artist.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/6c/Peter_Paul_Rubens_-_Child_portrait_of_Frans_Rubens%2C_son_of_the_artist.jpg",
      width: 826,
      height: 1000,
    },
    {
      title: "Peter Paul Rubens - Torso of Laocoon.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c9/Peter_Paul_Rubens_-_Torso_of_Laocoon.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c9/Peter_Paul_Rubens_-_Torso_of_Laocoon.jpg",
      width: 660,
      height: 1000,
    },
    {
      title: "Peter Paul Rubens - Study sheet with arms and hands.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/58/Peter_Paul_Rubens_-_Study_sheet_with_arms_and_hands.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/5/58/Peter_Paul_Rubens_-_Study_sheet_with_arms_and_hands.jpg",
      width: 659,
      height: 1000,
    },
    {
      title: "Peter Paul Rubens - Dionysus supporting a drunken Silenus with a maenad dancing in front of him (after the Borghese Vase in the Louvre).jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a7/Peter_Paul_Rubens_-_Dionysus_supporting_a_drunken_Silenus_with_a_maenad_dancing_in_front_of_him_%28after_the_Borghese_Vase_in_the_Louvre%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a7/Peter_Paul_Rubens_-_Dionysus_supporting_a_drunken_Silenus_with_a_maenad_dancing_in_front_of_him_%28after_the_Borghese_Vase_in_the_Louvre%29.jpg",
      width: 1000,
      height: 770,
    },
    {
      title: "Peter Paul Rubens - Standing boy with cloth (back view from right).jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/71/Peter_Paul_Rubens_-_Standing_boy_with_cloth_%28back_view_from_right%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/71/Peter_Paul_Rubens_-_Standing_boy_with_cloth_%28back_view_from_right%29.jpg",
      width: 729,
      height: 1000,
    },
    {
      title: "Raffaello Santi - Vision of Ezekiel - (MeisterDrucke-31103).jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/47/Raffaello_Santi_-_Vision_of_Ezekiel_-_%28MeisterDrucke-31103%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/47/Raffaello_Santi_-_Vision_of_Ezekiel_-_%28MeisterDrucke-31103%29.jpg",
      width: 600,
      height: 752,
    },
    {
      title: "Peter Paul Rubens - Young man kneeling to the left with his hands tied behind his back. (Preliminary study for Isaac in the painting “Abraham's Sacrifice”).jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e9/Peter_Paul_Rubens_-_Young_man_kneeling_to_the_left_with_his_hands_tied_behind_his_back._%28Preliminary_study_for_Isaac_in_the_painting_%E2%80%9CAbraham%27s_Sacrifice%E2%80%9D%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Peter_Paul_Rubens_-_Young_man_kneeling_to_the_left_with_his_hands_tied_behind_his_back._%28Preliminary_study_for_Isaac_in_the_painting_%E2%80%9CAbraham%27s_Sacrifice%E2%80%9D%29.jpg/1280px-thumbnail.jpg",
      width: 1778,
      height: 3500,
    },
    {
      title: "Jan Cornelisz. Vermeyen (Attributed to) and Peter Paul Rubens (reworked) - Courtly company at a fountain.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1c/Jan_Cornelisz._Vermeyen_%28Attributed_to%29_and_Peter_Paul_Rubens_%28reworked%29_-_Courtly_company_at_a_fountain.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1c/Jan_Cornelisz._Vermeyen_%28Attributed_to%29_and_Peter_Paul_Rubens_%28reworked%29_-_Courtly_company_at_a_fountain.jpg/1280px-Jan_Cornelisz._Vermeyen_%28Attributed_to%29_and_Peter_Paul_Rubens_%28reworked%29_-_Courtly_company_at_a_fountain.jpg",
      width: 2769,
      height: 1314,
    },
    {
      title: "Peter Paul Rubens - Portrait of Albert Rubens (1614-1657), Son of the Artist, in Profile.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e6/Peter_Paul_Rubens_-_Portrait_of_Albert_Rubens_%281614-1657%29%2C_Son_of_the_Artist%2C_in_Profile.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Peter_Paul_Rubens_-_Portrait_of_Albert_Rubens_%281614-1657%29%2C_Son_of_the_Artist%2C_in_Profile.jpg/1280px-Peter_Paul_Rubens_-_Portrait_of_Albert_Rubens_%281614-1657%29%2C_Son_of_the_Artist%2C_in_Profile.jpg",
      width: 1310,
      height: 1600,
    },
    {
      title: "Peter Paul Rubens - Portrait of Nicolaas Rubens, Son of the Artist, Wearing a Red Felt Cap.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3a/Peter_Paul_Rubens_-_Portrait_of_Nicolaas_Rubens%2C_Son_of_the_Artist%2C_Wearing_a_Red_Felt_Cap.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Peter_Paul_Rubens_-_Portrait_of_Nicolaas_Rubens%2C_Son_of_the_Artist%2C_Wearing_a_Red_Felt_Cap.jpg/1280px-Peter_Paul_Rubens_-_Portrait_of_Nicolaas_Rubens%2C_Son_of_the_Artist%2C_Wearing_a_Red_Felt_Cap.jpg",
      width: 1280,
      height: 1594,
    },
    {
      title: "Peter Paul Rubens - Janus-like head of Cupid and Psyche.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ea/Peter_Paul_Rubens_-_Janus-like_head_of_Cupid_and_Psyche.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/ea/Peter_Paul_Rubens_-_Janus-like_head_of_Cupid_and_Psyche.jpg",
      width: 945,
      height: 979,
    },
    {
      title: "Peter Paul Rubens - Self-portrait with Helena Fourment and Son.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/0d/Peter_Paul_Rubens_-_Self-portrait_with_Helena_Fourment_and_Son.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0d/Peter_Paul_Rubens_-_Self-portrait_with_Helena_Fourment_and_Son.jpg/1280px-Peter_Paul_Rubens_-_Self-portrait_with_Helena_Fourment_and_Son.jpg",
      width: 1735,
      height: 2247,
    },
    {
      title: "Peter Paul Rubens - Anatomical study of a man.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e8/Peter_Paul_Rubens_-_Anatomical_study_of_a_man.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Peter_Paul_Rubens_-_Anatomical_study_of_a_man.jpg/1280px-Peter_Paul_Rubens_-_Anatomical_study_of_a_man.jpg",
      width: 2059,
      height: 2947,
    },
    {
      title: "Peter Paul Rubens - Two young women, the one on the left holding a dog.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/5a/Peter_Paul_Rubens_-_Two_young_women%2C_the_one_on_the_left_holding_a_dog.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5a/Peter_Paul_Rubens_-_Two_young_women%2C_the_one_on_the_left_holding_a_dog.jpg/1244px-Peter_Paul_Rubens_-_Two_young_women%2C_the_one_on_the_left_holding_a_dog.jpg",
      width: 1244,
      height: 1512,
    },
    {
      title: "Peter Paul Ruben's copy of the lost Battle of Anghiari.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c4/Peter_Paul_Ruben%27s_copy_of_the_lost_Battle_of_Anghiari.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c4/Peter_Paul_Ruben%27s_copy_of_the_lost_Battle_of_Anghiari.jpg",
      width: 1179,
      height: 857,
    },
    {
      title: "Infanta Isabella - Sir Peter Paul Rubens.png",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/52/Infanta_Isabella_-_Sir_Peter_Paul_Rubens.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/5/52/Infanta_Isabella_-_Sir_Peter_Paul_Rubens.png",
      width: 1024,
      height: 1536,
    },
    {
      title: "Portrait of a Woman - Sir Peter Paul Rubens.png",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Portrait_of_a_Woman_-_Sir_Peter_Paul_Rubens.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Portrait_of_a_Woman_-_Sir_Peter_Paul_Rubens.png",
      width: 1024,
      height: 1536,
    },
    {
      title: "After leonardo da vinci, The Battle of Anghiari by Rubens, Louvre.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c5/After_leonardo_da_vinci%2C_The_Battle_of_Anghiari_by_Rubens%2C_Louvre.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c5/After_leonardo_da_vinci%2C_The_Battle_of_Anghiari_by_Rubens%2C_Louvre.jpg",
      width: 1030,
      height: 708,
    },
    {
      title: "Rubens Alcibiades MOMA.jpeg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Rubens_Alcibiades_MOMA.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a5/Rubens_Alcibiades_MOMA.jpeg",
      width: 575,
      height: 423,
    },
    {
      title: "Possibly Peter Paul Rubens 001.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Possibly_Peter_Paul_Rubens_001.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Possibly_Peter_Paul_Rubens_001.jpg/1280px-Possibly_Peter_Paul_Rubens_001.jpg",
      width: 1547,
      height: 2424,
    },
    {
      title: "Possibly Peter Paul Rubens 002.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/9c/Possibly_Peter_Paul_Rubens_002.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9c/Possibly_Peter_Paul_Rubens_002.jpg/1280px-Possibly_Peter_Paul_Rubens_002.jpg",
      width: 1723,
      height: 2364,
    },
    {
      title: "Peter Paul Rubens 222.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/aa/Peter_Paul_Rubens_222.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/aa/Peter_Paul_Rubens_222.jpg",
      width: 583,
      height: 759,
    },
    {
      title: "0 La Nuit - Pierre Paul Rubens d'après Michel-Ange.JPG",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b9/0_La_Nuit_-_Pierre_Paul_Rubens_d%27apr%C3%A8s_Michel-Ange.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/0_La_Nuit_-_Pierre_Paul_Rubens_d%27apr%C3%A8s_Michel-Ange.JPG/1280px-0_La_Nuit_-_Pierre_Paul_Rubens_d%27apr%C3%A8s_Michel-Ange.JPG",
      width: 2330,
      height: 1669,
    },
    {
      title: "Peter Paul Rubens - Judith Beheading Holofernes - Google Art Project.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ec/Peter_Paul_Rubens_-_Judith_Beheading_Holofernes_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Peter_Paul_Rubens_-_Judith_Beheading_Holofernes_-_Google_Art_Project.jpg/1280px-Peter_Paul_Rubens_-_Judith_Beheading_Holofernes_-_Google_Art_Project.jpg",
      width: 2501,
      height: 3216,
    },
    {
      title: "Peter Paul Rubens - Seated Male Youth (Study for Daniel) - Google Art Project.jpg",
      artist: "Peter Paul Rubens",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/dd/Peter_Paul_Rubens_-_Seated_Male_Youth_%28Study_for_Daniel%29_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dd/Peter_Paul_Rubens_-_Seated_Male_Youth_%28Study_for_Daniel%29_-_Google_Art_Project.jpg/1280px-Peter_Paul_Rubens_-_Seated_Male_Youth_%28Study_for_Daniel%29_-_Google_Art_Project.jpg",
      width: 2481,
      height: 4160,
    },
  ],
};

export const JEAN_AUGUSTE_DOMINIQUE_INGRES_DRAWINGS: ArtistCollection = {
  artist: "Jean-Auguste-Dominique Ingres",
  deathYear: 1867,
  publicDomainStatus: "Public domain - artist died 1867 (>159 years ago)",
  works: [
  ],
};

export const EGON_SCHIELE_DRAWINGS: ArtistCollection = {
  artist: "Egon Schiele",
  deathYear: 1918,
  publicDomainStatus: "Public domain - artist died 1918 (>108 years ago)",
  works: [
    {
      title: "Schiele - Stehendes Mädchen mit kariertem Tuch.jpg",
      artist: "Egon Schiele",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c8/Schiele_-_Stehendes_M%C3%A4dchen_mit_kariertem_Tuch.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c8/Schiele_-_Stehendes_M%C3%A4dchen_mit_kariertem_Tuch.jpg",
      width: 624,
      height: 1552,
    },
    {
      title: "Egon Schiele - Sitzender Rückenakt - 1917.jpeg",
      artist: "Egon Schiele",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/74/Egon_Schiele_-_Sitzender_R%C3%BCckenakt_-_1917.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Egon_Schiele_-_Sitzender_R%C3%BCckenakt_-_1917.jpeg/1280px-Egon_Schiele_-_Sitzender_R%C3%BCckenakt_-_1917.jpeg",
      width: 3576,
      height: 5610,
    },
    {
      title: "Egon Schiele - Margeriten, Winding und Mohnblume - 1918.jpeg",
      artist: "Egon Schiele",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6d/Egon_Schiele_-_Margeriten%2C_Winding_und_Mohnblume_-_1918.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6d/Egon_Schiele_-_Margeriten%2C_Winding_und_Mohnblume_-_1918.jpeg/1280px-Egon_Schiele_-_Margeriten%2C_Winding_und_Mohnblume_-_1918.jpeg",
      width: 3510,
      height: 5634,
    },
    {
      title: "Egon Schiele - Standing Girl - Google Art Project.jpg",
      artist: "Egon Schiele",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4e/Egon_Schiele_-_Standing_Girl_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Egon_Schiele_-_Standing_Girl_-_Google_Art_Project.jpg/1280px-Egon_Schiele_-_Standing_Girl_-_Google_Art_Project.jpg",
      width: 2621,
      height: 6856,
    },
    {
      title: "Egon Schiele. The Graphic Work of Egon Schiele (1922) — detail (24467567963).jpg",
      artist: "Egon Schiele",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/57/Egon_Schiele._The_Graphic_Work_of_Egon_Schiele_%281922%29_%E2%80%94_detail_%2824467567963%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/57/Egon_Schiele._The_Graphic_Work_of_Egon_Schiele_%281922%29_%E2%80%94_detail_%2824467567963%29.jpg/1280px-Egon_Schiele._The_Graphic_Work_of_Egon_Schiele_%281922%29_%E2%80%94_detail_%2824467567963%29.jpg",
      width: 2592,
      height: 1728,
    },
    {
      title: "Český Krumlov, Egon Schiele Art Centrum, stálá výstava, E. Schiele-Tanečnice Moa.jpg",
      artist: "Egon Schiele",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7a/%C4%8Cesk%C3%BD_Krumlov%2C_Egon_Schiele_Art_Centrum%2C_st%C3%A1l%C3%A1_v%C3%BDstava%2C_E._Schiele-Tane%C4%8Dnice_Moa.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/%C4%8Cesk%C3%BD_Krumlov%2C_Egon_Schiele_Art_Centrum%2C_st%C3%A1l%C3%A1_v%C3%BDstava%2C_E._Schiele-Tane%C4%8Dnice_Moa.jpg/1280px-%C4%8Cesk%C3%BD_Krumlov%2C_Egon_Schiele_Art_Centrum%2C_st%C3%A1l%C3%A1_v%C3%BDstava%2C_E._Schiele-Tane%C4%8Dnice_Moa.jpg",
      width: 2198,
      height: 2621,
    },
    {
      title: "Egon Schiele - Autorretrato, c. 1910.jpg",
      artist: "Egon Schiele",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/aa/Egon_Schiele_-_Autorretrato%2C_c._1910.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/aa/Egon_Schiele_-_Autorretrato%2C_c._1910.jpg",
      width: 700,
      height: 1238,
    },
  ],
};

export const GUSTAV_KLIMT_DRAWINGS: ArtistCollection = {
  artist: "Gustav Klimt",
  deathYear: 1918,
  publicDomainStatus: "Public domain - artist died 1918 (>108 years ago)",
  works: [
    {
      title: "Klimt Mulher sentada.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/96/Klimt_Mulher_sentada.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/9/96/Klimt_Mulher_sentada.jpg",
      width: 450,
      height: 625,
    },
    {
      title: "Klimt-missionaires-01.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e6/Klimt-missionaires-01.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Klimt-missionaires-01.jpg/1280px-Klimt-missionaires-01.jpg",
      width: 1425,
      height: 979,
    },
    {
      title: "Klimt Wasserschlangen skizze.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f1/Klimt_Wasserschlangen_skizze.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Klimt_Wasserschlangen_skizze.jpg/1280px-Klimt_Wasserschlangen_skizze.jpg",
      width: 1284,
      height: 1414,
    },
    {
      title: "Klimt - Liegender Halbakt.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d2/Klimt_-_Liegender_Halbakt.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d2/Klimt_-_Liegender_Halbakt.jpg",
      width: 1120,
      height: 768,
    },
    {
      title: "Klimt - Zwei Studien zu einer am Tisch sitzenden jungen Frau.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e4/Klimt_-_Zwei_Studien_zu_einer_am_Tisch_sitzenden_jungen_Frau.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/e4/Klimt_-_Zwei_Studien_zu_einer_am_Tisch_sitzenden_jungen_Frau.jpg",
      width: 864,
      height: 1216,
    },
    {
      title: "Klimt - Sitzender weiblicher Rückenakt.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/61/Klimt_-_Sitzender_weiblicher_R%C3%BCckenakt.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/61/Klimt_-_Sitzender_weiblicher_R%C3%BCckenakt.jpg",
      width: 864,
      height: 1216,
    },
    {
      title: "Klimt - Sitzender weiblicher Akt von vorne.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/5a/Klimt_-_Sitzender_weiblicher_Akt_von_vorne.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/5/5a/Klimt_-_Sitzender_weiblicher_Akt_von_vorne.jpg",
      width: 864,
      height: 1232,
    },
    {
      title: "Klimt - Sitzende Frau mit aufgestützen linken Bein.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/37/Klimt_-_Sitzende_Frau_mit_aufgest%C3%BCtzen_linken_Bein.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/37/Klimt_-_Sitzende_Frau_mit_aufgest%C3%BCtzen_linken_Bein.jpg",
      width: 832,
      height: 1248,
    },
    {
      title: "Klimt - Ausgestreckte Frau 001.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/90/Klimt_-_Ausgestreckte_Frau_001.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/Klimt_-_Ausgestreckte_Frau_001.jpg/1280px-Klimt_-_Ausgestreckte_Frau_001.jpg",
      width: 1408,
      height: 832,
    },
    {
      title: "Klimt Kniestück im Profil nach rechts.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/88/Klimt_Kniest%C3%BCck_im_Profil_nach_rechts.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/88/Klimt_Kniest%C3%BCck_im_Profil_nach_rechts.jpg",
      width: 763,
      height: 1200,
    },
    {
      title: "Klimt - Fünf Studien eines schlafendes Kindes.jpeg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/93/Klimt_-_F%C3%BCnf_Studien_eines_schlafendes_Kindes.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/93/Klimt_-_F%C3%BCnf_Studien_eines_schlafendes_Kindes.jpeg/1280px-Klimt_-_F%C3%BCnf_Studien_eines_schlafendes_Kindes.jpeg",
      width: 1950,
      height: 2862,
    },
    {
      title: "Klimt - Sitzende alte Frau nach links.jpeg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/38/Klimt_-_Sitzende_alte_Frau_nach_links.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Klimt_-_Sitzende_alte_Frau_nach_links.jpeg/1280px-Klimt_-_Sitzende_alte_Frau_nach_links.jpeg",
      width: 3960,
      height: 2778,
    },
    {
      title: "Klimt - Stehender Frauenakt von vorne mit erhobenen Armen.jpeg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ec/Klimt_-_Stehender_Frauenakt_von_vorne_mit_erhobenen_Armen.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/Klimt_-_Stehender_Frauenakt_von_vorne_mit_erhobenen_Armen.jpeg/1280px-Klimt_-_Stehender_Frauenakt_von_vorne_mit_erhobenen_Armen.jpeg",
      width: 2040,
      height: 2748,
    },
    {
      title: "Klimt - Die Squinx mit dem Wissen, Erdkugel, Liebespaar, alter verzweifelter Mann.jpeg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d3/Klimt_-_Die_Squinx_mit_dem_Wissen%2C_Erdkugel%2C_Liebespaar%2C_alter_verzweifelter_Mann.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d3/Klimt_-_Die_Squinx_mit_dem_Wissen%2C_Erdkugel%2C_Liebespaar%2C_alter_verzweifelter_Mann.jpeg/1280px-Klimt_-_Die_Squinx_mit_dem_Wissen%2C_Erdkugel%2C_Liebespaar%2C_alter_verzweifelter_Mann.jpeg",
      width: 2028,
      height: 2958,
    },
    {
      title: "Klimt - Die Sehnsucht nach dem Glück.jpeg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/be/Klimt_-_Die_Sehnsucht_nach_dem_Gl%C3%BCck.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Klimt_-_Die_Sehnsucht_nach_dem_Gl%C3%BCck.jpeg/1280px-Klimt_-_Die_Sehnsucht_nach_dem_Gl%C3%BCck.jpeg",
      width: 1674,
      height: 1128,
    },
    {
      title: "Klimt - Stehender Frauenakt nach rechts - 1902.jpeg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e7/Klimt_-_Stehender_Frauenakt_nach_rechts_-_1902.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Klimt_-_Stehender_Frauenakt_nach_rechts_-_1902.jpeg/1280px-Klimt_-_Stehender_Frauenakt_nach_rechts_-_1902.jpeg",
      width: 3534,
      height: 5190,
    },
    {
      title: "Klimt - Stehender Mädchenakt nach links - 1902.jpeg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e5/Klimt_-_Stehender_M%C3%A4dchenakt_nach_links_-_1902.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Klimt_-_Stehender_M%C3%A4dchenakt_nach_links_-_1902.jpeg/1280px-Klimt_-_Stehender_M%C3%A4dchenakt_nach_links_-_1902.jpeg",
      width: 1878,
      height: 2706,
    },
    {
      title: "Klimt - Stehender Frauenakt nach links, Frauenakt von vorne.jpeg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Klimt_-_Stehender_Frauenakt_nach_links%2C_Frauenakt_von_vorne.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c3/Klimt_-_Stehender_Frauenakt_nach_links%2C_Frauenakt_von_vorne.jpeg/1280px-Klimt_-_Stehender_Frauenakt_nach_links%2C_Frauenakt_von_vorne.jpeg",
      width: 1926,
      height: 2796,
    },
    {
      title: "Gustav Klimt - Head of a Woman in Three-Quarter Profile (Study for the Beethoven Frieze), 1901-1902 - Google Art Project.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/67/Gustav_Klimt_-_Head_of_a_Woman_in_Three-Quarter_Profile_%28Study_for_the_Beethoven_Frieze%29%2C_1901-1902_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Gustav_Klimt_-_Head_of_a_Woman_in_Three-Quarter_Profile_%28Study_for_the_Beethoven_Frieze%29%2C_1901-1902_-_Google_Art_Project.jpg/1280px-Gustav_Klimt_-_Head_of_a_Woman_in_Three-Quarter_Profile_%28Study_for_the_Beethoven_Frieze%29%2C_1901-1902_-_Google_Art_Project.jpg",
      width: 2833,
      height: 4037,
    },
    {
      title: "Gustav Klimt - Portrait of a Lady with Cape and Hat, 1897-1898 - Google Art Project.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/2c/Gustav_Klimt_-_Portrait_of_a_Lady_with_Cape_and_Hat%2C_1897-1898_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Gustav_Klimt_-_Portrait_of_a_Lady_with_Cape_and_Hat%2C_1897-1898_-_Google_Art_Project.jpg/1280px-Gustav_Klimt_-_Portrait_of_a_Lady_with_Cape_and_Hat%2C_1897-1898_-_Google_Art_Project.jpg",
      width: 2600,
      height: 3606,
    },
    {
      title: "Gustav Klimt - Floating Woman with Outstretched Arm (Study for \"Medicine\"), 1900-1901 - Google Art Project.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ad/Gustav_Klimt_-_Floating_Woman_with_Outstretched_Arm_%28Study_for_%22Medicine%22%29%2C_1900-1901_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ad/Gustav_Klimt_-_Floating_Woman_with_Outstretched_Arm_%28Study_for_%22Medicine%22%29%2C_1900-1901_-_Google_Art_Project.jpg/1280px-Gustav_Klimt_-_Floating_Woman_with_Outstretched_Arm_%28Study_for_%22Medicine%22%29%2C_1900-1901_-_Google_Art_Project.jpg",
      width: 2991,
      height: 4237,
    },
    {
      title: "Gustav Klimt - Naked Girl with Ruff, lying - Google Art Project.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/be/Gustav_Klimt_-_Naked_Girl_with_Ruff%2C_lying_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/be/Gustav_Klimt_-_Naked_Girl_with_Ruff%2C_lying_-_Google_Art_Project.jpg/1280px-Gustav_Klimt_-_Naked_Girl_with_Ruff%2C_lying_-_Google_Art_Project.jpg",
      width: 3946,
      height: 2582,
    },
    {
      title: "Gustav Klimt - Dancing Woman with Cape - Google Art Project.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e5/Gustav_Klimt_-_Dancing_Woman_with_Cape_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Gustav_Klimt_-_Dancing_Woman_with_Cape_-_Google_Art_Project.jpg/1280px-Gustav_Klimt_-_Dancing_Woman_with_Cape_-_Google_Art_Project.jpg",
      width: 2612,
      height: 4043,
    },
    {
      title: "Gustav Klimt - Naked Girl Standing, with Right Hand to Breast - Google Art Project.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/56/Gustav_Klimt_-_Naked_Girl_Standing%2C_with_Right_Hand_to_Breast_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/Gustav_Klimt_-_Naked_Girl_Standing%2C_with_Right_Hand_to_Breast_-_Google_Art_Project.jpg/1280px-Gustav_Klimt_-_Naked_Girl_Standing%2C_with_Right_Hand_to_Breast_-_Google_Art_Project.jpg",
      width: 2833,
      height: 4476,
    },
    {
      title: "Gustav Klimt - Portrait of the Artist's Dead Son - Otto Zimmermann DLC Vienna.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/87/Gustav_Klimt_-_Portrait_of_the_Artist%27s_Dead_Son_-_Otto_Zimmermann_DLC_Vienna.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/87/Gustav_Klimt_-_Portrait_of_the_Artist%27s_Dead_Son_-_Otto_Zimmermann_DLC_Vienna.jpg",
      width: 496,
      height: 800,
    },
    {
      title: "Klimt Female nude sitting.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Klimt_Female_nude_sitting.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Klimt_Female_nude_sitting.jpg",
      width: 511,
      height: 777,
    },
    {
      title: "Burgtheater-IMG 0936-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c5/Burgtheater-IMG_0936-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c5/Burgtheater-IMG_0936-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0936-Klimt_Karton.JPG",
      width: 5184,
      height: 3456,
    },
    {
      title: "Burgtheater-IMG 0937-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/64/Burgtheater-IMG_0937-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/64/Burgtheater-IMG_0937-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0937-Klimt_Karton.JPG",
      width: 3456,
      height: 5184,
    },
    {
      title: "Burgtheater-IMG 0938-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e6/Burgtheater-IMG_0938-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/Burgtheater-IMG_0938-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0938-Klimt_Karton.JPG",
      width: 5184,
      height: 3456,
    },
    {
      title: "Burgtheater-IMG 0941-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3f/Burgtheater-IMG_0941-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Burgtheater-IMG_0941-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0941-Klimt_Karton.JPG",
      width: 5184,
      height: 3456,
    },
    {
      title: "Burgtheater-IMG 0939-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/9b/Burgtheater-IMG_0939-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Burgtheater-IMG_0939-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0939-Klimt_Karton.JPG",
      width: 5184,
      height: 3456,
    },
    {
      title: "Burgtheater-IMG 0940-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/30/Burgtheater-IMG_0940-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Burgtheater-IMG_0940-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0940-Klimt_Karton.JPG",
      width: 5184,
      height: 3456,
    },
    {
      title: "Burgtheater-IMG 0942-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/ff/Burgtheater-IMG_0942-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Burgtheater-IMG_0942-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0942-Klimt_Karton.JPG",
      width: 5184,
      height: 3456,
    },
    {
      title: "Burgtheater-IMG 0944-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/06/Burgtheater-IMG_0944-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/Burgtheater-IMG_0944-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0944-Klimt_Karton.JPG",
      width: 5184,
      height: 3456,
    },
    {
      title: "Burgtheater-IMG 0946-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/80/Burgtheater-IMG_0946-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Burgtheater-IMG_0946-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0946-Klimt_Karton.JPG",
      width: 5184,
      height: 3456,
    },
    {
      title: "Burgtheater-IMG 0951-Klimt Karton.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Burgtheater-IMG_0951-Klimt_Karton.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Burgtheater-IMG_0951-Klimt_Karton.JPG/1280px-Burgtheater-IMG_0951-Klimt_Karton.JPG",
      width: 5184,
      height: 3456,
    },
    {
      title: "EROTISCHE SZENE .PNG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/aa/EROTISCHE_SZENE_.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/aa/EROTISCHE_SZENE_.PNG",
      width: 671,
      height: 434,
    },
    {
      title: "FREUNDINNEN (GIRLFRIENDS).PNG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e6/FREUNDINNEN_%28GIRLFRIENDS%29.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/e6/FREUNDINNEN_%28GIRLFRIENDS%29.PNG",
      width: 457,
      height: 670,
    },
    {
      title: "Gustav Klimt - LIEGENDER AKT (RECLINING NUDE).PNG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/10/Gustav_Klimt_-_LIEGENDER_AKT_%28RECLINING_NUDE%29.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/1/10/Gustav_Klimt_-_LIEGENDER_AKT_%28RECLINING_NUDE%29.PNG",
      width: 943,
      height: 612,
    },
    {
      title: "Gustav Klimt - Reclining female nude with her hands behind her head.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cf/Gustav_Klimt_-_Reclining_female_nude_with_her_hands_behind_her_head.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Gustav_Klimt_-_Reclining_female_nude_with_her_hands_behind_her_head.jpg/1280px-Gustav_Klimt_-_Reclining_female_nude_with_her_hands_behind_her_head.jpg",
      width: 5923,
      height: 3791,
    },
    {
      title: "Gustav Klimt - Couple kissing.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ab/Gustav_Klimt_-_Couple_kissing.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/ab/Gustav_Klimt_-_Couple_kissing.jpg",
      width: 547,
      height: 752,
    },
    {
      title: "Gustav Klimt (1862 - 1918) Frauenkopf im Profil nach rechts, 1897-98.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f8/Gustav_Klimt_%281862_-_1918%29_Frauenkopf_im_Profil_nach_rechts%2C_1897-98.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/Gustav_Klimt_%281862_-_1918%29_Frauenkopf_im_Profil_nach_rechts%2C_1897-98.jpg/1280px-Gustav_Klimt_%281862_-_1918%29_Frauenkopf_im_Profil_nach_rechts%2C_1897-98.jpg",
      width: 5092,
      height: 7080,
    },
    {
      title: "Adele und Gustav - Liebe (Klimt - 1899).jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/94/Adele_und_Gustav_-_Liebe_%28Klimt_-_1899%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/94/Adele_und_Gustav_-_Liebe_%28Klimt_-_1899%29.jpg/1266px-Adele_und_Gustav_-_Liebe_%28Klimt_-_1899%29.jpg",
      width: 1266,
      height: 2191,
    },
    {
      title: "Couple of standing lovers (1907-08), by Gustav Klimt.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4a/Couple_of_standing_lovers_%281907-08%29%2C_by_Gustav_Klimt.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4a/Couple_of_standing_lovers_%281907-08%29%2C_by_Gustav_Klimt.jpg/1280px-Couple_of_standing_lovers_%281907-08%29%2C_by_Gustav_Klimt.jpg",
      width: 1547,
      height: 2400,
    },
    {
      title: "Gusav Block Studie Adele Bloch-Bauer.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b5/Gusav_Block_Studie_Adele_Bloch-Bauer.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Gusav_Block_Studie_Adele_Bloch-Bauer.jpg/1280px-Gusav_Block_Studie_Adele_Bloch-Bauer.jpg",
      width: 3331,
      height: 5000,
    },
    {
      title: "Gustab Klimt Kopf einer alten Frau (Studie für Die drei Lebensalter).jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/eb/Gustab_Klimt_Kopf_einer_alten_Frau_%28Studie_f%C3%BCr_Die_drei_Lebensalter%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/eb/Gustab_Klimt_Kopf_einer_alten_Frau_%28Studie_f%C3%BCr_Die_drei_Lebensalter%29.jpg/1280px-Gustab_Klimt_Kopf_einer_alten_Frau_%28Studie_f%C3%BCr_Die_drei_Lebensalter%29.jpg",
      width: 3322,
      height: 5000,
    },
    {
      title: "Gusta Klimt Sitzender Halbakt von vorne Studie zu Tod und Leben c1908-09.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Gusta_Klimt_Sitzender_Halbakt_von_vorne_Studie_zu_Tod_und_Leben_c1908-09.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Gusta_Klimt_Sitzender_Halbakt_von_vorne_Studie_zu_Tod_und_Leben_c1908-09.jpg/1280px-Gusta_Klimt_Sitzender_Halbakt_von_vorne_Studie_zu_Tod_und_Leben_c1908-09.jpg",
      width: 3445,
      height: 5000,
    },
    {
      title: "Aufgestützt liegender Halbakt c1904.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Aufgest%C3%BCtzt_liegender_Halbakt_c1904.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Aufgest%C3%BCtzt_liegender_Halbakt_c1904.jpg/1280px-Aufgest%C3%BCtzt_liegender_Halbakt_c1904.jpg",
      width: 7763,
      height: 5169,
    },
    {
      title: "Gustav Klimt 073.JPG",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/81/Gustav_Klimt_073.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Gustav_Klimt_073.JPG/1280px-Gustav_Klimt_073.JPG",
      width: 1657,
      height: 1158,
    },
    {
      title: "Gustav Klimt Schwangere mit Mann.jpg",
      artist: "Gustav Klimt",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/86/Gustav_Klimt_Schwangere_mit_Mann.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/86/Gustav_Klimt_Schwangere_mit_Mann.jpg",
      width: 767,
      height: 1100,
    },
  ],
};

export const HONOR_DAUMIER_DRAWINGS: ArtistCollection = {
  artist: "Honoré Daumier",
  deathYear: 1879,
  publicDomainStatus: "Public domain - artist died 1879 (>147 years ago)",
  works: [
    {
      title: "Honoré Daumier - Portrait of a Girl (Jeannette), c. 1830 - Google Art Project.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/2a/Honor%C3%A9_Daumier_-_Portrait_of_a_Girl_%28Jeannette%29%2C_c._1830_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/Honor%C3%A9_Daumier_-_Portrait_of_a_Girl_%28Jeannette%29%2C_c._1830_-_Google_Art_Project.jpg/1280px-Honor%C3%A9_Daumier_-_Portrait_of_a_Girl_%28Jeannette%29%2C_c._1830_-_Google_Art_Project.jpg",
      width: 2732,
      height: 3620,
    },
    {
      title: "Honoré Daumier - The Side-Show - Google Art Project.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ee/Honor%C3%A9_Daumier_-_The_Side-Show_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ee/Honor%C3%A9_Daumier_-_The_Side-Show_-_Google_Art_Project.jpg/1280px-Honor%C3%A9_Daumier_-_The_Side-Show_-_Google_Art_Project.jpg",
      width: 4374,
      height: 5463,
    },
    {
      title: "Honoré Daumier - Les Amateurs d’estampes.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Honor%C3%A9_Daumier_-_Les_Amateurs_d%E2%80%99estampes.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a4/Honor%C3%A9_Daumier_-_Les_Amateurs_d%E2%80%99estampes.jpg",
      width: 960,
      height: 813,
    },
    {
      title: "Honoré Daumier - Two Saltimbanques - Google Art Project.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/34/Honor%C3%A9_Daumier_-_Two_Saltimbanques_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Honor%C3%A9_Daumier_-_Two_Saltimbanques_-_Google_Art_Project.jpg/1280px-Honor%C3%A9_Daumier_-_Two_Saltimbanques_-_Google_Art_Project.jpg",
      width: 2501,
      height: 3854,
    },
    {
      title: "Honoré Daumier - Two Lawyers Conversing - Google Art Project.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/25/Honor%C3%A9_Daumier_-_Two_Lawyers_Conversing_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Honor%C3%A9_Daumier_-_Two_Lawyers_Conversing_-_Google_Art_Project.jpg/1280px-Honor%C3%A9_Daumier_-_Two_Lawyers_Conversing_-_Google_Art_Project.jpg",
      width: 5968,
      height: 4613,
    },
    {
      title: "Honoré Daumier - Man under lock and key - A-2002-174 - Finnish National Gallery.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6c/Honor%C3%A9_Daumier_-_Man_under_lock_and_key_-_A-2002-174_-_Finnish_National_Gallery.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6c/Honor%C3%A9_Daumier_-_Man_under_lock_and_key_-_A-2002-174_-_Finnish_National_Gallery.jpg/1233px-Honor%C3%A9_Daumier_-_Man_under_lock_and_key_-_A-2002-174_-_Finnish_National_Gallery.jpg",
      width: 1233,
      height: 1621,
    },
    {
      title: "MEMBRES D'UNE SOCIÉTÉ D'HORTICULTURE.PNG",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a9/MEMBRES_D%27UNE_SOCI%C3%89T%C3%89_D%27HORTICULTURE.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a9/MEMBRES_D%27UNE_SOCI%C3%89T%C3%89_D%27HORTICULTURE.PNG",
      width: 547,
      height: 670,
    },
    {
      title: "TÊTE D'HOMME Honoré Daumier.PNG",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d3/T%C3%8ATE_D%27HOMME_Honor%C3%A9_Daumier.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d3/T%C3%8ATE_D%27HOMME_Honor%C3%A9_Daumier.PNG",
      width: 943,
      height: 422,
    },
    {
      title: "Honoré Daumier TÊTE DE FEMME.PNG",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/52/Honor%C3%A9_Daumier_T%C3%8ATE_DE_FEMME.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/5/52/Honor%C3%A9_Daumier_T%C3%8ATE_DE_FEMME.PNG",
      width: 703,
      height: 672,
    },
    {
      title: "AVANT L'AUDIENCE (UNE CAUSE CRIMINELLE PLAIDEUR ET AVOCAT).PNG",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/de/AVANT_L%27AUDIENCE_%28UNE_CAUSE_CRIMINELLE_PLAIDEUR_ET_AVOCAT%29.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/de/AVANT_L%27AUDIENCE_%28UNE_CAUSE_CRIMINELLE_PLAIDEUR_ET_AVOCAT%29.PNG",
      width: 709,
      height: 671,
    },
    {
      title: "QUATRE PERSONNAGES - RECTO .PNG",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ea/QUATRE_PERSONNAGES_-_RECTO_.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/ea/QUATRE_PERSONNAGES_-_RECTO_.PNG",
      width: 942,
      height: 448,
    },
    {
      title: "HOMME ASSIS DANS UN FAUTEUIL.PNG",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f8/HOMME_ASSIS_DANS_UN_FAUTEUIL.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f8/HOMME_ASSIS_DANS_UN_FAUTEUIL.PNG",
      width: 588,
      height: 672,
    },
    {
      title: "Three Attentive Spectators by Honore Daumier, pen and ink with watercolor.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/64/Three_Attentive_Spectators_by_Honore_Daumier%2C_pen_and_ink_with_watercolor.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/64/Three_Attentive_Spectators_by_Honore_Daumier%2C_pen_and_ink_with_watercolor.jpg",
      width: 793,
      height: 640,
    },
    {
      title: "Lezende man, SK-A-3660.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Lezende_man%2C_SK-A-3660.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Lezende_man%2C_SK-A-3660.jpg/1280px-Lezende_man%2C_SK-A-3660.jpg",
      width: 5384,
      height: 4258,
    },
    {
      title: "Daumier - DR9002.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/0c/Daumier_-_DR9002.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/0/0c/Daumier_-_DR9002.jpg",
      width: 674,
      height: 1000,
    },
    {
      title: "Daumier - Pause im Théâtre Français, um 1865.png",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7c/Daumier_-_Pause_im_Th%C3%A9%C3%A2tre_Fran%C3%A7ais%2C_um_1865.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/7c/Daumier_-_Pause_im_Th%C3%A9%C3%A2tre_Fran%C3%A7ais%2C_um_1865.png",
      width: 564,
      height: 433,
    },
    {
      title: "Daumier - Камиль Демулен в Пале-Рояле. Около 1850 г.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Daumier_-_%D0%9A%D0%B0%D0%BC%D0%B8%D0%BB%D1%8C_%D0%94%D0%B5%D0%BC%D1%83%D0%BB%D0%B5%D0%BD_%D0%B2_%D0%9F%D0%B0%D0%BB%D0%B5-%D0%A0%D0%BE%D1%8F%D0%BB%D0%B5._%D0%9E%D0%BA%D0%BE%D0%BB%D0%BE_1850_%D0%B3.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f7/Daumier_-_%D0%9A%D0%B0%D0%BC%D0%B8%D0%BB%D1%8C_%D0%94%D0%B5%D0%BC%D1%83%D0%BB%D0%B5%D0%BD_%D0%B2_%D0%9F%D0%B0%D0%BB%D0%B5-%D0%A0%D0%BE%D1%8F%D0%BB%D0%B5._%D0%9E%D0%BA%D0%BE%D0%BB%D0%BE_1850_%D0%B3.jpg",
      width: 974,
      height: 1200,
    },
    {
      title: "Daumier - The Saltimbanques Changing Place, 1928.273, c. 1865.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Daumier_-_The_Saltimbanques_Changing_Place%2C_1928.273%2C_c._1865.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Daumier_-_The_Saltimbanques_Changing_Place%2C_1928.273%2C_c._1865.jpg",
      width: 789,
      height: 1000,
    },
    {
      title: "Daumier - Studie eines Ringers, 24127, um 1852.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/76/Daumier_-_Studie_eines_Ringers%2C_24127%2C_um_1852.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/76/Daumier_-_Studie_eines_Ringers%2C_24127%2C_um_1852.jpg",
      width: 850,
      height: 1181,
    },
    {
      title: "Daumier - L'avocat et son client, SZ Daumier 1, um 1854 - 1856.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/74/Daumier_-_L%27avocat_et_son_client%2C_SZ_Daumier_1%2C_um_1854_-_1856.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Daumier_-_L%27avocat_et_son_client%2C_SZ_Daumier_1%2C_um_1854_-_1856.jpg/1280px-Daumier_-_L%27avocat_et_son_client%2C_SZ_Daumier_1%2C_um_1854_-_1856.jpg",
      width: 3312,
      height: 4000,
    },
    {
      title: "Daumier - Three Lawyers Conversing, 1955.1499, c. 1862–65.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ab/Daumier_-_Three_Lawyers_Conversing%2C_1955.1499%2C_c._1862%E2%80%9365.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Daumier_-_Three_Lawyers_Conversing%2C_1955.1499%2C_c._1862%E2%80%9365.jpg/1224px-Daumier_-_Three_Lawyers_Conversing%2C_1955.1499%2C_c._1862%E2%80%9365.jpg",
      width: 1224,
      height: 1600,
    },
    {
      title: "Daumier - Don Quixote and Sancho Panza, 42.208, 1865-1867.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/58/Daumier_-_Don_Quixote_and_Sancho_Panza%2C_42.208%2C_1865-1867.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/5/58/Daumier_-_Don_Quixote_and_Sancho_Panza%2C_42.208%2C_1865-1867.jpg",
      width: 1024,
      height: 533,
    },
    {
      title: "Daumier - The Three Connoisseurs, 1968.1, after 1869.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b5/Daumier_-_The_Three_Connoisseurs%2C_1968.1%2C_after_1869.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/Daumier_-_The_Three_Connoisseurs%2C_1968.1%2C_after_1869.jpg/1280px-Daumier_-_The_Three_Connoisseurs%2C_1968.1%2C_after_1869.jpg",
      width: 2311,
      height: 3000,
    },
    {
      title: "Daumier - Un wagon de troisième classe, 5635712.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/17/Daumier_-_Un_wagon_de_troisi%C3%A8me_classe%2C_5635712.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/17/Daumier_-_Un_wagon_de_troisi%C3%A8me_classe%2C_5635712.jpg/1280px-Daumier_-_Un_wagon_de_troisi%C3%A8me_classe%2C_5635712.jpg",
      width: 3200,
      height: 2321,
    },
    {
      title: "Daumier - Avant l'audience, circa 1868-1870, 5893271.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b7/Daumier_-_Avant_l%27audience%2C_circa_1868-1870%2C_5893271.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Daumier_-_Avant_l%27audience%2C_circa_1868-1870%2C_5893271.jpg/1280px-Daumier_-_Avant_l%27audience%2C_circa_1868-1870%2C_5893271.jpg",
      width: 2430,
      height: 3200,
    },
    {
      title: "Daumier - A page playing the mandolin, study for the painting 'Le Troubadour' in the Cleveland Museum of Art. c.1868-73, 1923,1016.1.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e7/Daumier_-_A_page_playing_the_mandolin%2C_study_for_the_painting_%27Le_Troubadour%27_in_the_Cleveland_Museum_of_Art._c.1868-73%2C_1923%2C1016.1.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Daumier_-_A_page_playing_the_mandolin%2C_study_for_the_painting_%27Le_Troubadour%27_in_the_Cleveland_Museum_of_Art._c.1868-73%2C_1923%2C1016.1.jpg/1280px-Daumier_-_A_page_playing_the_mandolin%2C_study_for_the_painting_%27Le_Troubadour%27_in_the_Cleveland_Museum_of_Art._c.1868-73%2C_1923%2C1016.1.jpg",
      width: 1685,
      height: 2500,
    },
    {
      title: "DAUMIER Chemin de fer - Impressions et compressions de voyage.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/89/DAUMIER_Chemin_de_fer_-_Impressions_et_compressions_de_voyage.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/DAUMIER_Chemin_de_fer_-_Impressions_et_compressions_de_voyage.jpg/1280px-DAUMIER_Chemin_de_fer_-_Impressions_et_compressions_de_voyage.jpg",
      width: 4590,
      height: 3719,
    },
    {
      title: "Honoré Daumier - Girardins begravning - NMH 50-1952 - Nationalmuseum.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/17/Honor%C3%A9_Daumier_-_Girardins_begravning_-_NMH_50-1952_-_Nationalmuseum.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/1/17/Honor%C3%A9_Daumier_-_Girardins_begravning_-_NMH_50-1952_-_Nationalmuseum.jpg",
      width: 1000,
      height: 706,
    },
    {
      title: "Honoré Daumier - Den fina årgången - NMH 229-1979 - Nationalmuseum.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Honor%C3%A9_Daumier_-_Den_fina_%C3%A5rg%C3%A5ngen_-_NMH_229-1979_-_Nationalmuseum.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/3c/Honor%C3%A9_Daumier_-_Den_fina_%C3%A5rg%C3%A5ngen_-_NMH_229-1979_-_Nationalmuseum.jpg",
      width: 1000,
      height: 778,
    },
    {
      title: "Honoré Daumier - Au théâtre (Musée Calvet).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a1/Honor%C3%A9_Daumier_-_Au_th%C3%A9%C3%A2tre_%28Mus%C3%A9e_Calvet%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/a1/Honor%C3%A9_Daumier_-_Au_th%C3%A9%C3%A2tre_%28Mus%C3%A9e_Calvet%29.jpg",
      width: 800,
      height: 533,
    },
    {
      title: "Honoré Daumier - Don Quichotte et Sancho Pança (Musée Calvet).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e1/Honor%C3%A9_Daumier_-_Don_Quichotte_et_Sancho_Pan%C3%A7a_%28Mus%C3%A9e_Calvet%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/e1/Honor%C3%A9_Daumier_-_Don_Quichotte_et_Sancho_Pan%C3%A7a_%28Mus%C3%A9e_Calvet%29.jpg",
      width: 800,
      height: 591,
    },
    {
      title: "In the Omnibus, Honoré Daumier.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4e/In_the_Omnibus%2C_Honor%C3%A9_Daumier.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/In_the_Omnibus%2C_Honor%C3%A9_Daumier.jpg/1240px-In_the_Omnibus%2C_Honor%C3%A9_Daumier.jpg",
      width: 1240,
      height: 893,
    },
    {
      title: "In the Omnibus, Honoré Daumier (cropped).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b7/In_the_Omnibus%2C_Honor%C3%A9_Daumier_%28cropped%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/b/b7/In_the_Omnibus%2C_Honor%C3%A9_Daumier_%28cropped%29.jpg",
      width: 1001,
      height: 503,
    },
    {
      title: "Daumier Register Number 1379.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/80/Daumier_Register_Number_1379.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/80/Daumier_Register_Number_1379.jpg",
      width: 766,
      height: 1000,
    },
    {
      title: "8 heures du matin, BAL2002.182.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/98/8_heures_du_matin%2C_BAL2002.182.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/98/8_heures_du_matin%2C_BAL2002.182.jpg/1280px-8_heures_du_matin%2C_BAL2002.182.jpg",
      width: 4386,
      height: 6211,
    },
    {
      title: "8 heures du matin, BAL2002.182(2).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ec/8_heures_du_matin%2C_BAL2002.182%282%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ec/8_heures_du_matin%2C_BAL2002.182%282%29.jpg/1280px-8_heures_du_matin%2C_BAL2002.182%282%29.jpg",
      width: 5004,
      height: 3291,
    },
    {
      title: "Tenue de canicule. 3, G.2338.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e0/Tenue_de_canicule._3%2C_G.2338.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Tenue_de_canicule._3%2C_G.2338.jpg/1280px-Tenue_de_canicule._3%2C_G.2338.jpg",
      width: 3864,
      height: 4888,
    },
    {
      title: "Tenue de canicule. 3, G.2338(2).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e1/Tenue_de_canicule._3%2C_G.2338%282%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/Tenue_de_canicule._3%2C_G.2338%282%29.jpg/1280px-Tenue_de_canicule._3%2C_G.2338%282%29.jpg",
      width: 4356,
      height: 5755,
    },
    {
      title: "Tenue de canicule. 3, G.2338(3).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a8/Tenue_de_canicule._3%2C_G.2338%283%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a8/Tenue_de_canicule._3%2C_G.2338%283%29.jpg/1280px-Tenue_de_canicule._3%2C_G.2338%283%29.jpg",
      width: 4303,
      height: 5742,
    },
    {
      title: "Le Charivari, trente-quatrième année, jeudi 22 juin 1865, 2018.0.1036(3).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6f/Le_Charivari%2C_trente-quatri%C3%A8me_ann%C3%A9e%2C_jeudi_22_juin_1865%2C_2018.0.1036%283%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Le_Charivari%2C_trente-quatri%C3%A8me_ann%C3%A9e%2C_jeudi_22_juin_1865%2C_2018.0.1036%283%29.jpg/1280px-Le_Charivari%2C_trente-quatri%C3%A8me_ann%C3%A9e%2C_jeudi_22_juin_1865%2C_2018.0.1036%283%29.jpg",
      width: 3780,
      height: 5291,
    },
    {
      title: "Daumier - DR10263.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Daumier_-_DR10263.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Daumier_-_DR10263.jpg",
      width: 706,
      height: 981,
    },
    {
      title: "Actualités C'est signulier rien ne reprend à la bourse. G.3299(1).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/91/Actualit%C3%A9s_C%27est_signulier_rien_ne_reprend_%C3%A0_la_bourse._G.3299%281%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Actualit%C3%A9s_C%27est_signulier_rien_ne_reprend_%C3%A0_la_bourse._G.3299%281%29.jpg/1280px-Actualit%C3%A9s_C%27est_signulier_rien_ne_reprend_%C3%A0_la_bourse._G.3299%281%29.jpg",
      width: 5928,
      height: 4311,
    },
    {
      title: "Actualités Chacun son tour, G.3018(1).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f0/Actualit%C3%A9s_Chacun_son_tour%2C_G.3018%281%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Actualit%C3%A9s_Chacun_son_tour%2C_G.3018%281%29.jpg/1280px-Actualit%C3%A9s_Chacun_son_tour%2C_G.3018%281%29.jpg",
      width: 5201,
      height: 4797,
    },
    {
      title: "Actualités - Quelle horrible chose. si nous avons la guerre. G.3316(1).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/af/Actualit%C3%A9s_-_Quelle_horrible_chose._si_nous_avons_la_guerre._G.3316%281%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Actualit%C3%A9s_-_Quelle_horrible_chose._si_nous_avons_la_guerre._G.3316%281%29.jpg/1280px-Actualit%C3%A9s_-_Quelle_horrible_chose._si_nous_avons_la_guerre._G.3316%281%29.jpg",
      width: 5739,
      height: 4328,
    },
    {
      title: "Honoré Daumier - Caricatura de dois caçadores (2).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/40/Honor%C3%A9_Daumier_-_Caricatura_de_dois_ca%C3%A7adores_%282%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/Honor%C3%A9_Daumier_-_Caricatura_de_dois_ca%C3%A7adores_%282%29.jpg/1280px-Honor%C3%A9_Daumier_-_Caricatura_de_dois_ca%C3%A7adores_%282%29.jpg",
      width: 4926,
      height: 3531,
    },
    {
      title: "Don Quixote in the Moonlight - Honoré Daumier (Kunstmuseum Basel).jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Don_Quixote_in_the_Moonlight_-_Honor%C3%A9_Daumier_%28Kunstmuseum_Basel%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/Don_Quixote_in_the_Moonlight_-_Honor%C3%A9_Daumier_%28Kunstmuseum_Basel%29.jpg/1280px-Don_Quixote_in_the_Moonlight_-_Honor%C3%A9_Daumier_%28Kunstmuseum_Basel%29.jpg",
      width: 2963,
      height: 2261,
    },
    {
      title: "Collectors at the Salle Drouot - Honoré Daumier - Rhode Island School of Design Museum 22.268A.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/aa/Collectors_at_the_Salle_Drouot_-_Honor%C3%A9_Daumier_-_Rhode_Island_School_of_Design_Museum_22.268A.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Collectors_at_the_Salle_Drouot_-_Honor%C3%A9_Daumier_-_Rhode_Island_School_of_Design_Museum_22.268A.jpg/1280px-Collectors_at_the_Salle_Drouot_-_Honor%C3%A9_Daumier_-_Rhode_Island_School_of_Design_Museum_22.268A.jpg",
      width: 1882,
      height: 1617,
    },
    {
      title: "Tenue de canicule - DPLA - f77dee78702a9fb1b2f7e208ecfe6c56.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/55/Tenue_de_canicule_-_DPLA_-_f77dee78702a9fb1b2f7e208ecfe6c56.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Tenue_de_canicule_-_DPLA_-_f77dee78702a9fb1b2f7e208ecfe6c56.jpg/1280px-Tenue_de_canicule_-_DPLA_-_f77dee78702a9fb1b2f7e208ecfe6c56.jpg",
      width: 3487,
      height: 5175,
    },
    {
      title: "1996.48.18683 Daumier 'The Bathers'.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/84/1996.48.18683_Daumier_%27The_Bathers%27.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/84/1996.48.18683_Daumier_%27The_Bathers%27.jpg",
      width: 712,
      height: 800,
    },
    {
      title: "1996.48.18685 Daumier 'The Grand Staircase of the Palace of Justice'.jpg",
      artist: "Honoré Daumier",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/dc/1996.48.18685_Daumier_%27The_Grand_Staircase_of_the_Palace_of_Justice%27.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/dc/1996.48.18685_Daumier_%27The_Grand_Staircase_of_the_Palace_of_Justice%27.jpg",
      width: 598,
      height: 800,
    },
  ],
};

export const EDGAR_DEGAS_DRAWINGS: ArtistCollection = {
  artist: "Edgar Degas",
  deathYear: 1917,
  publicDomainStatus: "Public domain - artist died 1917 (>109 years ago)",
  works: [
    {
      title: "Degas - Amazone, de dos, RF 5603, Recto.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/73/Degas_-_Amazone%2C_de_dos%2C_RF_5603%2C_Recto.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/73/Degas_-_Amazone%2C_de_dos%2C_RF_5603%2C_Recto.jpg",
      width: 493,
      height: 768,
    },
    {
      title: "Degas - Annotations chiffrées, RF 41577, Verso.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/0f/Degas_-_Annotations_chiffr%C3%A9es%2C_RF_41577%2C_Verso.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/0/0f/Degas_-_Annotations_chiffr%C3%A9es%2C_RF_41577%2C_Verso.jpg",
      width: 652,
      height: 768,
    },
    {
      title: "Degas - Ange volant, RF 43121, Recto.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/07/Degas_-_Ange_volant%2C_RF_43121%2C_Recto.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/0/07/Degas_-_Ange_volant%2C_RF_43121%2C_Recto.jpg",
      width: 599,
      height: 768,
    },
    {
      title: "Degas - Archer vu de dos, en équilibre sur une marche (), RF 43120, Recto.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e9/Degas_-_Archer_vu_de_dos%2C_en_%C3%A9quilibre_sur_une_marche_%28%29%2C_RF_43120%2C_Recto.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/e9/Degas_-_Archer_vu_de_dos%2C_en_%C3%A9quilibre_sur_une_marche_%28%29%2C_RF_43120%2C_Recto.jpg",
      width: 541,
      height: 768,
    },
    {
      title: "Degas - Aveuglement d'Elymas, RF 43146, Recto.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Degas_-_Aveuglement_d%27Elymas%2C_RF_43146%2C_Recto.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Degas_-_Aveuglement_d%27Elymas%2C_RF_43146%2C_Recto.jpg",
      width: 538,
      height: 768,
    },
    {
      title: "Degas - Adoration of the Shepherds, 1969.374.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c9/Degas_-_Adoration_of_the_Shepherds%2C_1969.374.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c9/Degas_-_Adoration_of_the_Shepherds%2C_1969.374.jpg",
      width: 843,
      height: 1054,
    },
    {
      title: "Degas - A seated violinist seen from behind, WA1977.26.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e4/Degas_-_A_seated_violinist_seen_from_behind%2C_WA1977.26.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/e4/Degas_-_A_seated_violinist_seen_from_behind%2C_WA1977.26.jpg",
      width: 800,
      height: 1152,
    },
    {
      title: "Degas - Abstract Lines, 95.GD.35.29.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ab/Degas_-_Abstract_Lines%2C_95.GD.35.29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Degas_-_Abstract_Lines%2C_95.GD.35.29.jpg/1280px-Degas_-_Abstract_Lines%2C_95.GD.35.29.jpg",
      width: 3000,
      height: 2280,
    },
    {
      title: "Degas - An Album of Pencil Sketches, 95.GD.35.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f1/Degas_-_An_Album_of_Pencil_Sketches%2C_95.GD.35.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Degas_-_An_Album_of_Pencil_Sketches%2C_95.GD.35.jpg/1280px-Degas_-_An_Album_of_Pencil_Sketches%2C_95.GD.35.jpg",
      width: 3000,
      height: 2284,
    },
    {
      title: "Degas - Brothel Scene, 95.GD.35.14.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/91/Degas_-_Brothel_Scene%2C_95.GD.35.14.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Degas_-_Brothel_Scene%2C_95.GD.35.14.jpg/1280px-Degas_-_Brothel_Scene%2C_95.GD.35.14.jpg",
      width: 3000,
      height: 1159,
    },
    {
      title: "Degas - Brothel Scene, 95.GD.35.15.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/36/Degas_-_Brothel_Scene%2C_95.GD.35.15.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/36/Degas_-_Brothel_Scene%2C_95.GD.35.15.jpg/1280px-Degas_-_Brothel_Scene%2C_95.GD.35.15.jpg",
      width: 3000,
      height: 2277,
    },
    {
      title: "Degas - Brothel Scene, 95.GD.35.16.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4e/Degas_-_Brothel_Scene%2C_95.GD.35.16.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Degas_-_Brothel_Scene%2C_95.GD.35.16.jpg/1280px-Degas_-_Brothel_Scene%2C_95.GD.35.16.jpg",
      width: 3000,
      height: 2286,
    },
    {
      title: "Degas - Brothel Scene, 95.GD.35.17.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/30/Degas_-_Brothel_Scene%2C_95.GD.35.17.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/Degas_-_Brothel_Scene%2C_95.GD.35.17.jpg/1280px-Degas_-_Brothel_Scene%2C_95.GD.35.17.jpg",
      width: 3000,
      height: 2299,
    },
    {
      title: "Degas - Brothel Scene, 95.GD.35.18.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/12/Degas_-_Brothel_Scene%2C_95.GD.35.18.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Degas_-_Brothel_Scene%2C_95.GD.35.18.jpg/1280px-Degas_-_Brothel_Scene%2C_95.GD.35.18.jpg",
      width: 3000,
      height: 2292,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP102560.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c2/Album_of_Forty-five_Figure_Studies_MET_DP102560.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/Album_of_Forty-five_Figure_Studies_MET_DP102560.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP102560.jpg",
      width: 4000,
      height: 2600,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371809.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/84/Album_of_Forty-five_Figure_Studies_MET_DP371809.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/84/Album_of_Forty-five_Figure_Studies_MET_DP371809.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371809.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371810.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6a/Album_of_Forty-five_Figure_Studies_MET_DP371810.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Album_of_Forty-five_Figure_Studies_MET_DP371810.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371810.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371811.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f9/Album_of_Forty-five_Figure_Studies_MET_DP371811.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Album_of_Forty-five_Figure_Studies_MET_DP371811.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371811.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371812.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7a/Album_of_Forty-five_Figure_Studies_MET_DP371812.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Album_of_Forty-five_Figure_Studies_MET_DP371812.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371812.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371813.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/70/Album_of_Forty-five_Figure_Studies_MET_DP371813.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/70/Album_of_Forty-five_Figure_Studies_MET_DP371813.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371813.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371814.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/ff/Album_of_Forty-five_Figure_Studies_MET_DP371814.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Album_of_Forty-five_Figure_Studies_MET_DP371814.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371814.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371815.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/ce/Album_of_Forty-five_Figure_Studies_MET_DP371815.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/Album_of_Forty-five_Figure_Studies_MET_DP371815.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371815.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371816.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/67/Album_of_Forty-five_Figure_Studies_MET_DP371816.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Album_of_Forty-five_Figure_Studies_MET_DP371816.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371816.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371817.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a6/Album_of_Forty-five_Figure_Studies_MET_DP371817.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a6/Album_of_Forty-five_Figure_Studies_MET_DP371817.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371817.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371818.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/44/Album_of_Forty-five_Figure_Studies_MET_DP371818.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/44/Album_of_Forty-five_Figure_Studies_MET_DP371818.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371818.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371819.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/71/Album_of_Forty-five_Figure_Studies_MET_DP371819.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/Album_of_Forty-five_Figure_Studies_MET_DP371819.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371819.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371824.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6b/Album_of_Forty-five_Figure_Studies_MET_DP371824.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/Album_of_Forty-five_Figure_Studies_MET_DP371824.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371824.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371825.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ac/Album_of_Forty-five_Figure_Studies_MET_DP371825.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Album_of_Forty-five_Figure_Studies_MET_DP371825.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371825.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371826.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/74/Album_of_Forty-five_Figure_Studies_MET_DP371826.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/74/Album_of_Forty-five_Figure_Studies_MET_DP371826.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371826.jpg",
      width: 3190,
      height: 3874,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371827.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1e/Album_of_Forty-five_Figure_Studies_MET_DP371827.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Album_of_Forty-five_Figure_Studies_MET_DP371827.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371827.jpg",
      width: 3204,
      height: 3873,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371828.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Album_of_Forty-five_Figure_Studies_MET_DP371828.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cc/Album_of_Forty-five_Figure_Studies_MET_DP371828.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371828.jpg",
      width: 3216,
      height: 3869,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371829.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/da/Album_of_Forty-five_Figure_Studies_MET_DP371829.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Album_of_Forty-five_Figure_Studies_MET_DP371829.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371829.jpg",
      width: 3217,
      height: 3869,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371830.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/9e/Album_of_Forty-five_Figure_Studies_MET_DP371830.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/Album_of_Forty-five_Figure_Studies_MET_DP371830.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371830.jpg",
      width: 3216,
      height: 3869,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371831.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/47/Album_of_Forty-five_Figure_Studies_MET_DP371831.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/47/Album_of_Forty-five_Figure_Studies_MET_DP371831.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371831.jpg",
      width: 3240,
      height: 3869,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371832.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e4/Album_of_Forty-five_Figure_Studies_MET_DP371832.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e4/Album_of_Forty-five_Figure_Studies_MET_DP371832.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371832.jpg",
      width: 3240,
      height: 3869,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371833.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f0/Album_of_Forty-five_Figure_Studies_MET_DP371833.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f0/Album_of_Forty-five_Figure_Studies_MET_DP371833.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371833.jpg",
      width: 3327,
      height: 4000,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371834.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/20/Album_of_Forty-five_Figure_Studies_MET_DP371834.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/Album_of_Forty-five_Figure_Studies_MET_DP371834.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371834.jpg",
      width: 3208,
      height: 3870,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371835.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/dc/Album_of_Forty-five_Figure_Studies_MET_DP371835.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/Album_of_Forty-five_Figure_Studies_MET_DP371835.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371835.jpg",
      width: 3224,
      height: 3869,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371836.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e0/Album_of_Forty-five_Figure_Studies_MET_DP371836.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e0/Album_of_Forty-five_Figure_Studies_MET_DP371836.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371836.jpg",
      width: 3201,
      height: 3870,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP371837.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Album_of_Forty-five_Figure_Studies_MET_DP371837.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Album_of_Forty-five_Figure_Studies_MET_DP371837.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP371837.jpg",
      width: 3215,
      height: 3869,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP372898.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ef/Album_of_Forty-five_Figure_Studies_MET_DP372898.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/ef/Album_of_Forty-five_Figure_Studies_MET_DP372898.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP372898.jpg",
      width: 3081,
      height: 3884,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP372899.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/78/Album_of_Forty-five_Figure_Studies_MET_DP372899.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Album_of_Forty-five_Figure_Studies_MET_DP372899.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP372899.jpg",
      width: 3067,
      height: 3884,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP372900.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/2e/Album_of_Forty-five_Figure_Studies_MET_DP372900.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2e/Album_of_Forty-five_Figure_Studies_MET_DP372900.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP372900.jpg",
      width: 3095,
      height: 3883,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP372901.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/43/Album_of_Forty-five_Figure_Studies_MET_DP372901.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/Album_of_Forty-five_Figure_Studies_MET_DP372901.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP372901.jpg",
      width: 3092,
      height: 3883,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP372902.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f1/Album_of_Forty-five_Figure_Studies_MET_DP372902.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Album_of_Forty-five_Figure_Studies_MET_DP372902.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP372902.jpg",
      width: 3078,
      height: 3884,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP372903.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Album_of_Forty-five_Figure_Studies_MET_DP372903.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Album_of_Forty-five_Figure_Studies_MET_DP372903.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP372903.jpg",
      width: 3063,
      height: 3884,
    },
    {
      title: "Album of Forty-five Figure Studies MET DP372904.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7b/Album_of_Forty-five_Figure_Studies_MET_DP372904.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Album_of_Forty-five_Figure_Studies_MET_DP372904.jpg/1280px-Album_of_Forty-five_Figure_Studies_MET_DP372904.jpg",
      width: 3092,
      height: 3883,
    },
    {
      title: "Degas - A Young Woman Reclining in a Chair, 1965.252.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/09/Degas_-_A_Young_Woman_Reclining_in_a_Chair%2C_1965.252.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/0/09/Degas_-_A_Young_Woman_Reclining_in_a_Chair%2C_1965.252.jpg",
      width: 1024,
      height: 527,
    },
    {
      title: "Degas - At the Louvre The Etruscan Sarcophagus, 1971.36.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1a/Degas_-_At_the_Louvre_The_Etruscan_Sarcophagus%2C_1971.36.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1a/Degas_-_At_the_Louvre_The_Etruscan_Sarcophagus%2C_1971.36.jpg/1280px-Degas_-_At_the_Louvre_The_Etruscan_Sarcophagus%2C_1971.36.jpg",
      width: 1600,
      height: 1074,
    },
    {
      title: "Degas - Détails d'armure, RF 15498, Verso.jpg",
      artist: "Edgar Degas",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/2e/Degas_-_D%C3%A9tails_d%27armure%2C_RF_15498%2C_Verso.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/2/2e/Degas_-_D%C3%A9tails_d%27armure%2C_RF_15498%2C_Verso.jpg",
      width: 505,
      height: 768,
    },
  ],
};

export const HENRI_DE_TOULOUSE_LAUTREC_DRAWINGS: ArtistCollection = {
  artist: "Henri de Toulouse-Lautrec",
  deathYear: 1901,
  publicDomainStatus: "Public domain - artist died 1901 (>125 years ago)",
  works: [
    {
      title: "Lautrec Carmen Gaudin.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f1/Lautrec_Carmen_Gaudin.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f1/Lautrec_Carmen_Gaudin.jpg",
      width: 750,
      height: 1170,
    },
    {
      title: "New Hat-Suzanne Valadon-Toulouse Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/20/New_Hat-Suzanne_Valadon-Toulouse_Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/20/New_Hat-Suzanne_Valadon-Toulouse_Lautrec.jpg/1280px-New_Hat-Suzanne_Valadon-Toulouse_Lautrec.jpg",
      width: 1949,
      height: 2288,
    },
    {
      title: "Henri de Toulouse-Lautrec - The Painter Before His Subject - Google Art Project.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/29/Henri_de_Toulouse-Lautrec_-_The_Painter_Before_His_Subject_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/29/Henri_de_Toulouse-Lautrec_-_The_Painter_Before_His_Subject_-_Google_Art_Project.jpg/1280px-Henri_de_Toulouse-Lautrec_-_The_Painter_Before_His_Subject_-_Google_Art_Project.jpg",
      width: 4001,
      height: 2476,
    },
    {
      title: "Henri de Toulouse-Lautrec - Head of a Man - Google Art Project.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b6/Henri_de_Toulouse-Lautrec_-_Head_of_a_Man_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Henri_de_Toulouse-Lautrec_-_Head_of_a_Man_-_Google_Art_Project.jpg/1280px-Henri_de_Toulouse-Lautrec_-_Head_of_a_Man_-_Google_Art_Project.jpg",
      width: 1540,
      height: 2401,
    },
    {
      title: "'At the Cirque Fernando' by Henri de Toulouse-Lautrec, Norton Simon Museum.JPG",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/30/%27At_the_Cirque_Fernando%27_by_Henri_de_Toulouse-Lautrec%2C_Norton_Simon_Museum.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/%27At_the_Cirque_Fernando%27_by_Henri_de_Toulouse-Lautrec%2C_Norton_Simon_Museum.JPG/1280px-%27At_the_Cirque_Fernando%27_by_Henri_de_Toulouse-Lautrec%2C_Norton_Simon_Museum.JPG",
      width: 2805,
      height: 2025,
    },
    {
      title: "Toulouse-Lautrec dessin - Jacques Saint-Cere.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/55/Toulouse-Lautrec_dessin_-_Jacques_Saint-Cere.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/5/55/Toulouse-Lautrec_dessin_-_Jacques_Saint-Cere.jpg",
      width: 541,
      height: 475,
    },
    {
      title: "CAFÉ-CONCERT À MONTMARTE.PNG",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c4/CAF%C3%89-CONCERT_%C3%80_MONTMARTE.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c4/CAF%C3%89-CONCERT_%C3%80_MONTMARTE.PNG",
      width: 540,
      height: 669,
    },
    {
      title: "CAVALIER - RECTO CROQUIS - VERSO.PNG",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/be/CAVALIER_-_RECTO_CROQUIS_-_VERSO.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/b/be/CAVALIER_-_RECTO_CROQUIS_-_VERSO.PNG",
      width: 888,
      height: 671,
    },
    {
      title: "Clevelandart 1952.113.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/9d/Clevelandart_1952.113.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Clevelandart_1952.113.jpg/1280px-Clevelandart_1952.113.jpg",
      width: 2831,
      height: 3400,
    },
    {
      title: "Anna Held et Baldy (1896) - H.T. Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/65/Anna_Held_et_Baldy_%281896%29_-_H.T._Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/65/Anna_Held_et_Baldy_%281896%29_-_H.T._Lautrec.jpg",
      width: 875,
      height: 1200,
    },
    {
      title: "Gueule de bois (Toulouse-Lautrec).jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/46/Gueule_de_bois_%28Toulouse-Lautrec%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/46/Gueule_de_bois_%28Toulouse-Lautrec%29.jpg/1280px-Gueule_de_bois_%28Toulouse-Lautrec%29.jpg",
      width: 4608,
      height: 3456,
    },
    {
      title: "Henri de toulouse-lautrec marin.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/35/Henri_de_toulouse-lautrec_marin.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/Henri_de_toulouse-lautrec_marin.jpg/1280px-Henri_de_toulouse-lautrec_marin.jpg",
      width: 1959,
      height: 3200,
    },
    {
      title: "(Albi) Musée Toulouse-Lautrec - Charge de Toulouse-Lautrec par lui-même vers 1894.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/aa/%28Albi%29_Mus%C3%A9e_Toulouse-Lautrec_-_Charge_de_Toulouse-Lautrec_par_lui-m%C3%AAme_vers_1894.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/%28Albi%29_Mus%C3%A9e_Toulouse-Lautrec_-_Charge_de_Toulouse-Lautrec_par_lui-m%C3%AAme_vers_1894.jpg/1280px-%28Albi%29_Mus%C3%A9e_Toulouse-Lautrec_-_Charge_de_Toulouse-Lautrec_par_lui-m%C3%AAme_vers_1894.jpg",
      width: 6240,
      height: 9440,
    },
    {
      title: "(Albi) Etude pour Le blanchisseur de la maison - Toulouse-Lautrec 1894 MTL.015.01.01.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/72/%28Albi%29_Etude_pour_Le_blanchisseur_de_la_maison_-_Toulouse-Lautrec_1894_MTL.015.01.01.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/%28Albi%29_Etude_pour_Le_blanchisseur_de_la_maison_-_Toulouse-Lautrec_1894_MTL.015.01.01.jpg/1280px-%28Albi%29_Etude_pour_Le_blanchisseur_de_la_maison_-_Toulouse-Lautrec_1894_MTL.015.01.01.jpg",
      width: 5504,
      height: 8256,
    },
    {
      title: "(Albi) Buste d'après un plâtre d'Antonio del Polaiuolo - Henri de Toulouse-Lautrec - Musée Toulouse-Lautrec D.33-162.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e8/%28Albi%29_Buste_d%27apr%C3%A8s_un_pl%C3%A2tre_d%27Antonio_del_Polaiuolo_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec_D.33-162.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/%28Albi%29_Buste_d%27apr%C3%A8s_un_pl%C3%A2tre_d%27Antonio_del_Polaiuolo_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec_D.33-162.jpg/1280px-%28Albi%29_Buste_d%27apr%C3%A8s_un_pl%C3%A2tre_d%27Antonio_del_Polaiuolo_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec_D.33-162.jpg",
      width: 4812,
      height: 6189,
    },
    {
      title: "(Albi) Torse du Belvédère d'après un plâtre Henri de Toulouse-Lautrec - Musée Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/06/%28Albi%29_Torse_du_Belv%C3%A9d%C3%A8re_d%27apr%C3%A8s_un_pl%C3%A2tre_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/06/%28Albi%29_Torse_du_Belv%C3%A9d%C3%A8re_d%27apr%C3%A8s_un_pl%C3%A2tre_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg/1280px-%28Albi%29_Torse_du_Belv%C3%A9d%C3%A8re_d%27apr%C3%A8s_un_pl%C3%A2tre_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      width: 4220,
      height: 5423,
    },
    {
      title: "Henri de Toulouse-Lautrec - Portrait d’homme (Musée Calvet).jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f3/Henri_de_Toulouse-Lautrec_-_Portrait_d%E2%80%99homme_%28Mus%C3%A9e_Calvet%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/f/f3/Henri_de_Toulouse-Lautrec_-_Portrait_d%E2%80%99homme_%28Mus%C3%A9e_Calvet%29.jpg",
      width: 439,
      height: 600,
    },
    {
      title: "(Albi) La Blanchisseuse 1888 - Toulouse-Lautrec - Musée Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4c/%28Albi%29_La_Blanchisseuse_1888_-_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/%28Albi%29_La_Blanchisseuse_1888_-_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg/1280px-%28Albi%29_La_Blanchisseuse_1888_-_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      width: 4505,
      height: 6023,
    },
    {
      title: "Henri de toulouse-lautrec a saint-lazare050842).jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/8b/Henri_de_toulouse-lautrec_a_saint-lazare050842%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/8b/Henri_de_toulouse-lautrec_a_saint-lazare050842%29.jpg/1280px-Henri_de_toulouse-lautrec_a_saint-lazare050842%29.jpg",
      width: 2665,
      height: 3200,
    },
    {
      title: "(Albi) Femme assis, de dos, vers la gauche - 1888 - Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/2a/%28Albi%29_Femme_assis%2C_de_dos%2C_vers_la_gauche_-_1888_-_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2a/%28Albi%29_Femme_assis%2C_de_dos%2C_vers_la_gauche_-_1888_-_Toulouse-Lautrec.jpg/1280px-%28Albi%29_Femme_assis%2C_de_dos%2C_vers_la_gauche_-_1888_-_Toulouse-Lautrec.jpg",
      width: 5210,
      height: 6614,
    },
    {
      title: "(Albi) Danseuse en savates, debout, de profil, dans les coulisses - 1887 - Henri de Toulouse-Lautrec - Musée Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/5b/%28Albi%29_Danseuse_en_savates%2C_debout%2C_de_profil%2C_dans_les_coulisses_-_1887_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5b/%28Albi%29_Danseuse_en_savates%2C_debout%2C_de_profil%2C_dans_les_coulisses_-_1887_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg/1280px-%28Albi%29_Danseuse_en_savates%2C_debout%2C_de_profil%2C_dans_les_coulisses_-_1887_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      width: 4134,
      height: 5318,
    },
    {
      title: "(Albi) Mademoiselle Béatrix Tapié de Céleyran, 1882, Henri de Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/00/%28Albi%29_Mademoiselle_B%C3%A9atrix_Tapi%C3%A9_de_C%C3%A9leyran%2C_1882%2C_Henri_de_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/00/%28Albi%29_Mademoiselle_B%C3%A9atrix_Tapi%C3%A9_de_C%C3%A9leyran%2C_1882%2C_Henri_de_Toulouse-Lautrec.jpg/1280px-%28Albi%29_Mademoiselle_B%C3%A9atrix_Tapi%C3%A9_de_C%C3%A9leyran%2C_1882%2C_Henri_de_Toulouse-Lautrec.jpg",
      width: 4017,
      height: 4845,
    },
    {
      title: "(Albi) La Trapéziste du cirque médrano - 1888 - Henri de Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a0/%28Albi%29_La_Trap%C3%A9ziste_du_cirque_m%C3%A9drano_-_1888_-_Henri_de_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a0/%28Albi%29_La_Trap%C3%A9ziste_du_cirque_m%C3%A9drano_-_1888_-_Henri_de_Toulouse-Lautrec.jpg/1280px-%28Albi%29_La_Trap%C3%A9ziste_du_cirque_m%C3%A9drano_-_1888_-_Henri_de_Toulouse-Lautrec.jpg",
      width: 4891,
      height: 7074,
    },
    {
      title: "(Albi) Les Grands Concerts de l'Opéra, Ambroise Thomas assistant à une répétition de Françoise de Rimini (1896) Henri de Toulouse-Lautrec - Musée Toulouse Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/03/%28Albi%29_Les_Grands_Concerts_de_l%27Op%C3%A9ra%2C_Ambroise_Thomas_assistant_%C3%A0_une_r%C3%A9p%C3%A9tition_de_Fran%C3%A7oise_de_Rimini_%281896%29_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse_Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/%28Albi%29_Les_Grands_Concerts_de_l%27Op%C3%A9ra%2C_Ambroise_Thomas_assistant_%C3%A0_une_r%C3%A9p%C3%A9tition_de_Fran%C3%A7oise_de_Rimini_%281896%29_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse_Lautrec.jpg/1280px-thumbnail.jpg",
      width: 4287,
      height: 5640,
    },
    {
      title: "(Albi) Six croquis de main sur une contrebasse (1893) - Henri de Toulouse-Lautrec - Musée Toulouse-Laurec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e8/%28Albi%29_Six_croquis_de_main_sur_une_contrebasse_%281893%29_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Laurec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/%28Albi%29_Six_croquis_de_main_sur_une_contrebasse_%281893%29_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Laurec.jpg/1280px-%28Albi%29_Six_croquis_de_main_sur_une_contrebasse_%281893%29_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Laurec.jpg",
      width: 8978,
      height: 7494,
    },
    {
      title: "(Albi) Danseuse, contrebasse et profil de femme (1896) - Henri de Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b2/%28Albi%29_Danseuse%2C_contrebasse_et_profil_de_femme_%281896%29_-_Henri_de_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/%28Albi%29_Danseuse%2C_contrebasse_et_profil_de_femme_%281896%29_-_Henri_de_Toulouse-Lautrec.jpg/1280px-%28Albi%29_Danseuse%2C_contrebasse_et_profil_de_femme_%281896%29_-_Henri_de_Toulouse-Lautrec.jpg",
      width: 6764,
      height: 8666,
    },
    {
      title: "(Albi) Procès Arton, Arton s'expliquant - 1896 - Henri de Toulouse-Lautrec - Musée Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b8/%28Albi%29_Proc%C3%A8s_Arton%2C_Arton_s%27expliquant_-_1896_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b8/%28Albi%29_Proc%C3%A8s_Arton%2C_Arton_s%27expliquant_-_1896_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg/1280px-%28Albi%29_Proc%C3%A8s_Arton%2C_Arton_s%27expliquant_-_1896_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      width: 6502,
      height: 4765,
    },
    {
      title: "(Albi) Cheval D.22 - c.1880 - Henri de Toulouse-Lautrec - Musée Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7d/%28Albi%29_Cheval_D.22_-_c.1880_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/%28Albi%29_Cheval_D.22_-_c.1880_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg/1280px-%28Albi%29_Cheval_D.22_-_c.1880_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      width: 5854,
      height: 4577,
    },
    {
      title: "(Albi) Le Jockey se rendant au poteau - Henri de Toulouse-Lautrec - Musée Toulouse-Lautrec.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4c/%28Albi%29_Le_Jockey_se_rendant_au_poteau_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/%28Albi%29_Le_Jockey_se_rendant_au_poteau_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg/1280px-%28Albi%29_Le_Jockey_se_rendant_au_poteau_-_Henri_de_Toulouse-Lautrec_-_Mus%C3%A9e_Toulouse-Lautrec.jpg",
      width: 5241,
      height: 7308,
    },
    {
      title: "Chronisten der Mode 1923 (140714592).jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/07/Chronisten_der_Mode_1923_%28140714592%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Chronisten_der_Mode_1923_%28140714592%29.jpg/1280px-Chronisten_der_Mode_1923_%28140714592%29.jpg",
      width: 3246,
      height: 4251,
    },
    {
      title: "Henri de Toulouse-Lautrec Gabriel Tapié et Maurice Guibert.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/da/Henri_de_Toulouse-Lautrec_Gabriel_Tapi%C3%A9_et_Maurice_Guibert.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Henri_de_Toulouse-Lautrec_Gabriel_Tapi%C3%A9_et_Maurice_Guibert.jpg/1280px-Henri_de_Toulouse-Lautrec_Gabriel_Tapi%C3%A9_et_Maurice_Guibert.jpg",
      width: 1795,
      height: 3000,
    },
    {
      title: "Henri de Toulouse-Lautrec - Au Cirque, ecuyere de haute école- Le Pointage.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6c/Henri_de_Toulouse-Lautrec_-_Au_Cirque%2C_ecuyere_de_haute_%C3%A9cole-_Le_Pointage.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/6c/Henri_de_Toulouse-Lautrec_-_Au_Cirque%2C_ecuyere_de_haute_%C3%A9cole-_Le_Pointage.jpg",
      width: 1103,
      height: 1742,
    },
    {
      title: "Henri de Toulouse-Lautrec Monsieur Sesti 1896.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/ff/Henri_de_Toulouse-Lautrec_Monsieur_Sesti_1896.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/ff/Henri_de_Toulouse-Lautrec_Monsieur_Sesti_1896.jpg/1280px-Henri_de_Toulouse-Lautrec_Monsieur_Sesti_1896.jpg",
      width: 5387,
      height: 3080,
    },
    {
      title: "Henri de Toulouse-Lautrec Yvette Guilbert portrait study.jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e3/Henri_de_Toulouse-Lautrec_Yvette_Guilbert_portrait_study.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e3/Henri_de_Toulouse-Lautrec_Yvette_Guilbert_portrait_study.jpg/1280px-Henri_de_Toulouse-Lautrec_Yvette_Guilbert_portrait_study.jpg",
      width: 2510,
      height: 3904,
    },
    {
      title: "Posters in miniature (IA postersinminiatu00poll) (page 245 crop).jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/26/Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_245_crop%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_245_crop%29.jpg/1280px-Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_245_crop%29.jpg",
      width: 1413,
      height: 2117,
    },
    {
      title: "Posters in miniature (IA postersinminiatu00poll) (page 246 crop).jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4e/Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_246_crop%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4e/Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_246_crop%29.jpg/1280px-Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_246_crop%29.jpg",
      width: 1413,
      height: 2117,
    },
    {
      title: "Posters in miniature (IA postersinminiatu00poll) (page 247 crop).jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f1/Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_247_crop%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f1/Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_247_crop%29.jpg/1280px-Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_247_crop%29.jpg",
      width: 1413,
      height: 2117,
    },
    {
      title: "Posters in miniature (IA postersinminiatu00poll) (page 248 crop).jpg",
      artist: "Henri de Toulouse-Lautrec",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/37/Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_248_crop%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/37/Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_248_crop%29.jpg/1280px-Posters_in_miniature_%28IA_postersinminiatu00poll%29_%28page_248_crop%29.jpg",
      width: 1413,
      height: 2117,
    },
  ],
};

export const K_THE_KOLLWITZ_DRAWINGS: ArtistCollection = {
  artist: "Käthe Kollwitz",
  deathYear: 1945,
  publicDomainStatus: "Public domain - artist died 1945 (>81 years ago)",
  works: [
    {
      title: "KAS-Familienpolitik-Bild-5909-1.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/75/KAS-Familienpolitik-Bild-5909-1.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/75/KAS-Familienpolitik-Bild-5909-1.jpg",
      width: 793,
      height: 1119,
    },
    {
      title: "Kollwitz TwoStudiesOfAWomansHead MIA 7165.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/fb/Kollwitz_TwoStudiesOfAWomansHead_MIA_7165.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Kollwitz_TwoStudiesOfAWomansHead_MIA_7165.jpg/1280px-Kollwitz_TwoStudiesOfAWomansHead_MIA_7165.jpg",
      width: 5000,
      height: 3444,
    },
    {
      title: "Käthe Kollwitz, Betende Frau (Femme en prière).jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d5/K%C3%A4the_Kollwitz%2C_Betende_Frau_%28Femme_en_pri%C3%A8re%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d5/K%C3%A4the_Kollwitz%2C_Betende_Frau_%28Femme_en_pri%C3%A8re%29.jpg",
      width: 811,
      height: 1000,
    },
    {
      title: "Käthe Kollwitz, Frau, Korb tragend (Femme portant un panier).jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/9a/K%C3%A4the_Kollwitz%2C_Frau%2C_Korb_tragend_%28Femme_portant_un_panier%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/9/9a/K%C3%A4the_Kollwitz%2C_Frau%2C_Korb_tragend_%28Femme_portant_un_panier%29.jpg",
      width: 465,
      height: 1000,
    },
    {
      title: "Käthe Kollwitz, Not (Misère).jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/72/K%C3%A4the_Kollwitz%2C_Not_%28Mis%C3%A8re%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/72/K%C3%A4the_Kollwitz%2C_Not_%28Mis%C3%A8re%29.jpg",
      width: 940,
      height: 1000,
    },
    {
      title: "Käthe Kollwitz Zeichnung.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f2/K%C3%A4the_Kollwitz_Zeichnung.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/K%C3%A4the_Kollwitz_Zeichnung.jpg/1280px-K%C3%A4the_Kollwitz_Zeichnung.jpg",
      width: 1737,
      height: 2294,
    },
    {
      title: "ZWEI STUDIEN EINER ARBEITERFRAU .PNG",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/ec/ZWEI_STUDIEN_EINER_ARBEITERFRAU_.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/ec/ZWEI_STUDIEN_EINER_ARBEITERFRAU_.PNG",
      width: 498,
      height: 671,
    },
    {
      title: "Dr. Carl Credé - Volk in Not. Das Unheil des Abtreibungsparagraphen.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/45/Dr._Carl_Cred%C3%A9_-_Volk_in_Not._Das_Unheil_des_Abtreibungsparagraphen.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/45/Dr._Carl_Cred%C3%A9_-_Volk_in_Not._Das_Unheil_des_Abtreibungsparagraphen.jpg",
      width: 1078,
      height: 1466,
    },
    {
      title: "Blätter der Piscatorbühne - Frauen in Not § 218, 1930.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cd/Bl%C3%A4tter_der_Piscatorb%C3%BChne_-_Frauen_in_Not_%C2%A7_218%2C_1930.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/cd/Bl%C3%A4tter_der_Piscatorb%C3%BChne_-_Frauen_in_Not_%C2%A7_218%2C_1930.jpg",
      width: 1024,
      height: 1507,
    },
    {
      title: "Käthe Kollwitz-Tête d'enfant endormi (1892).jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/18/K%C3%A4the_Kollwitz-T%C3%AAte_d%27enfant_endormi_%281892%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/18/K%C3%A4the_Kollwitz-T%C3%AAte_d%27enfant_endormi_%281892%29.jpg/1280px-K%C3%A4the_Kollwitz-T%C3%AAte_d%27enfant_endormi_%281892%29.jpg",
      width: 2680,
      height: 2141,
    },
    {
      title: "Käthe Kollwitz-Enfant endormi-1892.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a5/K%C3%A4the_Kollwitz-Enfant_endormi-1892.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/K%C3%A4the_Kollwitz-Enfant_endormi-1892.jpg/1280px-K%C3%A4the_Kollwitz-Enfant_endormi-1892.jpg",
      width: 2713,
      height: 1962,
    },
    {
      title: "Käthe Kollwitz-Scène de rue et tête d'enfant-1892.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/bf/K%C3%A4the_Kollwitz-Sc%C3%A8ne_de_rue_et_t%C3%AAte_d%27enfant-1892.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/bf/K%C3%A4the_Kollwitz-Sc%C3%A8ne_de_rue_et_t%C3%AAte_d%27enfant-1892.jpg/1280px-K%C3%A4the_Kollwitz-Sc%C3%A8ne_de_rue_et_t%C3%AAte_d%27enfant-1892.jpg",
      width: 3516,
      height: 2642,
    },
    {
      title: "Expo Käthe Kollwitz.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/11/Expo_K%C3%A4the_Kollwitz.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/11/Expo_K%C3%A4the_Kollwitz.jpg/1280px-Expo_K%C3%A4the_Kollwitz.jpg",
      width: 4128,
      height: 3096,
    },
    {
      title: "Expo Käthe Kollwitz - 49097569207.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d6/Expo_K%C3%A4the_Kollwitz_-_49097569207.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d6/Expo_K%C3%A4the_Kollwitz_-_49097569207.jpg/1280px-Expo_K%C3%A4the_Kollwitz_-_49097569207.jpg",
      width: 4128,
      height: 3096,
    },
    {
      title: "Unemployment (SM sg358z).png",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/75/Unemployment_%28SM_sg358z%29.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/75/Unemployment_%28SM_sg358z%29.png/1280px-Unemployment_%28SM_sg358z%29.png",
      width: 7925,
      height: 5948,
    },
    {
      title: "Sitzende Frau mit verschränkten Armen (SM sg3347z).png",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Sitzende_Frau_mit_verschr%C3%A4nkten_Armen_%28SM_sg3347z%29.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Sitzende_Frau_mit_verschr%C3%A4nkten_Armen_%28SM_sg3347z%29.png/1280px-Sitzende_Frau_mit_verschr%C3%A4nkten_Armen_%28SM_sg3347z%29.png",
      width: 6465,
      height: 9924,
    },
    {
      title: "Mann, Frau und kleines Kind (SM sg3348z).png",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/42/Mann%2C_Frau_und_kleines_Kind_%28SM_sg3348z%29.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/Mann%2C_Frau_und_kleines_Kind_%28SM_sg3348z%29.png/1280px-Mann%2C_Frau_und_kleines_Kind_%28SM_sg3348z%29.png",
      width: 5556,
      height: 7335,
    },
    {
      title: "Studienblatt- Liegender weiblicher Akt (SM sg358vz).png",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/60/Studienblatt-_Liegender_weiblicher_Akt_%28SM_sg358vz%29.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/Studienblatt-_Liegender_weiblicher_Akt_%28SM_sg358vz%29.png/1280px-Studienblatt-_Liegender_weiblicher_Akt_%28SM_sg358vz%29.png",
      width: 7942,
      height: 5983,
    },
    {
      title: "Mutter am Bett des toten Kindes (SM sg3346z).png",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/61/Mutter_am_Bett_des_toten_Kindes_%28SM_sg3346z%29.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Mutter_am_Bett_des_toten_Kindes_%28SM_sg3346z%29.png/1280px-Mutter_am_Bett_des_toten_Kindes_%28SM_sg3346z%29.png",
      width: 5748,
      height: 3524,
    },
    {
      title: "Frauen mit Kindern (Women with Children) .jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/22/Frauen_mit_Kindern_%28Women_with_Children%29_.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/2/22/Frauen_mit_Kindern_%28Women_with_Children%29_.jpg",
      width: 800,
      height: 1149,
    },
    {
      title: "Zeichnung zu Volks by Käthe Kollwitz, 1921.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/07/Zeichnung_zu_Volks_by_K%C3%A4the_Kollwitz%2C_1921.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/07/Zeichnung_zu_Volks_by_K%C3%A4the_Kollwitz%2C_1921.jpg/1280px-Zeichnung_zu_Volks_by_K%C3%A4the_Kollwitz%2C_1921.jpg",
      width: 3344,
      height: 3504,
    },
    {
      title: "Käthe-Kollwitz-Museum Berlin 07.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/2b/K%C3%A4the-Kollwitz-Museum_Berlin_07.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2b/K%C3%A4the-Kollwitz-Museum_Berlin_07.jpg/1280px-K%C3%A4the-Kollwitz-Museum_Berlin_07.jpg",
      width: 2952,
      height: 1816,
    },
    {
      title: "Käthe Kollwitz Im Profil 1910.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/34/K%C3%A4the_Kollwitz_Im_Profil_1910.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/K%C3%A4the_Kollwitz_Im_Profil_1910.jpg/1280px-K%C3%A4the_Kollwitz_Im_Profil_1910.jpg",
      width: 4732,
      height: 5993,
    },
    {
      title: "Käthe Kollwitz Schwangere 1920.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/14/K%C3%A4the_Kollwitz_Schwangere_1920.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/K%C3%A4the_Kollwitz_Schwangere_1920.jpg/1280px-K%C3%A4the_Kollwitz_Schwangere_1920.jpg",
      width: 5632,
      height: 7873,
    },
    {
      title: "Käthe Kollwitz Weiblicher Rückenakt c1904.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f3/K%C3%A4the_Kollwitz_Weiblicher_R%C3%BCckenakt_c1904.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f3/K%C3%A4the_Kollwitz_Weiblicher_R%C3%BCckenakt_c1904.jpg/1280px-K%C3%A4the_Kollwitz_Weiblicher_R%C3%BCckenakt_c1904.jpg",
      width: 3499,
      height: 5000,
    },
    {
      title: "Kupferstichkabinett (SMB) Käthe Kollwitz-Bauernkrieg 268561.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/ba/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_268561.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_268561.jpg/1280px-Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_268561.jpg",
      width: 3500,
      height: 2954,
    },
    {
      title: "Kupferstichkabinett (SMB) Käthe Kollwitz-Bauernkrieg 1920256.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/88/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_1920256.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/88/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_1920256.jpg/1280px-Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_1920256.jpg",
      width: 3500,
      height: 3009,
    },
    {
      title: "Kupferstichkabinett (SMB) Käthe Kollwitz-Bauernkrieg 1920260.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/65/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_1920260.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/65/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_1920260.jpg/1280px-Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_1920260.jpg",
      width: 3500,
      height: 3018,
    },
    {
      title: "Kupferstichkabinett (SMB) Käthe Kollwitz-Bauernkrieg 2268558.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_2268558.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_2268558.jpg/1280px-Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_2268558.jpg",
      width: 3500,
      height: 2986,
    },
    {
      title: "Kupferstichkabinett (SMB) Käthe Kollwitz-Bauernkrieg 2268562.jpg",
      artist: "Käthe Kollwitz",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/66/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_2268562.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/66/Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_2268562.jpg/1280px-Kupferstichkabinett_%28SMB%29_K%C3%A4the_Kollwitz-Bauernkrieg_2268562.jpg",
      width: 3500,
      height: 2689,
    },
  ],
};

export const HOKUSAI_DRAWINGS: ArtistCollection = {
  artist: "Hokusai",
  deathYear: 1849,
  publicDomainStatus: "Public domain - artist died 1849 (>177 years ago)",
  works: [
  ],
};

export const WILLIAM_BLAKE_DRAWINGS: ArtistCollection = {
  artist: "William Blake",
  deathYear: 1827,
  publicDomainStatus: "Public domain - artist died 1827 (>199 years ago)",
  works: [
    {
      title: "William Blake - Moses Receiving the Law - Google Art Project.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b4/William_Blake_-_Moses_Receiving_the_Law_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/William_Blake_-_Moses_Receiving_the_Law_-_Google_Art_Project.jpg/1280px-William_Blake_-_Moses_Receiving_the_Law_-_Google_Art_Project.jpg",
      width: 3545,
      height: 7645,
    },
    {
      title: "William Blake - Study for a Destroying Deity - Google Art Project.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b3/William_Blake_-_Study_for_a_Destroying_Deity_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/William_Blake_-_Study_for_a_Destroying_Deity_-_Google_Art_Project.jpg/1280px-William_Blake_-_Study_for_a_Destroying_Deity_-_Google_Art_Project.jpg",
      width: 7002,
      height: 5190,
    },
    {
      title: "Evening A23512.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/14/Evening_A23512.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/Evening_A23512.jpg/1271px-Evening_A23512.jpg",
      width: 1271,
      height: 4000,
    },
    {
      title: "William Blake, The Great Red Dragon and the Woman Clothed with the Sun, c. 1805, NGA 11502.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f7/William_Blake%2C_The_Great_Red_Dragon_and_the_Woman_Clothed_with_the_Sun%2C_c._1805%2C_NGA_11502.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f7/William_Blake%2C_The_Great_Red_Dragon_and_the_Woman_Clothed_with_the_Sun%2C_c._1805%2C_NGA_11502.jpg/1280px-William_Blake%2C_The_Great_Red_Dragon_and_the_Woman_Clothed_with_the_Sun%2C_c._1805%2C_NGA_11502.jpg",
      width: 3253,
      height: 4000,
    },
    {
      title: "William Blake after Henry Fuseli, Queen Katherine's Dream (recto), c. 1804, NGA 11500.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e6/William_Blake_after_Henry_Fuseli%2C_Queen_Katherine%27s_Dream_%28recto%29%2C_c._1804%2C_NGA_11500.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e6/William_Blake_after_Henry_Fuseli%2C_Queen_Katherine%27s_Dream_%28recto%29%2C_c._1804%2C_NGA_11500.jpg/1280px-William_Blake_after_Henry_Fuseli%2C_Queen_Katherine%27s_Dream_%28recto%29%2C_c._1804%2C_NGA_11500.jpg",
      width: 3174,
      height: 4000,
    },
    {
      title: "William Blake after John Linnell, Lady Torrens and Family, c. 1825, NGA 11522.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6f/William_Blake_after_John_Linnell%2C_Lady_Torrens_and_Family%2C_c._1825%2C_NGA_11522.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/William_Blake_after_John_Linnell%2C_Lady_Torrens_and_Family%2C_c._1825%2C_NGA_11522.jpg/1280px-William_Blake_after_John_Linnell%2C_Lady_Torrens_and_Family%2C_c._1825%2C_NGA_11522.jpg",
      width: 4000,
      height: 3258,
    },
    {
      title: "William Blake, \"And Saul Said unto David, Go, and the Lord be with Thee\" (recto), c. 1780-1785, NGA 4869.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/dc/William_Blake%2C_%22And_Saul_Said_unto_David%2C_Go%2C_and_the_Lord_be_with_Thee%22_%28recto%29%2C_c._1780-1785%2C_NGA_4869.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/dc/William_Blake%2C_%22And_Saul_Said_unto_David%2C_Go%2C_and_the_Lord_be_with_Thee%22_%28recto%29%2C_c._1780-1785%2C_NGA_4869.jpg/1280px-William_Blake%2C_%22And_Saul_Said_unto_David%2C_Go%2C_and_the_Lord_be_with_Thee%22_%28recto%29%2C_c._1780-1785%2C_NGA_4869.jpg",
      width: 4000,
      height: 2816,
    },
    {
      title: "William Blake, A Crouching Figure Holding a Shield (verso), probably c. 1793, NGA 33975.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/23/William_Blake%2C_A_Crouching_Figure_Holding_a_Shield_%28verso%29%2C_probably_c._1793%2C_NGA_33975.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/William_Blake%2C_A_Crouching_Figure_Holding_a_Shield_%28verso%29%2C_probably_c._1793%2C_NGA_33975.jpg/1280px-William_Blake%2C_A_Crouching_Figure_Holding_a_Shield_%28verso%29%2C_probably_c._1793%2C_NGA_33975.jpg",
      width: 2472,
      height: 4000,
    },
    {
      title: "William Blake, A Figure Ascending in a Glory of Clouds (?), probably c. 1805, NGA 11516.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b2/William_Blake%2C_A_Figure_Ascending_in_a_Glory_of_Clouds_%28%3F%29%2C_probably_c._1805%2C_NGA_11516.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/William_Blake%2C_A_Figure_Ascending_in_a_Glory_of_Clouds_%28%3F%29%2C_probably_c._1805%2C_NGA_11516.jpg/1280px-William_Blake%2C_A_Figure_Ascending_in_a_Glory_of_Clouds_%28%3F%29%2C_probably_c._1805%2C_NGA_11516.jpg",
      width: 3279,
      height: 4000,
    },
    {
      title: "William Blake, A Man Seen from Behind, Rising on Clouds, probably c. 1794, NGA 11511.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c4/William_Blake%2C_A_Man_Seen_from_Behind%2C_Rising_on_Clouds%2C_probably_c._1794%2C_NGA_11511.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/William_Blake%2C_A_Man_Seen_from_Behind%2C_Rising_on_Clouds%2C_probably_c._1794%2C_NGA_11511.jpg/1280px-William_Blake%2C_A_Man_Seen_from_Behind%2C_Rising_on_Clouds%2C_probably_c._1794%2C_NGA_11511.jpg",
      width: 4000,
      height: 2839,
    },
    {
      title: "William Blake, A Resurrection Scene (recto), c. 1805, NGA 4873.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/76/William_Blake%2C_A_Resurrection_Scene_%28recto%29%2C_c._1805%2C_NGA_4873.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/76/William_Blake%2C_A_Resurrection_Scene_%28recto%29%2C_c._1805%2C_NGA_4873.jpg/1280px-William_Blake%2C_A_Resurrection_Scene_%28recto%29%2C_c._1805%2C_NGA_4873.jpg",
      width: 2389,
      height: 4000,
    },
    {
      title: "William Blake, A Warring Angel (recto), c. 1780, NGA 11506.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/86/William_Blake%2C_A_Warring_Angel_%28recto%29%2C_c._1780%2C_NGA_11506.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/William_Blake%2C_A_Warring_Angel_%28recto%29%2C_c._1780%2C_NGA_11506.jpg/1280px-William_Blake%2C_A_Warring_Angel_%28recto%29%2C_c._1780%2C_NGA_11506.jpg",
      width: 4000,
      height: 2889,
    },
    {
      title: "William Blake, An Angel Teaching a Daughter of Men the Secrets of Sin, c. 1824-1827, NGA 30673.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/de/William_Blake%2C_An_Angel_Teaching_a_Daughter_of_Men_the_Secrets_of_Sin%2C_c._1824-1827%2C_NGA_30673.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/William_Blake%2C_An_Angel_Teaching_a_Daughter_of_Men_the_Secrets_of_Sin%2C_c._1824-1827%2C_NGA_30673.jpg/1280px-William_Blake%2C_An_Angel_Teaching_a_Daughter_of_Men_the_Secrets_of_Sin%2C_c._1824-1827%2C_NGA_30673.jpg",
      width: 2817,
      height: 4000,
    },
    {
      title: "William Blake, An Armed Man Spurning a Woman (recto), c. 1790-1795, NGA 11517.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1d/William_Blake%2C_An_Armed_Man_Spurning_a_Woman_%28recto%29%2C_c._1790-1795%2C_NGA_11517.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/William_Blake%2C_An_Armed_Man_Spurning_a_Woman_%28recto%29%2C_c._1790-1795%2C_NGA_11517.jpg/1280px-William_Blake%2C_An_Armed_Man_Spurning_a_Woman_%28recto%29%2C_c._1790-1795%2C_NGA_11517.jpg",
      width: 3094,
      height: 4000,
    },
    {
      title: "William Blake, An Ascending Spiral of Figures (recto), probably c. 1820, NGA 11519.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/19/William_Blake%2C_An_Ascending_Spiral_of_Figures_%28recto%29%2C_probably_c._1820%2C_NGA_11519.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/19/William_Blake%2C_An_Ascending_Spiral_of_Figures_%28recto%29%2C_probably_c._1820%2C_NGA_11519.jpg/1280px-William_Blake%2C_An_Ascending_Spiral_of_Figures_%28recto%29%2C_probably_c._1820%2C_NGA_11519.jpg",
      width: 2769,
      height: 4000,
    },
    {
      title: "William Blake, Christian with the Shield of Faith, Taking Leave of His Companions, 1824-1827, NGA 46312.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a2/William_Blake%2C_Christian_with_the_Shield_of_Faith%2C_Taking_Leave_of_His_Companions%2C_1824-1827%2C_NGA_46312.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/William_Blake%2C_Christian_with_the_Shield_of_Faith%2C_Taking_Leave_of_His_Companions%2C_1824-1827%2C_NGA_46312.jpg/1280px-William_Blake%2C_Christian_with_the_Shield_of_Faith%2C_Taking_Leave_of_His_Companions%2C_1824-1827%2C_NGA_46312.jpg",
      width: 2799,
      height: 4000,
    },
    {
      title: "William Blake, Enoch before the Great Glory, c. 1824-1827, NGA 30675.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/30/William_Blake%2C_Enoch_before_the_Great_Glory%2C_c._1824-1827%2C_NGA_30675.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/30/William_Blake%2C_Enoch_before_the_Great_Glory%2C_c._1824-1827%2C_NGA_30675.jpg/1280px-William_Blake%2C_Enoch_before_the_Great_Glory%2C_c._1824-1827%2C_NGA_30675.jpg",
      width: 2815,
      height: 4000,
    },
    {
      title: "William Blake, Group of Men Seated in a Circle (recto), c. 1780-1785, NGA 4871.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b3/William_Blake%2C_Group_of_Men_Seated_in_a_Circle_%28recto%29%2C_c._1780-1785%2C_NGA_4871.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/William_Blake%2C_Group_of_Men_Seated_in_a_Circle_%28recto%29%2C_c._1780-1785%2C_NGA_4871.jpg/1280px-William_Blake%2C_Group_of_Men_Seated_in_a_Circle_%28recto%29%2C_c._1780-1785%2C_NGA_4871.jpg",
      width: 4000,
      height: 3228,
    },
    {
      title: "William Blake, Job and His Daughters, c. 1821, NGA 11521.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/40/William_Blake%2C_Job_and_His_Daughters%2C_c._1821%2C_NGA_11521.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/William_Blake%2C_Job_and_His_Daughters%2C_c._1821%2C_NGA_11521.jpg/1280px-William_Blake%2C_Job_and_His_Daughters%2C_c._1821%2C_NGA_11521.jpg",
      width: 4000,
      height: 3175,
    },
    {
      title: "William Blake, Job and His Family Restored to Prosperity, 1821, NGA 11526.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/14/William_Blake%2C_Job_and_His_Family_Restored_to_Prosperity%2C_1821%2C_NGA_11526.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/14/William_Blake%2C_Job_and_His_Family_Restored_to_Prosperity%2C_1821%2C_NGA_11526.jpg/1280px-William_Blake%2C_Job_and_His_Family_Restored_to_Prosperity%2C_1821%2C_NGA_11526.jpg",
      width: 4000,
      height: 3354,
    },
    {
      title: "William Blake, John Linnell, 1825, NGA 11524.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/89/William_Blake%2C_John_Linnell%2C_1825%2C_NGA_11524.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/89/William_Blake%2C_John_Linnell%2C_1825%2C_NGA_11524.jpg/1280px-William_Blake%2C_John_Linnell%2C_1825%2C_NGA_11524.jpg",
      width: 2677,
      height: 4000,
    },
    {
      title: "William Blake, King Canute, c. 1819-1820, NGA 11504.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1e/William_Blake%2C_King_Canute%2C_c._1819-1820%2C_NGA_11504.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/William_Blake%2C_King_Canute%2C_c._1819-1820%2C_NGA_11504.jpg/1280px-William_Blake%2C_King_Canute%2C_c._1819-1820%2C_NGA_11504.jpg",
      width: 3111,
      height: 4000,
    },
    {
      title: "William Blake, King Edward, c. 1819, NGA 11505.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/de/William_Blake%2C_King_Edward%2C_c._1819%2C_NGA_11505.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/de/William_Blake%2C_King_Edward%2C_c._1819%2C_NGA_11505.jpg/1280px-William_Blake%2C_King_Edward%2C_c._1819%2C_NGA_11505.jpg",
      width: 3221,
      height: 4000,
    },
    {
      title: "William Blake, Los and His Spectre (verso), c. 1804-1807, NGA 11501.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d5/William_Blake%2C_Los_and_His_Spectre_%28verso%29%2C_c._1804-1807%2C_NGA_11501.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/William_Blake%2C_Los_and_His_Spectre_%28verso%29%2C_c._1804-1807%2C_NGA_11501.jpg/1280px-William_Blake%2C_Los_and_His_Spectre_%28verso%29%2C_c._1804-1807%2C_NGA_11501.jpg",
      width: 3265,
      height: 4000,
    },
    {
      title: "William Blake, Los Supporting the Sun (recto), probably c. 1793, NGA 33974.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7f/William_Blake%2C_Los_Supporting_the_Sun_%28recto%29%2C_probably_c._1793%2C_NGA_33974.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7f/William_Blake%2C_Los_Supporting_the_Sun_%28recto%29%2C_probably_c._1793%2C_NGA_33974.jpg/1280px-William_Blake%2C_Los_Supporting_the_Sun_%28recto%29%2C_probably_c._1793%2C_NGA_33974.jpg",
      width: 2866,
      height: 4000,
    },
    {
      title: "William Blake, Moses Staying the Plague (?) (recto), c. 1780-1785, NGA 4867.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1b/William_Blake%2C_Moses_Staying_the_Plague_%28%3F%29_%28recto%29%2C_c._1780-1785%2C_NGA_4867.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1b/William_Blake%2C_Moses_Staying_the_Plague_%28%3F%29_%28recto%29%2C_c._1780-1785%2C_NGA_4867.jpg/1280px-William_Blake%2C_Moses_Staying_the_Plague_%28%3F%29_%28recto%29%2C_c._1780-1785%2C_NGA_4867.jpg",
      width: 4000,
      height: 3194,
    },
    {
      title: "William Blake, Queen Katherine's Dream, c. 1825, NGA 11638.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d2/William_Blake%2C_Queen_Katherine%27s_Dream%2C_c._1825%2C_NGA_11638.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d2/William_Blake%2C_Queen_Katherine%27s_Dream%2C_c._1825%2C_NGA_11638.jpg/1280px-William_Blake%2C_Queen_Katherine%27s_Dream%2C_c._1825%2C_NGA_11638.jpg",
      width: 3372,
      height: 4000,
    },
    {
      title: "William Blake, Saint Augustine Converting King Ethelbert of Kent, probably c. 1793, NGA 11510.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/49/William_Blake%2C_Saint_Augustine_Converting_King_Ethelbert_of_Kent%2C_probably_c._1793%2C_NGA_11510.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/William_Blake%2C_Saint_Augustine_Converting_King_Ethelbert_of_Kent%2C_probably_c._1793%2C_NGA_11510.jpg/1280px-William_Blake%2C_Saint_Augustine_Converting_King_Ethelbert_of_Kent%2C_probably_c._1793%2C_NGA_11510.jpg",
      width: 4000,
      height: 2764,
    },
    {
      title: "William Blake, Sketch for the Title-Page of the Engraved Illustrations to the Book of Job, c. 1823-1826, NGA 11523.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e9/William_Blake%2C_Sketch_for_the_Title-Page_of_the_Engraved_Illustrations_to_the_Book_of_Job%2C_c._1823-1826%2C_NGA_11523.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/William_Blake%2C_Sketch_for_the_Title-Page_of_the_Engraved_Illustrations_to_the_Book_of_Job%2C_c._1823-1826%2C_NGA_11523.jpg/1280px-William_Blake%2C_Sketch_for_the_Title-Page_of_the_Engraved_Illustrations_to_the_Book_of_Job%2C_c._1823-1826%2C_NGA_11523.jpg",
      width: 3127,
      height: 4000,
    },
    {
      title: "William Blake, Sketch of a Swordsman Standing Over His Defeated Opponent (recto), c. 1780-1785, NGA 57830.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/60/William_Blake%2C_Sketch_of_a_Swordsman_Standing_Over_His_Defeated_Opponent_%28recto%29%2C_c._1780-1785%2C_NGA_57830.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/60/William_Blake%2C_Sketch_of_a_Swordsman_Standing_Over_His_Defeated_Opponent_%28recto%29%2C_c._1780-1785%2C_NGA_57830.jpg/1280px-William_Blake%2C_Sketch_of_a_Swordsman_Standing_Over_His_Defeated_Opponent_%28recto%29%2C_c._1780-1785%2C_NGA_57830.jpg",
      width: 4000,
      height: 2759,
    },
    {
      title: "William Blake, Sketch of a Swordsman Standing Over His Defeated Opponent (verso), c. 1780-1785, NGA 57831.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/35/William_Blake%2C_Sketch_of_a_Swordsman_Standing_Over_His_Defeated_Opponent_%28verso%29%2C_c._1780-1785%2C_NGA_57831.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/35/William_Blake%2C_Sketch_of_a_Swordsman_Standing_Over_His_Defeated_Opponent_%28verso%29%2C_c._1780-1785%2C_NGA_57831.jpg/1280px-William_Blake%2C_Sketch_of_a_Swordsman_Standing_Over_His_Defeated_Opponent_%28verso%29%2C_c._1780-1785%2C_NGA_57831.jpg",
      width: 4000,
      height: 2612,
    },
    {
      title: "William Blake, The Belvedere Torso (verso), probably c. 1779-1780, NGA 4868.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c1/William_Blake%2C_The_Belvedere_Torso_%28verso%29%2C_probably_c._1779-1780%2C_NGA_4868.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/William_Blake%2C_The_Belvedere_Torso_%28verso%29%2C_probably_c._1779-1780%2C_NGA_4868.jpg/1280px-William_Blake%2C_The_Belvedere_Torso_%28verso%29%2C_probably_c._1779-1780%2C_NGA_4868.jpg",
      width: 3201,
      height: 4000,
    },
    {
      title: "William Blake, The Daughter of Men Becomes a Siren, c. 1824-1827, NGA 30674.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a1/William_Blake%2C_The_Daughter_of_Men_Becomes_a_Siren%2C_c._1824-1827%2C_NGA_30674.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/William_Blake%2C_The_Daughter_of_Men_Becomes_a_Siren%2C_c._1824-1827%2C_NGA_30674.jpg/1280px-William_Blake%2C_The_Daughter_of_Men_Becomes_a_Siren%2C_c._1824-1827%2C_NGA_30674.jpg",
      width: 2822,
      height: 4000,
    },
    {
      title: "William Blake, The Death of Saint Joseph, 1803, NGA 72093.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/fa/William_Blake%2C_The_Death_of_Saint_Joseph%2C_1803%2C_NGA_72093.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fa/William_Blake%2C_The_Death_of_Saint_Joseph%2C_1803%2C_NGA_72093.jpg/1280px-William_Blake%2C_The_Death_of_Saint_Joseph%2C_1803%2C_NGA_72093.jpg",
      width: 3846,
      height: 4000,
    },
    {
      title: "William Blake, The Descent of Peace (recto), c. 1815, NGA 11514.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/ba/William_Blake%2C_The_Descent_of_Peace_%28recto%29%2C_c._1815%2C_NGA_11514.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/William_Blake%2C_The_Descent_of_Peace_%28recto%29%2C_c._1815%2C_NGA_11514.jpg/1280px-William_Blake%2C_The_Descent_of_Peace_%28recto%29%2C_c._1815%2C_NGA_11514.jpg",
      width: 2949,
      height: 4000,
    },
    {
      title: "William Blake, The Descent of the Angels to One of the Daughters of Men, c. 1824-1827, NGA 30672.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/43/William_Blake%2C_The_Descent_of_the_Angels_to_One_of_the_Daughters_of_Men%2C_c._1824-1827%2C_NGA_30672.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/43/William_Blake%2C_The_Descent_of_the_Angels_to_One_of_the_Daughters_of_Men%2C_c._1824-1827%2C_NGA_30672.jpg/1280px-William_Blake%2C_The_Descent_of_the_Angels_to_One_of_the_Daughters_of_Men%2C_c._1824-1827%2C_NGA_30672.jpg",
      width: 2824,
      height: 4000,
    },
    {
      title: "William Blake, The Ghost of Samuel Appearing to Saul, c. 1800, NGA 11498.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e1/William_Blake%2C_The_Ghost_of_Samuel_Appearing_to_Saul%2C_c._1800%2C_NGA_11498.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e1/William_Blake%2C_The_Ghost_of_Samuel_Appearing_to_Saul%2C_c._1800%2C_NGA_11498.jpg/1280px-William_Blake%2C_The_Ghost_of_Samuel_Appearing_to_Saul%2C_c._1800%2C_NGA_11498.jpg",
      width: 3711,
      height: 3444,
    },
    {
      title: "William Blake, The Great Red Dragon and the Beast from the Sea, c. 1805, NGA 11499.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/23/William_Blake%2C_The_Great_Red_Dragon_and_the_Beast_from_the_Sea%2C_c._1805%2C_NGA_11499.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/23/William_Blake%2C_The_Great_Red_Dragon_and_the_Beast_from_the_Sea%2C_c._1805%2C_NGA_11499.jpg/1280px-William_Blake%2C_The_Great_Red_Dragon_and_the_Beast_from_the_Sea%2C_c._1805%2C_NGA_11499.jpg",
      width: 3432,
      height: 3839,
    },
    {
      title: "William Blake, The Infant Hercules Throttling the Serpents, 1790-1793, NGA 11512.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/40/William_Blake%2C_The_Infant_Hercules_Throttling_the_Serpents%2C_1790-1793%2C_NGA_11512.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/40/William_Blake%2C_The_Infant_Hercules_Throttling_the_Serpents%2C_1790-1793%2C_NGA_11512.jpg/1280px-William_Blake%2C_The_Infant_Hercules_Throttling_the_Serpents%2C_1790-1793%2C_NGA_11512.jpg",
      width: 2953,
      height: 4000,
    },
    {
      title: "William Blake, The Last Judgment, c. 1809, NGA 11525.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/ce/William_Blake%2C_The_Last_Judgment%2C_c._1809%2C_NGA_11525.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/ce/William_Blake%2C_The_Last_Judgment%2C_c._1809%2C_NGA_11525.jpg/1280px-William_Blake%2C_The_Last_Judgment%2C_c._1809%2C_NGA_11525.jpg",
      width: 3051,
      height: 4000,
    },
    {
      title: "William Blake, The Vision of the Lord of Spirits, c. 1824-1827, NGA 30676.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b4/William_Blake%2C_The_Vision_of_the_Lord_of_Spirits%2C_c._1824-1827%2C_NGA_30676.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b4/William_Blake%2C_The_Vision_of_the_Lord_of_Spirits%2C_c._1824-1827%2C_NGA_30676.jpg/1280px-William_Blake%2C_The_Vision_of_the_Lord_of_Spirits%2C_c._1824-1827%2C_NGA_30676.jpg",
      width: 2800,
      height: 4000,
    },
    {
      title: "William Blake, Time's Triple Bow (recto), c. 1804-1807, NGA 11508.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cd/William_Blake%2C_Time%27s_Triple_Bow_%28recto%29%2C_c._1804-1807%2C_NGA_11508.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/William_Blake%2C_Time%27s_Triple_Bow_%28recto%29%2C_c._1804-1807%2C_NGA_11508.jpg/1280px-William_Blake%2C_Time%27s_Triple_Bow_%28recto%29%2C_c._1804-1807%2C_NGA_11508.jpg",
      width: 3178,
      height: 4000,
    },
    {
      title: "William Blake, Two Legs, probably 1805-1810, NGA 11513.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/49/William_Blake%2C_Two_Legs%2C_probably_1805-1810%2C_NGA_11513.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/49/William_Blake%2C_Two_Legs%2C_probably_1805-1810%2C_NGA_11513.jpg/1280px-William_Blake%2C_Two_Legs%2C_probably_1805-1810%2C_NGA_11513.jpg",
      width: 3283,
      height: 4000,
    },
    {
      title: "William Blake, Wat Tyler's Daughter, c. 1819, NGA 11503.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b2/William_Blake%2C_Wat_Tyler%27s_Daughter%2C_c._1819%2C_NGA_11503.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b2/William_Blake%2C_Wat_Tyler%27s_Daughter%2C_c._1819%2C_NGA_11503.jpg/1280px-William_Blake%2C_Wat_Tyler%27s_Daughter%2C_c._1819%2C_NGA_11503.jpg",
      width: 2941,
      height: 4000,
    },
    {
      title: "Blake - La Mort du mauvais homme, RF 54420, Recto.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/46/Blake_-_La_Mort_du_mauvais_homme%2C_RF_54420%2C_Recto.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/46/Blake_-_La_Mort_du_mauvais_homme%2C_RF_54420%2C_Recto.jpg",
      width: 768,
      height: 616,
    },
    {
      title: "William-Blake-Missgunst.jpg",
      artist: "William Blake",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/8d/William-Blake-Missgunst.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/8d/William-Blake-Missgunst.jpg",
      width: 500,
      height: 674,
    },
  ],
};

export const PABLO_PICASSO_EARLY__DRAWINGS: ArtistCollection = {
  artist: "Pablo Picasso (early)",
  deathYear: 1973,
  publicDomainStatus: "Public domain - artist died 1973 (>53 years ago)",
  works: [
    {
      title: "HK Kln West Austin Road West West Kowloon Cultural District M+ Administration Building Phillips Auction preview exhibition Pablo Picasso's artworks March 2025 R12S 01.jpg",
      artist: "Pablo Picasso (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/90/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_01.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_01.jpg/1280px-thumbnail.jpg",
      width: 3000,
      height: 4000,
    },
    {
      title: "HK Kln West Austin Road West West Kowloon Cultural District M+ Administration Building Phillips Auction preview exhibition Pablo Picasso's artworks March 2025 R12S 03.jpg",
      artist: "Pablo Picasso (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/56/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_03.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/56/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_03.jpg/1280px-thumbnail.jpg",
      width: 4000,
      height: 3000,
    },
    {
      title: "HK Kln West Austin Road West West Kowloon Cultural District M+ Administration Building Phillips Auction preview exhibition Pablo Picasso's artworks March 2025 R12S 02.jpg",
      artist: "Pablo Picasso (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f8/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_02.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f8/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_02.jpg/1280px-thumbnail.jpg",
      width: 3000,
      height: 4000,
    },
    {
      title: "HK Kln West Austin Road West West Kowloon Cultural District M+ Administration Building Phillips Auction preview exhibition Pablo Picasso's artworks March 2025 R12S 06.jpg",
      artist: "Pablo Picasso (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/71/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_06.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/71/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_06.jpg/1280px-thumbnail.jpg",
      width: 4000,
      height: 3000,
    },
    {
      title: "HK Kln West Austin Road West West Kowloon Cultural District M+ Administration Building Phillips Auction preview exhibition Pablo Picasso's artworks March 2025 R12S 08.jpg",
      artist: "Pablo Picasso (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/42/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_08.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/42/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_08.jpg/1280px-thumbnail.jpg",
      width: 4000,
      height: 3000,
    },
    {
      title: "HK Kln West Austin Road West West Kowloon Cultural District M+ Administration Building Phillips Auction preview exhibition Pablo Picasso's artworks March 2025 R12S 12.jpg",
      artist: "Pablo Picasso (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3b/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_12.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3b/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_12.jpg/1280px-thumbnail.jpg",
      width: 4000,
      height: 3000,
    },
    {
      title: "HK Kln West Austin Road West West Kowloon Cultural District M+ Administration Building Phillips Auction preview exhibition Pablo Picasso's artworks March 2025 R12S 14.jpg",
      artist: "Pablo Picasso (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a3/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_14.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a3/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_14.jpg/1280px-thumbnail.jpg",
      width: 4000,
      height: 3000,
    },
    {
      title: "HK Kln West Austin Road West West Kowloon Cultural District M+ Administration Building Phillips Auction preview exhibition Pablo Picasso's artworks March 2025 R12S 15.jpg",
      artist: "Pablo Picasso (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/02/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_15.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/02/HK_Kln_West_Austin_Road_West_West_Kowloon_Cultural_District_M%2B_Administration_Building_Phillips_Auction_preview_exhibition_Pablo_Picasso%27s_artworks_March_2025_R12S_15.jpg/1280px-thumbnail.jpg",
      width: 4000,
      height: 3000,
    },
    {
      title: "HK Central The Henderson Christie's Auction preview March 2025 R12S 111.jpg",
      artist: "Pablo Picasso (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/fc/HK_Central_The_Henderson_Christie%27s_Auction_preview_March_2025_R12S_111.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/HK_Central_The_Henderson_Christie%27s_Auction_preview_March_2025_R12S_111.jpg/1280px-HK_Central_The_Henderson_Christie%27s_Auction_preview_March_2025_R12S_111.jpg",
      width: 4000,
      height: 3000,
    },
  ],
};

export const HENRI_MATISSE_EARLY__DRAWINGS: ArtistCollection = {
  artist: "Henri Matisse (early)",
  deathYear: 1954,
  publicDomainStatus: "Public domain - artist died 1954 (>72 years ago)",
  works: [
    {
      title: "Costumes dHenri Matisse pour le chant du rossignol (les Ballets russes, Opéra) (4550388400).jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f9/Costumes_dHenri_Matisse_pour_le_chant_du_rossignol_%28les_Ballets_russes%2C_Op%C3%A9ra%29_%284550388400%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Costumes_dHenri_Matisse_pour_le_chant_du_rossignol_%28les_Ballets_russes%2C_Op%C3%A9ra%29_%284550388400%29.jpg/1280px-Costumes_dHenri_Matisse_pour_le_chant_du_rossignol_%28les_Ballets_russes%2C_Op%C3%A9ra%29_%284550388400%29.jpg",
      width: 1600,
      height: 772,
    },
    {
      title: "Henri Matisse Odalisque 1931.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/0e/Henri_Matisse_Odalisque_1931.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0e/Henri_Matisse_Odalisque_1931.jpg/1280px-Henri_Matisse_Odalisque_1931.jpg",
      width: 5457,
      height: 3992,
    },
    {
      title: "Henri matisse, nudo sdraiato ornamentale, 1927.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/52/Henri_matisse%2C_nudo_sdraiato_ornamentale%2C_1927.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/52/Henri_matisse%2C_nudo_sdraiato_ornamentale%2C_1927.jpg/1280px-Henri_matisse%2C_nudo_sdraiato_ornamentale%2C_1927.jpg",
      width: 2205,
      height: 1932,
    },
    {
      title: "Henri matisse, donna con cappello, 1939.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b7/Henri_matisse%2C_donna_con_cappello%2C_1939.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/Henri_matisse%2C_donna_con_cappello%2C_1939.jpg/1280px-Henri_matisse%2C_donna_con_cappello%2C_1939.jpg",
      width: 2888,
      height: 3776,
    },
    {
      title: "Henri matisse, studio per lussuria I, 1907, carboncino su carta.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/25/Henri_matisse%2C_studio_per_lussuria_I%2C_1907%2C_carboncino_su_carta.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/25/Henri_matisse%2C_studio_per_lussuria_I%2C_1907%2C_carboncino_su_carta.jpg/1280px-Henri_matisse%2C_studio_per_lussuria_I%2C_1907%2C_carboncino_su_carta.jpg",
      width: 1820,
      height: 2807,
    },
    {
      title: "Marguerite, drawing by Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/33/Marguerite%2C_drawing_by_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/33/Marguerite%2C_drawing_by_Henri_Matisse.jpg/1280px-Marguerite%2C_drawing_by_Henri_Matisse.jpg",
      width: 2152,
      height: 2839,
    },
    {
      title: "Marguerite écrivant by Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/81/Marguerite_%C3%A9crivant_by_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/Marguerite_%C3%A9crivant_by_Henri_Matisse.jpg/1280px-Marguerite_%C3%A9crivant_by_Henri_Matisse.jpg",
      width: 2322,
      height: 2808,
    },
    {
      title: "Madame Raynal by Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b0/Madame_Raynal_by_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b0/Madame_Raynal_by_Henri_Matisse.jpg/1280px-Madame_Raynal_by_Henri_Matisse.jpg",
      width: 2495,
      height: 3313,
    },
    {
      title: "Marguerite les yeux baissés par Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/01/Marguerite_les_yeux_baiss%C3%A9s_par_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Marguerite_les_yeux_baiss%C3%A9s_par_Henri_Matisse.jpg/1280px-Marguerite_les_yeux_baiss%C3%A9s_par_Henri_Matisse.jpg",
      width: 2022,
      height: 2631,
    },
    {
      title: "Henri Matisse Tête de femme 1918.jpeg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d6/Henri_Matisse_T%C3%AAte_de_femme_1918.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/d6/Henri_Matisse_T%C3%AAte_de_femme_1918.jpeg",
      width: 800,
      height: 1083,
    },
    {
      title: "Henri Matisse Nu allongée 1921.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6a/Henri_Matisse_Nu_allong%C3%A9e_1921.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/Henri_Matisse_Nu_allong%C3%A9e_1921.jpg/1280px-Henri_Matisse_Nu_allong%C3%A9e_1921.jpg",
      width: 2048,
      height: 1487,
    },
    {
      title: "Henri Matisse Femme assise, chaise 1927.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/a1/Henri_Matisse_Femme_assise%2C_chaise_1927.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a1/Henri_Matisse_Femme_assise%2C_chaise_1927.jpg/1280px-Henri_Matisse_Femme_assise%2C_chaise_1927.jpg",
      width: 2048,
      height: 1493,
    },
    {
      title: "Henri Matisse Le Modèle (Henriette) 1922.jpeg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/01/Henri_Matisse_Le_Mod%C3%A8le_%28Henriette%29_1922.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/01/Henri_Matisse_Le_Mod%C3%A8le_%28Henriette%29_1922.jpeg/1280px-Henri_Matisse_Le_Mod%C3%A8le_%28Henriette%29_1922.jpeg",
      width: 2048,
      height: 3096,
    },
    {
      title: "Henri Matisse La pensée 1949.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Henri_Matisse_La_pens%C3%A9e_1949.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4b/Henri_Matisse_La_pens%C3%A9e_1949.jpg/1280px-Henri_Matisse_La_pens%C3%A9e_1949.jpg",
      width: 2618,
      height: 3341,
    },
    {
      title: "Marguerite by Henri Matisse (drawing).jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/62/Marguerite_by_Henri_Matisse_%28drawing%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Marguerite_by_Henri_Matisse_%28drawing%29.jpg/1280px-Marguerite_by_Henri_Matisse_%28drawing%29.jpg",
      width: 1698,
      height: 3612,
    },
    {
      title: "Marguerite 1921 drawing by Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d9/Marguerite_1921_drawing_by_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d9/Marguerite_1921_drawing_by_Henri_Matisse.jpg/1280px-Marguerite_1921_drawing_by_Henri_Matisse.jpg",
      width: 2204,
      height: 3104,
    },
    {
      title: "Marguerite (1916 drawing).jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Marguerite_%281916_drawing%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Marguerite_%281916_drawing%29.jpg/1280px-Marguerite_%281916_drawing%29.jpg",
      width: 2236,
      height: 3522,
    },
    {
      title: "Marguerite (1918) by Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/67/Marguerite_%281918%29_by_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Marguerite_%281918%29_by_Henri_Matisse.jpg/1280px-Marguerite_%281918%29_by_Henri_Matisse.jpg",
      width: 2439,
      height: 3128,
    },
    {
      title: "Marguerite (1920) by Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b9/Marguerite_%281920%29_by_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/Marguerite_%281920%29_by_Henri_Matisse.jpg/1280px-Marguerite_%281920%29_by_Henri_Matisse.jpg",
      width: 2025,
      height: 2998,
    },
    {
      title: "Portrait de femme, Henri Matisse (musée Maillol) (2959726870).jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/45/Portrait_de_femme%2C_Henri_Matisse_%28mus%C3%A9e_Maillol%29_%282959726870%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/45/Portrait_de_femme%2C_Henri_Matisse_%28mus%C3%A9e_Maillol%29_%282959726870%29.jpg",
      width: 653,
      height: 938,
    },
    {
      title: "Naakte vrouw, RP-F-2005-107-230-6.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/83/Naakte_vrouw%2C_RP-F-2005-107-230-6.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Naakte_vrouw%2C_RP-F-2005-107-230-6.jpg/1280px-Naakte_vrouw%2C_RP-F-2005-107-230-6.jpg",
      width: 3260,
      height: 4288,
    },
    {
      title: "Naakte man op de rug gezien, RP-F-2005-107-230-7.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/62/Naakte_man_op_de_rug_gezien%2C_RP-F-2005-107-230-7.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/62/Naakte_man_op_de_rug_gezien%2C_RP-F-2005-107-230-7.jpg/1280px-Naakte_man_op_de_rug_gezien%2C_RP-F-2005-107-230-7.jpg",
      width: 4266,
      height: 3284,
    },
    {
      title: "Prokofiev as drawn by Henri Matisse 1921 - Gallica.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/49/Prokofiev_as_drawn_by_Henri_Matisse_1921_-_Gallica.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/49/Prokofiev_as_drawn_by_Henri_Matisse_1921_-_Gallica.jpg",
      width: 641,
      height: 880,
    },
    {
      title: "Portrait de Georges Duthuit par Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c9/Portrait_de_Georges_Duthuit_par_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Portrait_de_Georges_Duthuit_par_Henri_Matisse.jpg/1280px-Portrait_de_Georges_Duthuit_par_Henri_Matisse.jpg",
      width: 2178,
      height: 3703,
    },
    {
      title: "Portrait de Claude drawing by Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b3/Portrait_de_Claude_drawing_by_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b3/Portrait_de_Claude_drawing_by_Henri_Matisse.jpg/1280px-Portrait_de_Claude_drawing_by_Henri_Matisse.jpg",
      width: 2243,
      height: 3073,
    },
    {
      title: "Portrait de marguerite by Henri Matisse.jpg",
      artist: "Henri Matisse (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1d/Portrait_de_marguerite_by_Henri_Matisse.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1d/Portrait_de_marguerite_by_Henri_Matisse.jpg/1280px-Portrait_de_marguerite_by_Henri_Matisse.jpg",
      width: 3489,
      height: 2669,
    },
  ],
};

export const AMEDEO_MODIGLIANI_DRAWINGS: ArtistCollection = {
  artist: "Amedeo Modigliani",
  deathYear: 1920,
  publicDomainStatus: "Public domain - artist died 1920 (>106 years ago)",
  works: [
    {
      title: "Amedeo Modigliani Ritratto di Donna Rossa.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/be/Amedeo_Modigliani_Ritratto_di_Donna_Rossa.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/b/be/Amedeo_Modigliani_Ritratto_di_Donna_Rossa.jpg",
      width: 420,
      height: 650,
    },
    {
      title: "A.modigliani 005.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/83/A.modigliani_005.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/83/A.modigliani_005.jpg",
      width: 778,
      height: 1450,
    },
    {
      title: "Modigliani Zeichnung Kopf.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Modigliani_Zeichnung_Kopf.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Modigliani_Zeichnung_Kopf.jpg",
      width: 500,
      height: 909,
    },
    {
      title: "Akt zeichnung 1.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/96/Akt_zeichnung_1.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/9/96/Akt_zeichnung_1.jpg",
      width: 500,
      height: 816,
    },
    {
      title: "Karyatide in rosa.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/70/Karyatide_in_rosa.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/70/Karyatide_in_rosa.jpg",
      width: 500,
      height: 628,
    },
    {
      title: "Amedeo modigliani - retrato de jovem viúva MCM-RJ.JPG",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/09/Amedeo_modigliani_-_retrato_de_jovem_vi%C3%BAva_MCM-RJ.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/0/09/Amedeo_modigliani_-_retrato_de_jovem_vi%C3%BAva_MCM-RJ.JPG",
      width: 410,
      height: 640,
    },
    {
      title: "Amedeo Modigliani.Danseres.JPG",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/54/Amedeo_Modigliani.Danseres.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/54/Amedeo_Modigliani.Danseres.JPG/1280px-Amedeo_Modigliani.Danseres.JPG",
      width: 1285,
      height: 1773,
    },
    {
      title: "Imagem147 Modigliani, retrato de Soror Mariana, Alcoforado, Beja.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/8e/Imagem147_Modigliani%2C_retrato_de_Soror_Mariana%2C_Alcoforado%2C_Beja.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/8e/Imagem147_Modigliani%2C_retrato_de_Soror_Mariana%2C_Alcoforado%2C_Beja.jpg",
      width: 581,
      height: 822,
    },
    {
      title: "'Caryatid', graphite drawing by Amedeo Modigliani, c. 1909-1914.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4f/%27Caryatid%27%2C_graphite_drawing_by_Amedeo_Modigliani%2C_c._1909-1914.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/%27Caryatid%27%2C_graphite_drawing_by_Amedeo_Modigliani%2C_c._1909-1914.jpg/1242px-%27Caryatid%27%2C_graphite_drawing_by_Amedeo_Modigliani%2C_c._1909-1914.jpg",
      width: 1242,
      height: 2055,
    },
    {
      title: "Amedeo Modigliani004.JPG",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e5/Amedeo_Modigliani004.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/e5/Amedeo_Modigliani004.JPG",
      width: 969,
      height: 1401,
    },
    {
      title: "Brooklyn Museum - Portrait of Adolphe Basler - Amedeo Modigliani.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b1/Brooklyn_Museum_-_Portrait_of_Adolphe_Basler_-_Amedeo_Modigliani.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/b/b1/Brooklyn_Museum_-_Portrait_of_Adolphe_Basler_-_Amedeo_Modigliani.jpg",
      width: 570,
      height: 768,
    },
    {
      title: "Brancusi Modigliani 1909.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c5/Brancusi_Modigliani_1909.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c5/Brancusi_Modigliani_1909.jpg",
      width: 424,
      height: 707,
    },
    {
      title: "Amedeo Modigliani 016.JPG",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/80/Amedeo_Modigliani_016.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/80/Amedeo_Modigliani_016.JPG",
      width: 729,
      height: 1935,
    },
    {
      title: "Amedeo Modigliani - Caryatid - Google Art Project.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/58/Amedeo_Modigliani_-_Caryatid_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/58/Amedeo_Modigliani_-_Caryatid_-_Google_Art_Project.jpg/1280px-Amedeo_Modigliani_-_Caryatid_-_Google_Art_Project.jpg",
      width: 4265,
      height: 5542,
    },
    {
      title: "Amedeo Modigliani - Untitled (Portrait of Madame Zborowska) - Google Art Project.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e5/Amedeo_Modigliani_-_Untitled_%28Portrait_of_Madame_Zborowska%29_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e5/Amedeo_Modigliani_-_Untitled_%28Portrait_of_Madame_Zborowska%29_-_Google_Art_Project.jpg/1280px-Amedeo_Modigliani_-_Untitled_%28Portrait_of_Madame_Zborowska%29_-_Google_Art_Project.jpg",
      width: 2362,
      height: 3155,
    },
    {
      title: "Amedeo Modigliani Purgatorius animae 1916.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/79/Amedeo_Modigliani_Purgatorius_animae_1916.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/79/Amedeo_Modigliani_Purgatorius_animae_1916.jpg/1280px-Amedeo_Modigliani_Purgatorius_animae_1916.jpg",
      width: 2849,
      height: 4783,
    },
    {
      title: "Amedeo Modigliani - Nude - Google Art Project.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ab/Amedeo_Modigliani_-_Nude_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ab/Amedeo_Modigliani_-_Nude_-_Google_Art_Project.jpg/1280px-Amedeo_Modigliani_-_Nude_-_Google_Art_Project.jpg",
      width: 4001,
      height: 3009,
    },
    {
      title: "Amedeo Modigliani - Portrait of Adolphe Basler - Google Art Project.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4c/Amedeo_Modigliani_-_Portrait_of_Adolphe_Basler_-_Google_Art_Project.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Amedeo_Modigliani_-_Portrait_of_Adolphe_Basler_-_Google_Art_Project.jpg/1280px-Amedeo_Modigliani_-_Portrait_of_Adolphe_Basler_-_Google_Art_Project.jpg",
      width: 2436,
      height: 4001,
    },
    {
      title: "Amedeo Modigliani - Caryatid.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/55/Amedeo_Modigliani_-_Caryatid.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/55/Amedeo_Modigliani_-_Caryatid.jpg/1280px-Amedeo_Modigliani_-_Caryatid.jpg",
      width: 2328,
      height: 3053,
    },
    {
      title: "Amedeo Modigliani - Retrato (Manuel Ortiz de Zárate).jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/42/Amedeo_Modigliani_-_Retrato_%28Manuel_Ortiz_de_Z%C3%A1rate%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/42/Amedeo_Modigliani_-_Retrato_%28Manuel_Ortiz_de_Z%C3%A1rate%29.jpg",
      width: 572,
      height: 750,
    },
    {
      title: "Modigliani - Tête.JPG",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4d/Modigliani_-_T%C3%AAte.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/4d/Modigliani_-_T%C3%AAte.JPG/1280px-Modigliani_-_T%C3%AAte.JPG",
      width: 1719,
      height: 1908,
    },
    {
      title: "GUGG Beatrice Hastings.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3e/GUGG_Beatrice_Hastings.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3e/GUGG_Beatrice_Hastings.jpg/1280px-GUGG_Beatrice_Hastings.jpg",
      width: 2071,
      height: 3000,
    },
    {
      title: "Jeune femme en buste, Amadeo Modigliani - Musée d'art et d'histoire du Judaïsme.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/40/Jeune_femme_en_buste%2C_Amadeo_Modigliani_-_Mus%C3%A9e_d%27art_et_d%27histoire_du_Juda%C3%AFsme.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/40/Jeune_femme_en_buste%2C_Amadeo_Modigliani_-_Mus%C3%A9e_d%27art_et_d%27histoire_du_Juda%C3%AFsme.jpg",
      width: 561,
      height: 800,
    },
    {
      title: "1915, Modigliani, Mateo.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/39/1915%2C_Modigliani%2C_Mateo.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/39/1915%2C_Modigliani%2C_Mateo.jpg/1280px-1915%2C_Modigliani%2C_Mateo.jpg",
      width: 1287,
      height: 2000,
    },
    {
      title: "Amedeo Modigliani - Guillaume Apollinaire 1915.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/f2/Amedeo_Modigliani_-_Guillaume_Apollinaire_1915.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Amedeo_Modigliani_-_Guillaume_Apollinaire_1915.jpg/1280px-Amedeo_Modigliani_-_Guillaume_Apollinaire_1915.jpg",
      width: 1545,
      height: 2180,
    },
    {
      title: "Amedeo modigliani, madame hastings in poltrona, 1915-16. matita su carta.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/aa/Amedeo_modigliani%2C_madame_hastings_in_poltrona%2C_1915-16._matita_su_carta.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/aa/Amedeo_modigliani%2C_madame_hastings_in_poltrona%2C_1915-16._matita_su_carta.jpg/1280px-Amedeo_modigliani%2C_madame_hastings_in_poltrona%2C_1915-16._matita_su_carta.jpg",
      width: 1988,
      height: 2552,
    },
    {
      title: "Drawing, Child (CH 18488617).jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/5f/Drawing%2C_Child_%28CH_18488617%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/5f/Drawing%2C_Child_%28CH_18488617%29.jpg/1280px-Drawing%2C_Child_%28CH_18488617%29.jpg",
      width: 3229,
      height: 4096,
    },
    {
      title: "Drawing, Child (CH 18488617-2).jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7c/Drawing%2C_Child_%28CH_18488617-2%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7c/Drawing%2C_Child_%28CH_18488617-2%29.jpg/1280px-Drawing%2C_Child_%28CH_18488617-2%29.jpg",
      width: 2886,
      height: 3787,
    },
    {
      title: "AmedeoModigliani-1919-Portrait of Foujita.png",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c7/AmedeoModigliani-1919-Portrait_of_Foujita.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c7/AmedeoModigliani-1919-Portrait_of_Foujita.png",
      width: 1077,
      height: 2624,
    },
    {
      title: "Amedeo Modigliani - Hermaphrodite - circa 1910-1911 - 001.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/67/Amedeo_Modigliani_-_Hermaphrodite_-_circa_1910-1911_-_001.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/67/Amedeo_Modigliani_-_Hermaphrodite_-_circa_1910-1911_-_001.jpg/1280px-Amedeo_Modigliani_-_Hermaphrodite_-_circa_1910-1911_-_001.jpg",
      width: 2362,
      height: 3916,
    },
    {
      title: "GNAM WLM18 118.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/d5/GNAM_WLM18_118.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/GNAM_WLM18_118.jpg/1280px-GNAM_WLM18_118.jpg",
      width: 4096,
      height: 2304,
    },
    {
      title: "FEMME À LA ROBE DÉCOLLETÉE ALLONGÉE SUR UN LIT.PNG",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/9/98/FEMME_%C3%80_LA_ROBE_D%C3%89COLLET%C3%89E_ALLONG%C3%89E_SUR_UN_LIT.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/9/98/FEMME_%C3%80_LA_ROBE_D%C3%89COLLET%C3%89E_ALLONG%C3%89E_SUR_UN_LIT.PNG",
      width: 940,
      height: 582,
    },
    {
      title: "CARYATIDE AU CHANDELIERS.PNG",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ae/CARYATIDE_AU_CHANDELIERS.PNG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/a/ae/CARYATIDE_AU_CHANDELIERS.PNG",
      width: 404,
      height: 670,
    },
    {
      title: "Anna Akhmatova.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Anna_Akhmatova.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/cc/Anna_Akhmatova.jpg",
      width: 477,
      height: 805,
    },
    {
      title: "Amedeo modigliani, il gendarme, 1913-15 (gnam).jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7a/Amedeo_modigliani%2C_il_gendarme%2C_1913-15_%28gnam%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7a/Amedeo_modigliani%2C_il_gendarme%2C_1913-15_%28gnam%29.jpg/1280px-Amedeo_modigliani%2C_il_gendarme%2C_1913-15_%28gnam%29.jpg",
      width: 2244,
      height: 3630,
    },
    {
      title: "Amedeo modigliani, uno zuavo, 1913-15 (gnam).jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/61/Amedeo_modigliani%2C_uno_zuavo%2C_1913-15_%28gnam%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/6/61/Amedeo_modigliani%2C_uno_zuavo%2C_1913-15_%28gnam%29.jpg/1280px-Amedeo_modigliani%2C_uno_zuavo%2C_1913-15_%28gnam%29.jpg",
      width: 2376,
      height: 3762,
    },
    {
      title: "Amedeo modigliani, il giovane pellegrino (charles douglas), 1913-15 (gnam).jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/51/Amedeo_modigliani%2C_il_giovane_pellegrino_%28charles_douglas%29%2C_1913-15_%28gnam%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/Amedeo_modigliani%2C_il_giovane_pellegrino_%28charles_douglas%29%2C_1913-15_%28gnam%29.jpg/1280px-Amedeo_modigliani%2C_il_giovane_pellegrino_%28charles_douglas%29%2C_1913-15_%28gnam%29.jpg",
      width: 2706,
      height: 4254,
    },
    {
      title: "High-macm-8-ma.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/81/High-macm-8-ma.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/High-macm-8-ma.jpg/1280px-High-macm-8-ma.jpg",
      width: 3968,
      height: 5114,
    },
    {
      title: "Gorvel by Modigliani.png",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3f/Gorvel_by_Modigliani.png",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/3f/Gorvel_by_Modigliani.png",
      width: 806,
      height: 1083,
    },
    {
      title: "Ada Karinthy by Modigliani.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/b/b8/Ada_Karinthy_by_Modigliani.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/b/b8/Ada_Karinthy_by_Modigliani.jpg",
      width: 875,
      height: 1200,
    },
    {
      title: "Amedeo Modigliani “Femme Assise Accoudee (à la bague)”, 1916.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/d/dd/Amedeo_Modigliani_%E2%80%9CFemme_Assise_Accoudee_%28%C3%A0_la_bague%29%E2%80%9D%2C_1916.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/d/dd/Amedeo_Modigliani_%E2%80%9CFemme_Assise_Accoudee_%28%C3%A0_la_bague%29%E2%80%9D%2C_1916.jpg",
      width: 821,
      height: 1170,
    },
    {
      title: "Amedeo Modigliani, Portræt af en siddende ung pige med hænderne i skødet Annie Bjarne, 1919, KKS1959-24, Statens Museum for Kunst.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/59/Amedeo_Modigliani%2C_Portr%C3%A6t_af_en_siddende_ung_pige_med_h%C3%A6nderne_i_sk%C3%B8det_Annie_Bjarne%2C_1919%2C_KKS1959-24%2C_Statens_Museum_for_Kunst.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/5/59/Amedeo_Modigliani%2C_Portr%C3%A6t_af_en_siddende_ung_pige_med_h%C3%A6nderne_i_sk%C3%B8det_Annie_Bjarne%2C_1919%2C_KKS1959-24%2C_Statens_Museum_for_Kunst.jpg",
      width: 843,
      height: 1600,
    },
    {
      title: "Amedeo Modigliani, Portræt af friherreinde Thora Hamilton, født Klinckowström, tidligere gift med maleren Nils Dardel, 1919, KKS1965-190, Statens Museum for Kunst.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/34/Amedeo_Modigliani%2C_Portr%C3%A6t_af_friherreinde_Thora_Hamilton%2C_f%C3%B8dt_Klinckowstr%C3%B6m%2C_tidligere_gift_med_maleren_Nils_Dardel%2C_1919%2C_KKS1965-190%2C_Statens_Museum_for_Kunst.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/34/Amedeo_Modigliani%2C_Portr%C3%A6t_af_friherreinde_Thora_Hamilton%2C_f%C3%B8dt_Klinckowstr%C3%B6m%2C_tidligere_gift_med_maleren_Nils_Dardel%2C_1919%2C_KKS1965-190%2C_Statens_Museum_for_Kunst.jpg/1280px-thumbnail.jpg",
      width: 4784,
      height: 8036,
    },
    {
      title: "Amedeo Modigliani, Portræt af friherreinde Thora Hamilton, født Klinckowström, tidligere gift med maleren Nils Dardel, , KKS1959-14, Statens Museum for Kunst.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/3a/Amedeo_Modigliani%2C_Portr%C3%A6t_af_friherreinde_Thora_Hamilton%2C_f%C3%B8dt_Klinckowstr%C3%B6m%2C_tidligere_gift_med_maleren_Nils_Dardel%2C_%2C_KKS1959-14%2C_Statens_Museum_for_Kunst.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Amedeo_Modigliani%2C_Portr%C3%A6t_af_friherreinde_Thora_Hamilton%2C_f%C3%B8dt_Klinckowstr%C3%B6m%2C_tidligere_gift_med_maleren_Nils_Dardel%2C_%2C_KKS1959-14%2C_Statens_Museum_for_Kunst.jpg/1280px-thumbnail.jpg",
      width: 3729,
      height: 8289,
    },
    {
      title: "Amedeo Modigliani, Portræt af en siddende ung pige Knæbillede, hovedet mod venstre, , KKShm1976-776, Statens Museum for Kunst.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/67/Amedeo_Modigliani%2C_Portr%C3%A6t_af_en_siddende_ung_pige_Kn%C3%A6billede%2C_hovedet_mod_venstre%2C_%2C_KKShm1976-776%2C_Statens_Museum_for_Kunst.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/67/Amedeo_Modigliani%2C_Portr%C3%A6t_af_en_siddende_ung_pige_Kn%C3%A6billede%2C_hovedet_mod_venstre%2C_%2C_KKShm1976-776%2C_Statens_Museum_for_Kunst.jpg",
      width: 1072,
      height: 1600,
    },
    {
      title: "Mother and Child by Amadeo Modigliani.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Mother_and_Child_by_Amadeo_Modigliani.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Mother_and_Child_by_Amadeo_Modigliani.jpg",
      width: 473,
      height: 1024,
    },
    {
      title: "Amedeo Modigliani Femme nue de face.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1e/Amedeo_Modigliani_Femme_nue_de_face.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Amedeo_Modigliani_Femme_nue_de_face.jpg/1280px-Amedeo_Modigliani_Femme_nue_de_face.jpg",
      width: 2048,
      height: 3309,
    },
    {
      title: "Amedeo Modigliani.Naakt.JPG",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/26/Amedeo_Modigliani.Naakt.JPG",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/26/Amedeo_Modigliani.Naakt.JPG/1280px-Amedeo_Modigliani.Naakt.JPG",
      width: 1745,
      height: 2561,
    },
    {
      title: "Seated Nude with Raised Arms MET sf1984.548.1.jpeg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/1/1f/Seated_Nude_with_Raised_Arms_MET_sf1984.548.1.jpeg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/1/1f/Seated_Nude_with_Raised_Arms_MET_sf1984.548.1.jpeg",
      width: 460,
      height: 660,
    },
    {
      title: "Portret van Jean Cocteau, RP-T-1970-6.jpg",
      artist: "Amedeo Modigliani",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/27/Portret_van_Jean_Cocteau%2C_RP-T-1970-6.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Portret_van_Jean_Cocteau%2C_RP-T-1970-6.jpg/1280px-Portret_van_Jean_Cocteau%2C_RP-T-1970-6.jpg",
      width: 3720,
      height: 5842,
    },
  ],
};

export const MAN_RAY_EARLY__DRAWINGS: ArtistCollection = {
  artist: "Man Ray (early)",
  deathYear: 1976,
  publicDomainStatus: "Public domain - artist died 1976 (>50 years ago)",
  works: [
    {
      title: "William Zorach-by-Man Ray.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/4/48/William_Zorach-by-Man_Ray.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/William_Zorach-by-Man_Ray.jpg/1280px-William_Zorach-by-Man_Ray.jpg",
      width: 4303,
      height: 5332,
    },
    {
      title: "Arnold schönberg man ray.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7e/Arnold_sch%C3%B6nberg_man_ray.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/7/7e/Arnold_sch%C3%B6nberg_man_ray.jpg",
      width: 1163,
      height: 1540,
    },
    {
      title: "Erik Satie.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/05/Erik_Satie.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/0/05/Erik_Satie.jpg",
      width: 473,
      height: 605,
    },
    {
      title: "Rrose-Sélavy11.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/e/e8/Rrose-S%C3%A9lavy11.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/e/e8/Rrose-S%C3%A9lavy11.jpg",
      width: 940,
      height: 1170,
    },
    {
      title: "Portrait-of-rose-sélavy-1921.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/77/Portrait-of-rose-s%C3%A9lavy-1921.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Portrait-of-rose-s%C3%A9lavy-1921.jpg/1280px-Portrait-of-rose-s%C3%A9lavy-1921.jpg",
      width: 2211,
      height: 2661,
    },
    {
      title: "Iris tree 1.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/25/Iris_tree_1.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/2/25/Iris_tree_1.jpg",
      width: 597,
      height: 800,
    },
    {
      title: "H.D. in Tendencies in Modern American Poetry, 1917.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/c/c4/H.D._in_Tendencies_in_Modern_American_Poetry%2C_1917.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/c/c4/H.D._in_Tendencies_in_Modern_American_Poetry%2C_1917.jpg",
      width: 491,
      height: 753,
    },
    {
      title: "H.D. in Tendencies in Modern American Poetry, 1917 - cropped.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/0/0c/H.D._in_Tendencies_in_Modern_American_Poetry%2C_1917_-_cropped.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/0/0c/H.D._in_Tendencies_in_Modern_American_Poetry%2C_1917_-_cropped.jpg",
      width: 418,
      height: 572,
    },
    {
      title: "James Joyce - Sep 1922 Shadowland.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/6/6c/James_Joyce_-_Sep_1922_Shadowland.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/6/6c/James_Joyce_-_Sep_1922_Shadowland.jpg",
      width: 595,
      height: 810,
    },
    {
      title: "Hilda Doolittle.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/2/20/Hilda_Doolittle.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/2/20/Hilda_Doolittle.jpg",
      width: 873,
      height: 1187,
    },
    {
      title: "Barbette 1925.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/5/51/Barbette_1925.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/5/51/Barbette_1925.jpg",
      width: 529,
      height: 470,
    },
    {
      title: "Alice B. Toklas and Gertrude Stein, 1922, Man Ray.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/a/ac/Alice_B._Toklas_and_Gertrude_Stein%2C_1922%2C_Man_Ray.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Alice_B._Toklas_and_Gertrude_Stein%2C_1922%2C_Man_Ray.jpg/1280px-Alice_B._Toklas_and_Gertrude_Stein%2C_1922%2C_Man_Ray.jpg",
      width: 1968,
      height: 1570,
    },
    {
      title: "Man Ray, 1923, Bryher.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/85/Man_Ray%2C_1923%2C_Bryher.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/85/Man_Ray%2C_1923%2C_Bryher.jpg",
      width: 437,
      height: 616,
    },
    {
      title: "May Ray Kiki with African mask.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/7e/May_Ray_Kiki_with_African_mask.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/May_Ray_Kiki_with_African_mask.jpg/1280px-May_Ray_Kiki_with_African_mask.jpg",
      width: 1280,
      height: 972,
    },
    {
      title: "Catherine Hessling by Man Ray in Cinegraphie Septembre 1927.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/3/33/Catherine_Hessling_by_Man_Ray_in_Cinegraphie_Septembre_1927.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/3/33/Catherine_Hessling_by_Man_Ray_in_Cinegraphie_Septembre_1927.jpg",
      width: 695,
      height: 925,
    },
    {
      title: "阿诺德·勋伯格肖像.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/f/fe/%E9%98%BF%E8%AF%BA%E5%BE%B7%C2%B7%E5%8B%8B%E4%BC%AF%E6%A0%BC%E8%82%96%E5%83%8F.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/f/fe/%E9%98%BF%E8%AF%BA%E5%BE%B7%C2%B7%E5%8B%8B%E4%BC%AF%E6%A0%BC%E8%82%96%E5%83%8F.jpg",
      width: 843,
      height: 1069,
    },
    {
      title: "Gadeau (Gift), gelatin silver print by Man Ray, 1921, private collection.jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/7/78/Gadeau_%28Gift%29%2C_gelatin_silver_print_by_Man_Ray%2C_1921%2C_private_collection.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/78/Gadeau_%28Gift%29%2C_gelatin_silver_print_by_Man_Ray%2C_1921%2C_private_collection.jpg/1280px-Gadeau_%28Gift%29%2C_gelatin_silver_print_by_Man_Ray%2C_1921%2C_private_collection.jpg",
      width: 1437,
      height: 1860,
    },
    {
      title: "Untitled gelatin silver print by Man Ray, from Champs délicieux (Delicious Fields).jpg",
      artist: "Man Ray (early)",
      url: "https://upload.wikimedia.org/wikipedia/commons/8/82/Untitled_gelatin_silver_print_by_Man_Ray%2C_from_Champs_d%C3%A9licieux_%28Delicious_Fields%29.jpg",
      thumbUrl: "https://upload.wikimedia.org/wikipedia/commons/8/82/Untitled_gelatin_silver_print_by_Man_Ray%2C_from_Champs_d%C3%A9licieux_%28Delicious_Fields%29.jpg",
      width: 672,
      height: 876,
    },
  ],
};

export const ALL_MASTER_DRAWINGS: ArtistCollection[] = [
  MICHELANGELO_DRAWINGS,
  LEONARDO_DA_VINCI_DRAWINGS,
  ALBRECHT_D_RER_DRAWINGS,
  REMBRANDT_DRAWINGS,
  RAPHAEL_DRAWINGS,
  PETER_PAUL_RUBENS_DRAWINGS,
  JEAN_AUGUSTE_DOMINIQUE_INGRES_DRAWINGS,
  EGON_SCHIELE_DRAWINGS,
  GUSTAV_KLIMT_DRAWINGS,
  HONOR_DAUMIER_DRAWINGS,
  EDGAR_DEGAS_DRAWINGS,
  HENRI_DE_TOULOUSE_LAUTREC_DRAWINGS,
  K_THE_KOLLWITZ_DRAWINGS,
  HOKUSAI_DRAWINGS,
  WILLIAM_BLAKE_DRAWINGS,
  PABLO_PICASSO_EARLY__DRAWINGS,
  HENRI_MATISSE_EARLY__DRAWINGS,
  AMEDEO_MODIGLIANI_DRAWINGS,
  MAN_RAY_EARLY__DRAWINGS,
];

export const FLAT_DRAWING_LIST: DrawingSource[] = ALL_MASTER_DRAWINGS.flatMap(c => c.works);
